var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _g, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstructorSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.194 306.858L480.193 113.018L467.163 105.495L441.103 120.541V159.689L423.729 149.658V91.802L410.699 84.279V62.864L384.638 47.818L362.923 60.356V150.53L345.549 140.499V114.137L332.518 106.614V41.511L302.115 23.957L276.055 39.003V119.247L254.339 131.786V81.633L232.621 69.095L215.248 79.125V120.808L197.874 110.803V67.335L180.501 57.304L163.127 67.334V43.901L145.754 33.871L106.664 56.44V132.785L93.6327 140.308L93.6337 160.369L80.6037 167.892V115.85L54.5427 100.804L19.8057 120.865V306.858H480.194Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 215.232L173.438 213.103V209.885L177.126 212.014V215.232Z",
    fill: "#FFE7C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 227.099L173.438 224.969V221.752L177.126 223.881V227.099Z",
    fill: "#FFE7C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 209.299L173.438 207.169V203.951L177.126 206.081V209.299Z",
    fill: "#FFE7C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 202.954L173.438 200.824V197.607L177.126 199.736V202.954Z",
    fill: "#FFE7C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 221.166L173.438 219.036V215.818L177.126 217.948V221.166Z",
    fill: "#FFE7C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 179.22L173.438 177.091V173.873L177.126 176.003V179.22Z",
    fill: "#FFE7C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 173.287L173.438 171.157V167.939L177.126 170.069V173.287Z",
    fill: "#FFE7C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 185.153L173.438 183.023V179.805L177.126 181.935V185.153Z",
    fill: "#FFE7C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 197.02L173.438 194.89V191.672L177.126 193.802V197.02Z",
    fill: "#FFE7C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 191.087L173.438 188.957V185.74L177.126 187.87V191.087Z",
    fill: "#FFE7C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 244.9L173.438 242.771V239.553L177.126 241.683V244.9Z",
    fill: "#FFE7C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 274.979L173.438 272.849V269.631L177.126 271.761V274.979Z",
    fill: "#FFE7C4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 262.702L173.438 260.572V257.354L177.126 259.484V262.702Z",
    fill: "#FFE7C4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 269.046L173.438 266.917V263.699L177.126 265.828V269.046Z",
    fill: "#FFE7C4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 286.845L173.438 284.716V281.498L177.126 283.628V286.845Z",
    fill: "#FFE7C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 280.913L173.438 278.783V275.566L177.126 277.695V280.913Z",
    fill: "#FFE7C4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 238.967L173.438 236.837V233.619L177.126 235.749V238.967Z",
    fill: "#FFE7C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 256.767L173.438 254.638V251.42L177.126 253.55V256.767Z",
    fill: "#FFE7C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 233.033L173.438 230.904V227.686L177.126 229.816V233.033Z",
    fill: "#FFE7C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 167.353L173.438 165.224V162.006L177.126 164.136V167.353Z",
    fill: "#FFE7C4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 250.834L173.438 248.704V245.486L177.126 247.616V250.834Z",
    fill: "#FFE7C4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 94.0423L173.438 91.9133V88.6953L177.126 90.8253V94.0423Z",
    fill: "#FFE7C4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 88.1078L173.438 85.9778V82.7598L177.126 84.8898V88.1078Z",
    fill: "#FFE7C4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 82.1751L173.438 80.0461V76.8281L177.126 78.9581V82.1751Z",
    fill: "#FFE7C4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 288.357L165.788 286.227V283.01L169.477 285.139V288.357Z",
    fill: "#FFE7C4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 282.424L165.788 280.294V277.076L169.477 279.206V282.424Z",
    fill: "#FFE7C4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 294.291L165.788 292.161V288.943L169.477 291.073V294.291Z",
    fill: "#FFE7C4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 300.224L165.788 298.094V294.877L169.477 297.006V300.224Z",
    fill: "#FFE7C4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 292.781L173.438 290.651V287.434L177.126 289.563V292.781Z",
    fill: "#FFE7C4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 111.842L173.438 109.712V106.494L177.126 108.624V111.842Z",
    fill: "#FFE7C4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 142.77L173.438 140.64V137.422L177.126 139.552V142.77Z",
    fill: "#FFE7C4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 136.425L173.438 134.296V131.078L177.126 133.208V136.425Z",
    fill: "#FFE7C4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 149.552L173.438 147.422V144.205L177.126 146.334V149.552Z",
    fill: "#FFE7C4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 129.642L173.438 127.513V124.295L177.126 126.424V129.642Z",
    fill: "#FFE7C4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 155.486L173.438 153.357V150.139L177.126 152.269V155.486Z",
    fill: "#FFE7C4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 161.419L173.438 159.289V156.072L177.126 158.201V161.419Z",
    fill: "#FFE7C4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 99.975L173.438 97.845V94.627L177.126 96.757V99.975Z",
    fill: "#FFE7C4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 105.91L173.438 103.78V100.562L177.126 102.693V105.91Z",
    fill: "#FFE7C4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 123.709L173.438 121.579V118.361L177.126 120.491V123.709Z",
    fill: "#FFE7C4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 117.775L173.438 115.645V112.428L177.126 114.558V117.775Z",
    fill: "#FFE7C4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 98.0247L109.193 95.8957V92.6777L112.881 94.8077V98.0247Z",
    fill: "#FFE7C4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 206.214L109.193 204.085V200.867L112.881 202.997V206.214Z",
    fill: "#FFE7C4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 200.281L109.193 198.151V194.934L112.881 197.063V200.281Z",
    fill: "#FFE7C4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 194.348L109.193 192.218V189L112.881 191.13V194.348Z",
    fill: "#FFE7C4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 212.147L109.193 210.017V206.799L112.881 208.929V212.147Z",
    fill: "#FFE7C4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 218.081L109.193 215.952V212.734L112.881 214.864V218.081Z",
    fill: "#FFE7C4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 157.898L109.193 155.768V152.551L112.881 154.68V157.898Z",
    fill: "#FFE7C4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 170.614L109.193 168.484V165.266L112.881 167.396V170.614Z",
    fill: "#FFE7C4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 188.414L109.193 186.284V183.066L112.881 185.196V188.414Z",
    fill: "#FFE7C4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 164.679L109.193 162.55V159.332L112.881 161.462V164.679Z",
    fill: "#FFE7C4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 176.546L109.193 174.416V171.199L112.881 173.328V176.546Z",
    fill: "#FFE7C4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 224.426L109.193 222.296V219.078L112.881 221.208V224.426Z",
    fill: "#FFE7C4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 182.48L109.193 180.351V177.133L112.881 179.263V182.48Z",
    fill: "#FFE7C4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 271.895L109.193 269.765V266.547L112.881 268.677V271.895Z",
    fill: "#FFE7C4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 265.96L109.193 263.83V260.613L112.881 262.742V265.96Z",
    fill: "#FFE7C4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 284.173L109.193 282.044V278.826L112.881 280.956V284.173Z",
    fill: "#FFE7C4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 260.028L109.193 257.898V254.68L112.881 256.81V260.028Z",
    fill: "#FFE7C4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 277.827L109.193 275.697V272.48L112.881 274.609V277.827Z",
    fill: "#FFE7C4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 242.226L109.193 240.097V236.879L112.881 239.008V242.226Z",
    fill: "#FFE7C4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 254.093L109.193 251.963V248.746L112.881 250.875V254.093Z",
    fill: "#FFE7C4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 236.293L109.193 234.163V230.945L112.881 233.075V236.293Z",
    fill: "#FFE7C4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 230.359L109.193 228.23V225.012L112.881 227.142V230.359Z",
    fill: "#FFE7C4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 248.16L109.193 246.031V242.812L112.881 244.942V248.16Z",
    fill: "#FFE7C4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 103.959L109.193 101.829V98.6113L112.881 100.741V103.959Z",
    fill: "#FFE7C4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 68.3587L109.193 66.2287V63.0117L112.881 65.1407V68.3587Z",
    fill: "#FFE7C4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 151.964L109.193 149.835V146.617L112.881 148.747V151.964Z",
    fill: "#FFE7C4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 74.2933L109.193 72.1633V68.9453L112.881 71.0753V74.2933Z",
    fill: "#FFE7C4"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 86.1595L109.193 84.0305V80.8125L112.881 82.9425V86.1595Z",
    fill: "#FFE7C4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 80.225L109.193 78.095V74.877L112.881 77.007V80.225Z",
    fill: "#FFE7C4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 134.048L109.193 131.918V128.701L112.881 130.83V134.048Z",
    fill: "#FFE7C4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 128.117L109.193 125.987V122.77L112.881 124.899V128.117Z",
    fill: "#FFE7C4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 145.915L109.193 143.785V140.568L112.881 142.697V145.915Z",
    fill: "#FFE7C4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 139.983L109.193 137.853V134.635L112.881 136.765V139.983Z",
    fill: "#FFE7C4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 92.0921L109.193 89.9621V86.7441L112.881 88.8741V92.0921Z",
    fill: "#FFE7C4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 121.759L109.193 119.63V116.412L112.881 118.542V121.759Z",
    fill: "#FFE7C4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 298.713L173.438 296.583V293.365L177.126 295.495V298.713Z",
    fill: "#FFE7C4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 276.492L165.788 274.363V271.145L169.477 273.274V276.492Z",
    fill: "#FFE7C4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 109.892L109.193 107.762V104.545L112.881 106.675V109.892Z",
    fill: "#FFE7C4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 115.827L109.193 113.697V110.479L112.881 112.609V115.827Z",
    fill: "#FFE7C4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 79.93L300.921 77.8V74.582L304.61 76.712V79.93Z",
    fill: "#FFE7C4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 163.472L300.921 161.342V158.125L304.61 160.254V163.472Z",
    fill: "#FFE7C4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 175.34L300.921 173.21V169.992L304.61 172.122V175.34Z",
    fill: "#FFE7C4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 193.141L300.921 191.011V187.793L304.61 189.923V193.141Z",
    fill: "#FFE7C4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 181.273L300.921 179.144V175.926L304.61 178.056V181.273Z",
    fill: "#FFE7C4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 187.207L300.921 185.077V181.859L304.61 183.989V187.207Z",
    fill: "#FFE7C4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 169.406L300.921 167.277V164.059L304.61 166.189V169.406Z",
    fill: "#FFE7C4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 127.396L300.921 125.267V122.049L304.61 124.179V127.396Z",
    fill: "#FFE7C4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 133.33L300.921 131.2V127.982L304.61 130.112V133.33Z",
    fill: "#FFE7C4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 139.263L300.921 137.134V133.916L304.61 136.046V139.263Z",
    fill: "#FFE7C4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 145.672L300.921 143.542V140.324L304.61 142.454V145.672Z",
    fill: "#FFE7C4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 151.605L300.921 149.475V146.258L304.61 148.387V151.605Z",
    fill: "#FFE7C4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 157.539L300.921 155.409V152.191L304.61 154.321V157.539Z",
    fill: "#FFE7C4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 235.086L300.921 232.956V229.738L304.61 231.868V235.086Z",
    fill: "#FFE7C4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 241.019L300.921 238.889V235.672L304.61 237.802V241.019Z",
    fill: "#FFE7C4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 246.952L300.921 244.823V241.605L304.61 243.735V246.952Z",
    fill: "#FFE7C4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 252.886L300.921 250.756V247.539L304.61 249.668V252.886Z",
    fill: "#FFE7C4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 229.152L300.921 227.022V223.805L304.61 225.934V229.152Z",
    fill: "#FFE7C4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 217.286L300.921 215.156V211.939L304.61 214.068V217.286Z",
    fill: "#FFE7C4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 211.352L300.921 209.222V206.004L304.61 208.134V211.352Z",
    fill: "#FFE7C4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 223.219L300.921 221.089V217.871L304.61 220.001V223.219Z",
    fill: "#FFE7C4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 205.419L300.921 203.29V200.072L304.61 202.202V205.419Z",
    fill: "#FFE7C4"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 199.075L300.921 196.945V193.727L304.61 195.857V199.075Z",
    fill: "#FFE7C4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 258.82L300.921 256.691V253.473L304.61 255.603V258.82Z",
    fill: "#FFE7C4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 296.344L293.272 294.214V290.996L296.961 293.126V296.344Z",
    fill: "#FFE7C4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 121.464L300.921 119.334V116.117L304.61 118.246V121.464Z",
    fill: "#FFE7C4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 290.411L293.272 288.281V285.064L296.961 287.194V290.411Z",
    fill: "#FFE7C4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 272.61L293.272 270.48V267.262L296.961 269.392V272.61Z",
    fill: "#FFE7C4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 278.544L293.272 276.415V273.197L296.961 275.327V278.544Z",
    fill: "#FFE7C4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 284.477L293.272 282.347V279.129L296.961 281.259V284.477Z",
    fill: "#FFE7C4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 62.1283L300.921 59.9992V56.7812L304.61 58.9112V62.1283Z",
    fill: "#FFE7C4"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 103.663L300.921 101.534V98.3164L304.61 100.446V103.663Z",
    fill: "#FFE7C4"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 97.7298L300.921 95.5998V92.3828L304.61 94.5118V97.7298Z",
    fill: "#FFE7C4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 115.531L300.921 113.402V110.184L304.61 112.314V115.531Z",
    fill: "#FFE7C4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 109.597L300.921 107.467V104.25L304.61 106.379V109.597Z",
    fill: "#FFE7C4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 91.7972L300.921 89.6672V86.4492L304.61 88.5792V91.7972Z",
    fill: "#FFE7C4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 73.9954L300.921 71.8664V68.6484L304.61 70.7784V73.9954Z",
    fill: "#FFE7C4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 85.8626L300.921 83.7326V80.5156L304.61 82.6456V85.8626Z",
    fill: "#FFE7C4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 68.0628L300.921 65.9328V62.7148L304.61 64.8448V68.0628Z",
    fill: "#FFE7C4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 290.106L109.193 287.976V284.758L112.881 286.888V290.106Z",
    fill: "#FFE7C4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 174.798L165.788 172.669V169.451L169.477 171.581V174.798Z",
    fill: "#FFE7C4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 180.731L165.788 178.601V175.383L169.477 177.513V180.731Z",
    fill: "#FFE7C4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 265.165L300.921 263.035V259.818L304.61 261.947V265.165Z",
    fill: "#FFE7C4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 192.598L165.788 190.468V187.25L169.477 189.38V192.598Z",
    fill: "#FFE7C4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 198.533L165.788 196.403V193.186L169.477 195.315V198.533Z",
    fill: "#FFE7C4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 204.877L165.788 202.747V199.529L169.477 201.659V204.877Z",
    fill: "#FFE7C4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 156.998L165.788 154.868V151.65L169.477 153.78V156.998Z",
    fill: "#FFE7C4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 151.065L165.788 148.935V145.717L169.477 147.847V151.065Z",
    fill: "#FFE7C4"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 145.131L165.788 143.001V139.783L169.477 141.913V145.131Z",
    fill: "#FFE7C4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 162.932L165.788 160.802V157.584L169.477 159.714V162.932Z",
    fill: "#FFE7C4"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 168.865L165.788 166.735V163.518L169.477 165.647V168.865Z",
    fill: "#FFE7C4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 252.345L165.788 250.215V246.998L169.477 249.128V252.345Z",
    fill: "#FFE7C4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 210.81L165.788 208.681V205.463L169.477 207.592V210.81Z",
    fill: "#FFE7C4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 258.278L165.788 256.148V252.93L169.477 255.06V258.278Z",
    fill: "#FFE7C4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 240.478L165.788 238.349V235.131L169.477 237.261V240.478Z",
    fill: "#FFE7C4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 264.624L165.788 262.495V259.277L169.477 261.407V264.624Z",
    fill: "#FFE7C4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 246.412L165.788 244.282V241.064L169.477 243.194V246.412Z",
    fill: "#FFE7C4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 216.744L165.788 214.614V211.396L169.477 213.526V216.744Z",
    fill: "#FFE7C4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 234.545L165.788 232.415V229.197L169.477 231.327V234.545Z",
    fill: "#FFE7C4"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 222.677L165.788 220.547V217.33L169.477 219.459V222.677Z",
    fill: "#FFE7C4"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 228.611L165.788 226.482V223.264L169.477 225.394V228.611Z",
    fill: "#FFE7C4"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 186.665L165.788 184.536V181.318L169.477 183.448V186.665Z",
    fill: "#FFE7C4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 300.766L300.921 298.636V295.418L304.61 297.548V300.766Z",
    fill: "#FFE7C4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 294.833L300.921 292.703V289.486L304.61 291.616V294.833Z",
    fill: "#FFE7C4"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 270.557L165.788 268.427V265.209L169.477 267.339V270.557Z",
    fill: "#FFE7C4"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 138.348L165.788 136.218V133L169.477 135.13V138.348Z",
    fill: "#FFE7C4"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 277.034L300.921 274.904V271.686L304.61 273.816V277.034Z",
    fill: "#FFE7C4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 282.966L300.921 280.837V277.619L304.61 279.748V282.966Z",
    fill: "#FFE7C4"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 288.899L300.921 286.769V283.551L304.61 285.681V288.899Z",
    fill: "#FFE7C4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M304.61 271.099L300.921 268.97V265.752L304.61 267.882V271.099Z",
    fill: "#FFE7C4"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 113.353L165.788 111.224V108.006L169.477 110.135V113.353Z",
    fill: "#FFE7C4"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 119.287L165.788 117.157V113.939L169.477 116.069V119.287Z",
    fill: "#FFE7C4"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 125.22L165.788 123.09V119.873L169.477 122.003V125.22Z",
    fill: "#FFE7C4"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 132.003L165.788 129.874V126.656L169.477 128.786V132.003Z",
    fill: "#FFE7C4"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 107.42L165.788 105.29V102.072L169.477 104.202V107.42Z",
    fill: "#FFE7C4"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 83.6859L165.788 81.5559V78.3379L169.477 80.4679V83.6859Z",
    fill: "#FFE7C4"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 89.6204L165.788 87.4914V84.2734L169.477 86.4034V89.6204Z",
    fill: "#FFE7C4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 77.7542L165.788 75.6243V72.4062L169.477 74.5363V77.7542Z",
    fill: "#FFE7C4"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 101.486L165.788 99.3567V96.1387L169.477 98.2687V101.486Z",
    fill: "#FFE7C4"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 95.5531L165.788 93.4231V90.2051L169.477 92.3351V95.5531Z",
    fill: "#FFE7C4"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 289.146L38.4854 287.017V283.799L42.1744 285.929V289.146Z",
    fill: "#FFE7C4"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 296.04L109.193 293.911V290.693L112.881 292.823V296.04Z",
    fill: "#FFE7C4"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 260.58L30.8379 258.45V255.232L34.5259 257.362V260.58Z",
    fill: "#FFE7C4"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 272.858L30.8379 270.728V267.51L34.5259 269.64V272.858Z",
    fill: "#FFE7C4"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 254.646L30.8379 252.516V249.299L34.5259 251.428V254.646Z",
    fill: "#FFE7C4"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 278.791L30.8379 276.661V273.443L34.5259 275.573V278.791Z",
    fill: "#FFE7C4"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 242.779L30.8379 240.65V237.432L34.5259 239.562V242.779Z",
    fill: "#FFE7C4"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 224.979L30.8379 222.849V219.631L34.5259 221.761V224.979Z",
    fill: "#FFE7C4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 230.911L30.8379 228.782V225.564L34.5259 227.694V230.911Z",
    fill: "#FFE7C4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 236.846L30.8379 234.716V231.498L34.5259 233.628V236.846Z",
    fill: "#FFE7C4"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 284.724L30.8379 282.595V279.377L34.5259 281.507V284.724Z",
    fill: "#FFE7C4"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 296.591L30.8379 294.462V291.244L34.5259 293.374V296.591Z",
    fill: "#FFE7C4"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 302.526L30.8379 300.396V297.178L34.5259 299.308V302.526Z",
    fill: "#FFE7C4"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 290.659L30.8379 288.529V285.311L34.5259 287.441V290.659Z",
    fill: "#FFE7C4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 219.044L30.8379 216.915V213.697L34.5259 215.827V219.044Z",
    fill: "#FFE7C4"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 248.713L30.8379 246.583V243.365L34.5259 245.495V248.713Z",
    fill: "#FFE7C4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 213.112L30.8379 210.982V207.764L34.5259 209.894V213.112Z",
    fill: "#FFE7C4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 141.295L30.8379 139.165V135.947L34.5259 138.077V141.295Z",
    fill: "#FFE7C4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 147.228L30.8379 145.098V141.881L34.5259 144.01V147.228Z",
    fill: "#FFE7C4"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 135.337L30.8379 133.208V129.99L34.5259 132.12V135.337Z",
    fill: "#FFE7C4"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 188.966L30.8379 186.836V183.619L34.5259 185.748V188.966Z",
    fill: "#FFE7C4"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 153.365L30.8379 151.236V148.018L34.5259 150.148V153.365Z",
    fill: "#FFE7C4"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 194.899L30.8379 192.769V189.551L34.5259 191.681V194.899Z",
    fill: "#FFE7C4"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 206.765L30.8379 204.636V201.418L34.5259 203.548V206.765Z",
    fill: "#FFE7C4"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 200.833L30.8379 198.703V195.486L34.5259 197.615V200.833Z",
    fill: "#FFE7C4"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 183.034L30.8379 180.904V177.686L34.5259 179.816V183.034Z",
    fill: "#FFE7C4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 159.299L30.8379 157.169V153.951L34.5259 156.081V159.299Z",
    fill: "#FFE7C4"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 165.232L30.8379 163.102V159.885L34.5259 162.015V165.232Z",
    fill: "#FFE7C4"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 171.166L30.8379 169.036V165.818L34.5259 167.948V171.166Z",
    fill: "#FFE7C4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 177.099L30.8379 174.969V171.752L34.5259 173.882V177.099Z",
    fill: "#FFE7C4"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 253.135L38.4854 251.005V247.787L42.1744 249.917V253.135Z",
    fill: "#FFE7C4"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 283.213L38.4854 281.083V277.865L42.1744 279.995V283.213Z",
    fill: "#FFE7C4"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 266.677L293.272 264.548V261.33L296.961 263.46V266.677Z",
    fill: "#FFE7C4"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 301.013L38.4854 298.883V295.666L42.1744 297.796V301.013Z",
    fill: "#FFE7C4"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 270.935L38.4854 268.805V265.588L42.1744 267.717V270.935Z",
    fill: "#FFE7C4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 265.001L38.4854 262.872V259.654L42.1744 261.784V265.001Z",
    fill: "#FFE7C4"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 277.281L38.4854 275.152V271.934L42.1744 274.064V277.281Z",
    fill: "#FFE7C4"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 259.068L38.4854 256.938V253.721L42.1744 255.85V259.068Z",
    fill: "#FFE7C4"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 295.08L38.4854 292.95V289.732L42.1744 291.862V295.08Z",
    fill: "#FFE7C4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 247.201L38.4854 245.071V241.854L42.1744 243.983V247.201Z",
    fill: "#FFE7C4"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 157.786L38.4854 155.657V152.439L42.1744 154.569V157.786Z",
    fill: "#FFE7C4"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 151.65L38.4854 149.52V146.303L42.1744 148.432V151.65Z",
    fill: "#FFE7C4"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 169.654L38.4854 167.525V164.307L42.1744 166.436V169.654Z",
    fill: "#FFE7C4"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 175.588L38.4854 173.458V170.24L42.1744 172.37V175.588Z",
    fill: "#FFE7C4"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 139.759L38.4854 137.63V134.412L42.1744 136.542V139.759Z",
    fill: "#FFE7C4"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 181.521L38.4854 179.391V176.174L42.1744 178.303V181.521Z",
    fill: "#FFE7C4"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 145.717L38.4854 143.587V140.369L42.1744 142.499V145.717Z",
    fill: "#FFE7C4"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 163.721L38.4854 161.591V158.373L42.1744 160.503V163.721Z",
    fill: "#FFE7C4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 223.466L38.4854 221.337V218.119L42.1744 220.248V223.466Z",
    fill: "#FFE7C4"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 229.401L38.4854 227.271V224.053L42.1744 226.183V229.401Z",
    fill: "#FFE7C4"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 235.333L38.4854 233.203V229.986L42.1744 232.116V235.333Z",
    fill: "#FFE7C4"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 217.534L38.4854 215.404V212.186L42.1744 214.316V217.534Z",
    fill: "#FFE7C4"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 241.268L38.4854 239.138V235.92L42.1744 238.05V241.268Z",
    fill: "#FFE7C4"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 211.188L38.4854 209.058V205.84L42.1744 207.97V211.188Z",
    fill: "#FFE7C4"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 193.387L38.4854 191.257V188.039L42.1744 190.169V193.387Z",
    fill: "#FFE7C4"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 199.321L38.4854 197.191V193.973L42.1744 196.103V199.321Z",
    fill: "#FFE7C4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 205.254L38.4854 203.124V199.906L42.1744 202.036V205.254Z",
    fill: "#FFE7C4"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1744 187.455L38.4854 185.325V182.107L42.1744 184.237V187.455Z",
    fill: "#FFE7C4"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 266.512L30.8379 264.382V261.164L34.5259 263.294V266.512Z",
    fill: "#FFE7C4"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 204.702L116.842 202.572V199.355L120.531 201.484V204.702Z",
    fill: "#FFE7C4"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 198.77L116.842 196.64V193.422L120.531 195.552V198.77Z",
    fill: "#FFE7C4"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 210.636L116.842 208.507V205.289L120.531 207.419V210.636Z",
    fill: "#FFE7C4"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 216.569L116.842 214.439V211.221L120.531 213.351V216.569Z",
    fill: "#FFE7C4"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 156.386L116.842 154.257V151.039L120.531 153.169V156.386Z",
    fill: "#FFE7C4"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 186.902L116.842 184.773V181.555L120.531 183.685V186.902Z",
    fill: "#FFE7C4"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 169.101L116.842 166.971V163.754L120.531 165.883V169.101Z",
    fill: "#FFE7C4"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 222.503L116.842 220.374V217.156L120.531 219.286V222.503Z",
    fill: "#FFE7C4"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 162.32L116.842 160.19V156.973L120.531 159.102V162.32Z",
    fill: "#FFE7C4"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 175.035L116.842 172.906V169.688L120.531 171.817V175.035Z",
    fill: "#FFE7C4"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 180.968L116.842 178.838V175.621L120.531 177.75V180.968Z",
    fill: "#FFE7C4"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 192.835L116.842 190.705V187.488L120.531 189.617V192.835Z",
    fill: "#FFE7C4"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 264.449L116.842 262.32V259.102L120.531 261.232V264.449Z",
    fill: "#FFE7C4"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 258.515L116.842 256.385V253.168L120.531 255.297V258.515Z",
    fill: "#FFE7C4"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 270.383L116.842 268.253V265.035L120.531 267.165V270.383Z",
    fill: "#FFE7C4"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 282.25L116.842 280.12V276.902L120.531 279.032V282.25Z",
    fill: "#FFE7C4"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 276.316L116.842 274.187V270.969L120.531 273.099V276.316Z",
    fill: "#FFE7C4"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 234.783L116.842 232.654V229.436L120.531 231.566V234.783Z",
    fill: "#FFE7C4"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 228.848L116.842 226.718V223.5L120.531 225.63V228.848Z",
    fill: "#FFE7C4"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 240.715L116.842 238.585V235.367L120.531 237.497V240.715Z",
    fill: "#FFE7C4"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 252.582L116.842 250.452V247.234L120.531 249.364V252.582Z",
    fill: "#FFE7C4"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 246.648L116.842 244.519V241.301L120.531 243.431V246.648Z",
    fill: "#FFE7C4"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 78.7142L116.842 76.5852V73.3672L120.531 75.4972V78.7142Z",
    fill: "#FFE7C4"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 288.595L116.842 286.466V283.248L120.531 285.378V288.595Z",
    fill: "#FFE7C4"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 301.973L109.193 299.843V296.625L112.881 298.755V301.973Z",
    fill: "#FFE7C4"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 84.6468L116.842 82.5168V79.2988L120.531 81.4288V84.6468Z",
    fill: "#FFE7C4"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 150.337L116.842 148.207V144.99L120.531 147.119V150.337Z",
    fill: "#FFE7C4"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 132.537L116.842 130.407V127.189L120.531 129.319V132.537Z",
    fill: "#FFE7C4"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 126.181L116.842 124.051V120.834L120.531 122.964V126.181Z",
    fill: "#FFE7C4"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 138.47L116.842 136.341V133.123L120.531 135.252V138.47Z",
    fill: "#FFE7C4"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 120.248L116.842 118.118V114.9L120.531 117.03V120.248Z",
    fill: "#FFE7C4"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 144.405L116.842 142.275V139.057L120.531 141.187V144.405Z",
    fill: "#FFE7C4"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 96.514L116.842 94.384V91.166L120.531 93.296V96.514Z",
    fill: "#FFE7C4"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 90.5814L116.842 88.4524V85.2344L120.531 87.3644V90.5814Z",
    fill: "#FFE7C4"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 102.449L116.842 100.32V97.1016L120.531 99.2306V102.449Z",
    fill: "#FFE7C4"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 108.381L116.842 106.251V103.033L120.531 105.163V108.381Z",
    fill: "#FFE7C4"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 114.314L116.842 112.185V108.967L120.531 111.097V114.314Z",
    fill: "#FFE7C4"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 72.7806L116.842 70.6506V67.4336L120.531 69.5626V72.7806Z",
    fill: "#FFE7C4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 226.49L23.1885 224.361V221.143L26.8775 223.273V226.49Z",
    fill: "#FFE7C4"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 190.477L23.1885 188.347V185.129L26.8775 187.259V190.477Z",
    fill: "#FFE7C4"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 238.357L23.1885 236.227V233.01L26.8775 235.139V238.357Z",
    fill: "#FFE7C4"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 244.291L23.1885 242.161V238.943L26.8775 241.073V244.291Z",
    fill: "#FFE7C4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 250.224L23.1885 248.094V244.877L26.8775 247.007V250.224Z",
    fill: "#FFE7C4"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 220.556L23.1885 218.426V215.209L26.8775 217.338V220.556Z",
    fill: "#FFE7C4"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 196.411L23.1885 194.281V191.064L26.8775 193.193V196.411Z",
    fill: "#FFE7C4"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 214.622L23.1885 212.493V209.275L26.8775 211.405V214.622Z",
    fill: "#FFE7C4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 202.343L23.1885 200.214V196.996L26.8775 199.126V202.343Z",
    fill: "#FFE7C4"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 208.689L23.1885 206.559V203.342L26.8775 205.471V208.689Z",
    fill: "#FFE7C4"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 232.424L23.1885 230.294V227.076L26.8775 229.206V232.424Z",
    fill: "#FFE7C4"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 292.169L23.1885 290.04V286.822L26.8775 288.952V292.169Z",
    fill: "#FFE7C4"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 256.159L23.1885 254.029V250.811L26.8775 252.941V256.159Z",
    fill: "#FFE7C4"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 286.238L23.1885 284.108V280.891L26.8775 283.02V286.238Z",
    fill: "#FFE7C4"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 298.104L23.1885 295.974V292.756L26.8775 294.886V298.104Z",
    fill: "#FFE7C4"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 262.091L23.1885 259.961V256.744L26.8775 258.874V262.091Z",
    fill: "#FFE7C4"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 268.436L23.1885 266.306V263.088L26.8775 265.218V268.436Z",
    fill: "#FFE7C4"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 294.528L116.842 292.398V289.18L120.531 291.31V294.528Z",
    fill: "#FFE7C4"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 280.302L23.1885 278.173V274.955L26.8775 277.085V280.302Z",
    fill: "#FFE7C4"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 274.37L23.1885 272.24V269.023L26.8775 271.152V274.37Z",
    fill: "#FFE7C4"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 184.544L23.1885 182.414V179.197L26.8775 181.326V184.544Z",
    fill: "#FFE7C4"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 300.462L116.842 298.333V295.115L120.531 297.245V300.462Z",
    fill: "#FFE7C4"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 166.744L23.1885 164.614V161.396L26.8775 163.526V166.744Z",
    fill: "#FFE7C4"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 160.81L23.1885 158.68V155.463L26.8775 157.592V160.81Z",
    fill: "#FFE7C4"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 154.877L23.1885 152.747V149.529L26.8775 151.659V154.877Z",
    fill: "#FFE7C4"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 172.677L23.1885 170.547V167.33L26.8775 169.459V172.677Z",
    fill: "#FFE7C4"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 178.61L23.1885 176.48V173.262L26.8775 175.392V178.61Z",
    fill: "#FFE7C4"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 130.915L23.1885 128.786V125.568L26.8775 127.698V130.915Z",
    fill: "#FFE7C4"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 148.943L23.1885 146.814V143.596L26.8775 145.726V148.943Z",
    fill: "#FFE7C4"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 136.873L23.1885 134.743V131.525L26.8775 133.655V136.873Z",
    fill: "#FFE7C4"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 142.806L23.1885 140.676V137.459L26.8775 139.588V142.806Z",
    fill: "#FFE7C4"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 267.151L457.65 269.281V266.064L461.338 263.934V267.151Z",
    fill: "#FFE7C4"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 96.72L365.837 94.59V91.373L369.526 93.502V96.72Z",
    fill: "#FFE7C4"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 102.653L365.837 100.523V97.3047L369.526 99.4347V102.653Z",
    fill: "#FFE7C4"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 90.7875L365.837 88.6574V85.4395L369.526 87.5695V90.7875Z",
    fill: "#FFE7C4"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 108.587L365.837 106.457V103.24L369.526 105.369V108.587Z",
    fill: "#FFE7C4"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 114.52L365.837 112.39V109.172L369.526 111.302V114.52Z",
    fill: "#FFE7C4"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 120.454L365.837 118.324V115.107L369.526 117.236V120.454Z",
    fill: "#FFE7C4"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 288.386L472.947 290.516V287.298L476.635 285.168V288.386Z",
    fill: "#FFE7C4"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 300.253L472.947 302.383V299.165L476.635 297.035V300.253Z",
    fill: "#FFE7C4"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 294.321L472.947 296.451V293.233L476.635 291.104V294.321Z",
    fill: "#FFE7C4"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 78.9203L365.837 76.7903V73.5723L369.526 75.7023V78.9203Z",
    fill: "#FFE7C4"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 84.8529L365.837 82.7229V79.5059L369.526 81.6349V84.8529Z",
    fill: "#FFE7C4"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 167.922L365.837 165.792V162.574L369.526 164.704V167.922Z",
    fill: "#FFE7C4"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 126.386L365.837 124.257V121.039L369.526 123.169V126.386Z",
    fill: "#FFE7C4"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 173.855L365.837 171.725V168.508L369.526 170.637V173.855Z",
    fill: "#FFE7C4"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 179.788L365.837 177.659V174.441L369.526 176.571V179.788Z",
    fill: "#FFE7C4"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 156.055L365.837 153.925V150.707L369.526 152.837V156.055Z",
    fill: "#FFE7C4"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 161.988L365.837 159.858V156.641L369.526 158.77V161.988Z",
    fill: "#FFE7C4"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 132.321L365.837 130.191V126.973L369.526 129.103V132.321Z",
    fill: "#FFE7C4"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 138.253L365.837 136.124V132.906L369.526 135.036V138.253Z",
    fill: "#FFE7C4"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 150.12L365.837 147.991V144.773L369.526 146.903V150.12Z",
    fill: "#FFE7C4"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 144.188L365.837 142.058V138.84L369.526 140.97V144.188Z",
    fill: "#FFE7C4"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 282.453L472.947 284.583V281.366L476.635 279.236V282.453Z",
    fill: "#FFE7C4"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 198.56L472.947 200.69V197.472L476.635 195.342V198.56Z",
    fill: "#FFE7C4"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 186.695L472.947 188.825V185.607L476.635 183.477V186.695Z",
    fill: "#FFE7C4"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 192.628L472.947 194.757V191.54L476.635 189.41V192.628Z",
    fill: "#FFE7C4"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 186.133L365.837 184.003V180.785L369.526 182.915V186.133Z",
    fill: "#FFE7C4"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 204.906L472.947 207.036V203.818L476.635 201.689V204.906Z",
    fill: "#FFE7C4"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 174.827L472.947 176.957V173.739L476.635 171.609V174.827Z",
    fill: "#FFE7C4"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 162.96L472.947 165.09V161.872L476.635 159.742V162.96Z",
    fill: "#FFE7C4"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 180.761L472.947 182.891V179.673L476.635 177.543V180.761Z",
    fill: "#FFE7C4"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 168.894L472.947 171.023V167.806L476.635 165.676V168.894Z",
    fill: "#FFE7C4"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 216.772L472.947 218.902V215.684L476.635 213.555V216.772Z",
    fill: "#FFE7C4"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 210.839L472.947 212.969V209.751L476.635 207.621V210.839Z",
    fill: "#FFE7C4"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 252.374L472.947 254.504V251.286L476.635 249.156V252.374Z",
    fill: "#FFE7C4"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 157.027L472.947 159.156V155.939L476.635 153.809V157.027Z",
    fill: "#FFE7C4"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 264.654L472.947 266.784V263.566L476.635 261.436V264.654Z",
    fill: "#FFE7C4"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 270.586L472.947 272.716V269.499L476.635 267.369V270.586Z",
    fill: "#FFE7C4"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 222.706L472.947 224.836V221.618L476.635 219.488V222.706Z",
    fill: "#FFE7C4"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 276.519L472.947 278.649V275.431L476.635 273.301V276.519Z",
    fill: "#FFE7C4"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 228.639L472.947 230.769V227.551L476.635 225.422V228.639Z",
    fill: "#FFE7C4"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 234.573L472.947 236.703V233.485L476.635 231.355V234.573Z",
    fill: "#FFE7C4"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 240.506L472.947 242.636V239.418L476.635 237.289V240.506Z",
    fill: "#FFE7C4"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 246.441L472.947 248.57V245.353L476.635 243.223V246.441Z",
    fill: "#FFE7C4"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 258.308L472.947 260.437V257.22L476.635 255.09V258.308Z",
    fill: "#FFE7C4"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 136.743L373.485 134.613V131.395L377.174 133.525V136.743Z",
    fill: "#FFE7C4"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 130.808L373.485 128.679V125.461L377.174 127.591V130.808Z",
    fill: "#FFE7C4"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 142.675L373.485 140.545V137.328L377.174 139.457V142.675Z",
    fill: "#FFE7C4"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 148.61L373.485 146.48V143.262L377.174 145.392V148.61Z",
    fill: "#FFE7C4"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 154.542L373.485 152.412V149.195L377.174 151.324V154.542Z",
    fill: "#FFE7C4"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 101.142L373.485 99.0119V95.7949L377.174 97.9239V101.142Z",
    fill: "#FFE7C4"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 192.066L365.837 189.937V186.719L369.526 188.849V192.066Z",
    fill: "#FFE7C4"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 124.875L373.485 122.745V119.527L377.174 121.657V124.875Z",
    fill: "#FFE7C4"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 160.477L373.485 158.347V155.129L377.174 157.259V160.477Z",
    fill: "#FFE7C4"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 118.942L373.485 116.812V113.594L377.174 115.724V118.942Z",
    fill: "#FFE7C4"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 113.009L373.485 110.879V107.662L377.174 109.791V113.009Z",
    fill: "#FFE7C4"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 208.355L373.485 206.226V203.008L377.174 205.138V208.355Z",
    fill: "#FFE7C4"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 196.49L373.485 194.361V191.143L377.174 193.273V196.49Z",
    fill: "#FFE7C4"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 202.423L373.485 200.293V197.076L377.174 199.205V202.423Z",
    fill: "#FFE7C4"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 95.2093L373.485 93.0793V89.8613L377.174 91.9913V95.2093Z",
    fill: "#FFE7C4"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 214.289L373.485 212.159V208.941L377.174 211.071V214.289Z",
    fill: "#FFE7C4"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 220.222L373.485 218.093V214.875L377.174 217.004V220.222Z",
    fill: "#FFE7C4"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 172.344L373.485 170.214V166.996L377.174 169.126V172.344Z",
    fill: "#FFE7C4"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 166.41L373.485 164.281V161.062L377.174 163.191V166.41Z",
    fill: "#FFE7C4"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 178.277L373.485 176.147V172.93L377.174 175.059V178.277Z",
    fill: "#FFE7C4"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 190.556L373.485 188.426V185.209L377.174 187.338V190.556Z",
    fill: "#FFE7C4"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 184.21L373.485 182.081V178.863L377.174 180.993V184.21Z",
    fill: "#FFE7C4"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 107.077L373.485 104.947V101.729L377.174 103.859V107.077Z",
    fill: "#FFE7C4"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 251.814L365.837 249.684V246.467L369.526 248.596V251.814Z",
    fill: "#FFE7C4"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 89.2747L373.485 87.1447V83.9277L377.174 86.0577V89.2747Z",
    fill: "#FFE7C4"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 239.535L365.837 237.406V234.188L369.526 236.316V239.535Z",
    fill: "#FFE7C4"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 221.735L365.837 219.605V216.387L369.526 218.517V221.735Z",
    fill: "#FFE7C4"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 245.88L365.837 243.751V240.533L369.526 242.663V245.88Z",
    fill: "#FFE7C4"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 233.602L365.837 231.472V228.254L369.526 230.384V233.602Z",
    fill: "#FFE7C4"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 203.933L365.837 201.804V198.586L369.526 200.716V203.933Z",
    fill: "#FFE7C4"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 198L365.837 195.87V192.652L369.526 194.782V198Z",
    fill: "#FFE7C4"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 209.868L365.837 207.738V204.52L369.526 206.65V209.868Z",
    fill: "#FFE7C4"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 215.8L365.837 213.671V210.453L369.526 212.582V215.8Z",
    fill: "#FFE7C4"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 227.667L365.837 225.537V222.32L369.526 224.45V227.667Z",
    fill: "#FFE7C4"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 299.282L365.837 297.152V293.934L369.526 296.064V299.282Z",
    fill: "#FFE7C4"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 293.347L365.837 291.218V288L369.526 290.13V293.347Z",
    fill: "#FFE7C4"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 83.3421L373.485 81.2121V77.9941L377.174 80.1241V83.3421Z",
    fill: "#FFE7C4"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 287.414L365.837 285.284V282.066L369.526 284.196V287.414Z",
    fill: "#FFE7C4"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 263.681L365.837 261.551V258.334L369.526 260.463V263.681Z",
    fill: "#FFE7C4"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 257.748L365.837 255.618V252.4L369.526 254.53V257.748Z",
    fill: "#FFE7C4"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 269.616L365.837 267.486V264.268L369.526 266.398V269.616Z",
    fill: "#FFE7C4"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 275.548L365.837 273.418V270.201L369.526 272.33V275.548Z",
    fill: "#FFE7C4"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 281.48L365.837 279.351V276.133L369.526 278.263V281.48Z",
    fill: "#FFE7C4"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 255.284L457.65 257.413V254.196L461.338 252.066V255.284Z",
    fill: "#FFE7C4"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 249.351L457.65 251.481V248.263L461.338 246.133V249.351Z",
    fill: "#FFE7C4"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 243.417L457.65 245.546V242.329L461.338 240.199V243.417Z",
    fill: "#FFE7C4"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 261.218L457.65 263.348V260.13L461.338 258V261.218Z",
    fill: "#FFE7C4"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 273.497L457.65 275.627V272.409L461.338 270.279V273.497Z",
    fill: "#FFE7C4"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 213.751L457.65 215.88V212.662L461.338 210.533V213.751Z",
    fill: "#FFE7C4"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 279.43L457.65 281.56V278.342L461.338 276.213V279.43Z",
    fill: "#FFE7C4"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 237.484L457.65 239.614V236.396L461.338 234.266V237.484Z",
    fill: "#FFE7C4"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 219.683L457.65 221.813V218.595L461.338 216.465V219.683Z",
    fill: "#FFE7C4"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 225.617L457.65 227.747V224.529L461.338 222.4V225.617Z",
    fill: "#FFE7C4"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 231.55L457.65 233.68V230.462L461.338 228.332V231.55Z",
    fill: "#FFE7C4"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 260.744L293.272 258.615V255.396L296.961 257.526V260.744Z",
    fill: "#FFE7C4"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 285.365L457.65 287.493V284.276L461.338 282.146V285.365Z",
    fill: "#FFE7C4"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 226.157L373.485 224.027V220.809L377.174 222.939V226.157Z",
    fill: "#FFE7C4"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 291.297L457.65 293.427V290.209L461.338 288.08V291.297Z",
    fill: "#FFE7C4"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 297.23L457.65 299.36V296.142L461.338 294.012V297.23Z",
    fill: "#FFE7C4"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 207.406L457.65 209.536V206.318L461.338 204.188V207.406Z",
    fill: "#FFE7C4"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 201.471L457.65 203.601V200.383L461.338 198.254V201.471Z",
    fill: "#FFE7C4"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 135.727L457.65 137.857V134.64L461.338 132.51V135.727Z",
    fill: "#FFE7C4"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 129.794L457.65 131.924V128.706L461.338 126.576V129.794Z",
    fill: "#FFE7C4"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 177.738L457.65 179.867V176.65L461.338 174.52V177.738Z",
    fill: "#FFE7C4"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 183.671L457.65 185.801V182.583L461.338 180.453V183.671Z",
    fill: "#FFE7C4"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 171.804L457.65 173.934V170.716L461.338 168.586V171.804Z",
    fill: "#FFE7C4"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 189.604L457.65 191.734V188.516L461.338 186.387V189.604Z",
    fill: "#FFE7C4"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 195.538L457.65 197.668V194.45L461.338 192.32V195.538Z",
    fill: "#FFE7C4"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 159.937L457.65 162.067V158.849L461.338 156.719V159.937Z",
    fill: "#FFE7C4"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 147.594L457.65 149.724V146.506L461.338 144.377V147.594Z",
    fill: "#FFE7C4"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 154.003L457.65 156.132V152.915L461.338 150.785V154.003Z",
    fill: "#FFE7C4"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 141.661L457.65 143.791V140.573L461.338 138.443V141.661Z",
    fill: "#FFE7C4"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 165.87L457.65 167.999V164.782L461.338 162.652V165.87Z",
    fill: "#FFE7C4"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 215.261L465.299 217.391V214.173L468.988 212.043V215.261Z",
    fill: "#FFE7C4"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 280.941L465.299 283.071V279.853L468.988 277.723V280.941Z",
    fill: "#FFE7C4"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 292.808L465.299 294.938V291.72L468.988 289.59V292.808Z",
    fill: "#FFE7C4"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 298.742L465.299 300.872V297.654L468.988 295.525V298.742Z",
    fill: "#FFE7C4"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 275.009L465.299 277.138V273.921L468.988 271.791V275.009Z",
    fill: "#FFE7C4"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 256.796L465.299 258.926V255.708L468.988 253.578V256.796Z",
    fill: "#FFE7C4"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 262.729L465.299 264.859V261.642L468.988 259.512V262.729Z",
    fill: "#FFE7C4"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 269.075L465.299 271.205V267.987L468.988 265.857V269.075Z",
    fill: "#FFE7C4"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 132.818L472.947 134.948V131.73L476.635 129.6V132.818Z",
    fill: "#FFE7C4"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 126.884L472.947 129.013V125.796L476.635 123.666V126.884Z",
    fill: "#FFE7C4"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 138.751L472.947 140.88V137.662L476.635 135.533V138.751Z",
    fill: "#FFE7C4"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 145.159L472.947 147.289V144.071L476.635 141.941V145.159Z",
    fill: "#FFE7C4"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 120.95L472.947 123.08V119.862L476.635 117.732V120.95Z",
    fill: "#FFE7C4"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 250.863L465.299 252.992V249.775L468.988 247.645V250.863Z",
    fill: "#FFE7C4"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 286.876L465.299 289.005V285.787L468.988 283.658V286.876Z",
    fill: "#FFE7C4"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 161.448L465.299 163.578V160.36L468.988 158.23V161.448Z",
    fill: "#FFE7C4"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 155.514L465.299 157.644V154.426L468.988 152.297V155.514Z",
    fill: "#FFE7C4"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 167.381L465.299 169.511V166.293L468.988 164.164V167.381Z",
    fill: "#FFE7C4"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 173.316L465.299 175.445V172.228L468.988 170.098V173.316Z",
    fill: "#FFE7C4"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 149.581L465.299 151.711V148.493L468.988 146.363V149.581Z",
    fill: "#FFE7C4"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 179.249L465.299 181.379V178.161L468.988 176.031V179.249Z",
    fill: "#FFE7C4"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 244.928L465.299 247.058V243.84L468.988 241.711V244.928Z",
    fill: "#FFE7C4"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 143.172L465.299 145.302V142.084L468.988 139.955V143.172Z",
    fill: "#FFE7C4"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 125.372L465.299 127.502V124.284L468.988 122.154V125.372Z",
    fill: "#FFE7C4"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 137.239L465.299 139.369V136.151L468.988 134.021V137.239Z",
    fill: "#FFE7C4"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 131.306L465.299 133.435V130.217L468.988 128.088V131.306Z",
    fill: "#FFE7C4"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 221.196L465.299 223.326V220.108L468.988 217.979V221.196Z",
    fill: "#FFE7C4"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M476.635 151.092L472.947 153.222V150.004L476.635 147.875V151.092Z",
    fill: "#FFE7C4"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 227.128L465.299 229.258V226.04L468.988 223.91V227.128Z",
    fill: "#FFE7C4"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 233.061L465.299 235.191V231.973L468.988 229.844V233.061Z",
    fill: "#FFE7C4"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 185.182L465.299 187.312V184.095L468.988 181.965V185.182Z",
    fill: "#FFE7C4"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 238.995L465.299 241.124V237.907L468.988 235.777V238.995Z",
    fill: "#FFE7C4"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 191.116L465.299 193.246V190.028L468.988 187.898V191.116Z",
    fill: "#FFE7C4"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 209.328L465.299 211.458V208.24L468.988 206.111V209.328Z",
    fill: "#FFE7C4"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 197.049L465.299 199.179V195.962L468.988 193.832V197.049Z",
    fill: "#FFE7C4"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M468.988 202.982L465.299 205.112V201.894L468.988 199.764V202.982Z",
    fill: "#FFE7C4"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 166.495L285.624 164.366V161.148L289.312 163.277V166.495Z",
    fill: "#FFE7C4"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 172.43L285.624 170.3V167.082L289.312 169.212V172.43Z",
    fill: "#FFE7C4"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 178.363L285.624 176.233V173.016L289.312 175.145V178.363Z",
    fill: "#FFE7C4"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 190.23L285.624 188.1V184.883L289.312 187.012V190.23Z",
    fill: "#FFE7C4"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 184.297L285.624 182.167V178.949L289.312 181.079V184.297Z",
    fill: "#FFE7C4"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 142.761L285.624 140.632V137.414L289.312 139.543V142.761Z",
    fill: "#FFE7C4"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 196.577L285.624 194.447V191.229L289.312 193.359V196.577Z",
    fill: "#FFE7C4"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 136.828L285.624 134.698V131.48L289.312 133.61V136.828Z",
    fill: "#FFE7C4"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 154.628L285.624 152.499V149.281L289.312 151.41V154.628Z",
    fill: "#FFE7C4"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 148.696L285.624 146.566V143.348L289.312 145.478V148.696Z",
    fill: "#FFE7C4"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 160.563L285.624 158.433V155.215L289.312 157.345V160.563Z",
    fill: "#FFE7C4"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 202.508L285.624 200.378V197.16L289.312 199.29V202.508Z",
    fill: "#FFE7C4"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 244.042L285.624 241.912V238.695L289.312 240.825V244.042Z",
    fill: "#FFE7C4"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 238.11L285.624 235.98V232.762L289.312 234.892V238.11Z",
    fill: "#FFE7C4"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 249.977L285.624 247.847V244.629L289.312 246.759V249.977Z",
    fill: "#FFE7C4"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 130.419L285.624 128.29V125.072L289.312 127.202V130.419Z",
    fill: "#FFE7C4"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 232.175L285.624 230.045V226.828L289.312 228.957V232.175Z",
    fill: "#FFE7C4"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 256.322L285.624 254.192V250.975L289.312 253.104V256.322Z",
    fill: "#FFE7C4"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 214.375L285.624 212.245V209.027L289.312 211.157V214.375Z",
    fill: "#FFE7C4"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 208.441L285.624 206.312V203.094L289.312 205.224V208.441Z",
    fill: "#FFE7C4"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 220.308L285.624 218.179V214.961L289.312 217.091V220.308Z",
    fill: "#FFE7C4"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 226.243L285.624 224.113V220.895L289.312 223.025V226.243Z",
    fill: "#FFE7C4"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 287.5L277.975 285.37V282.152L281.665 284.282V287.5Z",
    fill: "#FFE7C4"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 299.368L277.975 297.238V294.02L281.665 296.15V299.368Z",
    fill: "#FFE7C4"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 53.2845L285.624 51.1555V47.9375L289.312 50.0675V53.2845Z",
    fill: "#FFE7C4"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 293.433L277.975 291.304V288.086L281.665 290.216V293.433Z",
    fill: "#FFE7C4"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 59.2191L285.624 57.0891V53.8711L289.312 56.0011V59.2191Z",
    fill: "#FFE7C4"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 269.702L277.975 267.572V264.354L281.665 266.484V269.702Z",
    fill: "#FFE7C4"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 275.633L277.975 273.503V270.285L281.665 272.415V275.633Z",
    fill: "#FFE7C4"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 124.486L285.624 122.356V119.139L289.312 121.268V124.486Z",
    fill: "#FFE7C4"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 262.255L285.624 260.126V256.908L289.312 259.038V262.255Z",
    fill: "#FFE7C4"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 281.567L277.975 279.437V276.219L281.665 278.349V281.567Z",
    fill: "#FFE7C4"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 65.1517L285.624 63.0227V59.8047L289.312 61.9347V65.1517Z",
    fill: "#FFE7C4"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 94.8187L285.624 92.6887V89.4707L289.312 91.6007V94.8187Z",
    fill: "#FFE7C4"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 100.753L285.624 98.6233V95.4062L289.312 97.5353V100.753Z",
    fill: "#FFE7C4"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 118.552L285.624 116.423V113.205L289.312 115.335V118.552Z",
    fill: "#FFE7C4"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 112.62L285.624 110.49V107.273L289.312 109.402V112.62Z",
    fill: "#FFE7C4"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 106.686L285.624 104.556V101.338L289.312 103.468V106.686Z",
    fill: "#FFE7C4"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 77.0189L285.624 74.8899V71.6719L289.312 73.8019V77.0189Z",
    fill: "#FFE7C4"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 88.8861L285.624 86.7571V83.5391L289.312 85.6681V88.8861Z",
    fill: "#FFE7C4"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 71.0863L285.624 68.9563V65.7383L289.312 67.8683V71.0863Z",
    fill: "#FFE7C4"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 82.9535L285.624 80.8235V77.6055L289.312 79.7355V82.9535Z",
    fill: "#FFE7C4"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 297.855L285.624 295.726V292.508L289.312 294.637V297.855Z",
    fill: "#FFE7C4"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 268.188L285.624 266.058V262.84L289.312 264.97V268.188Z",
    fill: "#FFE7C4"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 170.917L293.272 168.787V165.57L296.961 167.699V170.917Z",
    fill: "#FFE7C4"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 164.985L293.272 162.855V159.637L296.961 161.767V164.985Z",
    fill: "#FFE7C4"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 232.09L373.485 229.96V226.742L377.174 228.872V232.09Z",
    fill: "#FFE7C4"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 182.785L293.272 180.654V177.438L296.961 179.566V182.785Z",
    fill: "#FFE7C4"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 159.05L293.272 156.92V153.703L296.961 155.832V159.05Z",
    fill: "#FFE7C4"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 141.25L293.272 139.12V135.902L296.961 138.032V141.25Z",
    fill: "#FFE7C4"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 147.183L293.272 145.054V141.836L296.961 143.966V147.183Z",
    fill: "#FFE7C4"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 153.118L293.272 150.988V147.77L296.961 149.9V153.118Z",
    fill: "#FFE7C4"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 194.652L293.272 192.522V189.305L296.961 191.434V194.652Z",
    fill: "#FFE7C4"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 188.719L293.272 186.589V183.371L296.961 185.501V188.719Z",
    fill: "#FFE7C4"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 230.664L293.272 228.534V225.316L296.961 227.446V230.664Z",
    fill: "#FFE7C4"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 242.532L293.272 240.402V237.184L296.961 239.314V242.532Z",
    fill: "#FFE7C4"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 236.597L293.272 234.468V231.25L296.961 233.379V236.597Z",
    fill: "#FFE7C4"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 248.465L293.272 246.335V243.117L296.961 245.247V248.465Z",
    fill: "#FFE7C4"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 254.399L293.272 252.269V249.051L296.961 251.181V254.399Z",
    fill: "#FFE7C4"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 206.93L293.272 204.8V201.582L296.961 203.712V206.93Z",
    fill: "#FFE7C4"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 212.865L293.272 210.735V207.518L296.961 209.648V212.865Z",
    fill: "#FFE7C4"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 200.997L293.272 198.868V195.65L296.961 197.78V200.997Z",
    fill: "#FFE7C4"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 224.73L293.272 222.6V219.383L296.961 221.513V224.73Z",
    fill: "#FFE7C4"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 218.797L293.272 216.667V213.449L296.961 215.579V218.797Z",
    fill: "#FFE7C4"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 176.852L293.272 174.722V171.504L296.961 173.634V176.852Z",
    fill: "#FFE7C4"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 263.766L277.975 261.636V258.418L281.665 260.548V263.766Z",
    fill: "#FFE7C4"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 63.641L293.272 61.511V58.293L296.961 60.423V63.641Z",
    fill: "#FFE7C4"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 57.7064L293.272 55.5774V52.3594L296.961 54.4894V57.7064Z",
    fill: "#FFE7C4"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 274.122L285.624 271.993V268.775L289.312 270.905V274.122Z",
    fill: "#FFE7C4"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 280.055L285.624 277.925V274.707L289.312 276.837V280.055Z",
    fill: "#FFE7C4"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 285.99L285.624 283.861V280.643L289.312 282.773V285.99Z",
    fill: "#FFE7C4"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M289.312 291.922L285.624 289.792V286.574L289.312 288.704V291.922Z",
    fill: "#FFE7C4"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 99.2425L293.272 97.1125V93.8945L296.961 96.0245V99.2425Z",
    fill: "#FFE7C4"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 105.175L293.272 103.045V99.8281L296.961 101.957V105.175Z",
    fill: "#FFE7C4"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 111.108L293.272 108.978V105.76L296.961 107.89V111.108Z",
    fill: "#FFE7C4"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 128.91L293.272 126.78V123.562L296.961 125.692V128.91Z",
    fill: "#FFE7C4"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 122.974L293.272 120.845V117.627L296.961 119.757V122.974Z",
    fill: "#FFE7C4"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 117.042L293.272 114.912V111.695L296.961 113.824V117.042Z",
    fill: "#FFE7C4"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 93.3079L293.272 91.1779V87.9609L296.961 90.0899V93.3079Z",
    fill: "#FFE7C4"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 75.5082L293.272 73.3782V70.1602L296.961 72.2902V75.5082Z",
    fill: "#FFE7C4"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 81.4408L293.272 79.3107V76.0938L296.961 78.2237V81.4408Z",
    fill: "#FFE7C4"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 69.5736L293.272 67.4446V64.2266L296.961 66.3556V69.5736Z",
    fill: "#FFE7C4"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 87.3753L293.272 85.2453V82.0273L296.961 84.1573V87.3753Z",
    fill: "#FFE7C4"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 134.841L293.272 132.712V129.494L296.961 131.624V134.841Z",
    fill: "#FFE7C4"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 164.898L381.135 162.769V159.551L384.823 161.681V164.898Z",
    fill: "#FFE7C4"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 170.831L381.135 168.701V165.484L384.823 167.613V170.831Z",
    fill: "#FFE7C4"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 176.766L381.135 174.636V171.418L384.823 173.548V176.766Z",
    fill: "#FFE7C4"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 182.699L381.135 180.569V177.352L384.823 179.481V182.699Z",
    fill: "#FFE7C4"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 188.632L381.135 186.503V183.285L384.823 185.415V188.632Z",
    fill: "#FFE7C4"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 135.23L381.135 133.101V129.883L384.823 132.013V135.23Z",
    fill: "#FFE7C4"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 141.164L381.135 139.034V135.816L384.823 137.946V141.164Z",
    fill: "#FFE7C4"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 194.978L381.135 192.848V189.631L384.823 191.76V194.978Z",
    fill: "#FFE7C4"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 158.964L381.135 156.834V153.617L384.823 155.746V158.964Z",
    fill: "#FFE7C4"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 147.097L381.135 144.968V141.75L384.823 143.879V147.097Z",
    fill: "#FFE7C4"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 257.834L277.975 255.704V252.486L281.665 254.616V257.834Z",
    fill: "#FFE7C4"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 242.445L381.135 240.316V237.098L384.823 239.228V242.445Z",
    fill: "#FFE7C4"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 200.911L381.135 198.782V195.564L384.823 197.694V200.911Z",
    fill: "#FFE7C4"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 236.511L381.135 234.381V231.164L384.823 233.293V236.511Z",
    fill: "#FFE7C4"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 254.725L381.135 252.595V249.377L384.823 251.507V254.725Z",
    fill: "#FFE7C4"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 248.378L381.135 246.248V243.031L384.823 245.16V248.378Z",
    fill: "#FFE7C4"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 230.578L381.135 228.448V225.23L384.823 227.36V230.578Z",
    fill: "#FFE7C4"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 129.297L381.135 127.167V123.949L384.823 126.079V129.297Z",
    fill: "#FFE7C4"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 212.777L381.135 210.648V207.43L384.823 209.56V212.777Z",
    fill: "#FFE7C4"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 206.844L381.135 204.714V201.496L384.823 203.626V206.844Z",
    fill: "#FFE7C4"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 218.711L381.135 216.581V213.363L384.823 215.493V218.711Z",
    fill: "#FFE7C4"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 224.644L381.135 222.514V219.297L384.823 221.426V224.644Z",
    fill: "#FFE7C4"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 285.902L373.485 283.772V280.555L377.174 282.684V285.902Z",
    fill: "#FFE7C4"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 123.365L381.135 121.236V118.018L384.823 120.148V123.365Z",
    fill: "#FFE7C4"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 274.036L373.485 271.907V268.689L377.174 270.819V274.036Z",
    fill: "#FFE7C4"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 268.103L373.485 265.973V262.756L377.174 264.885V268.103Z",
    fill: "#FFE7C4"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 260.659L381.135 258.529V255.311L384.823 257.441V260.659Z",
    fill: "#FFE7C4"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 279.969L373.485 277.839V274.621L377.174 276.751V279.969Z",
    fill: "#FFE7C4"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 243.956L373.485 241.826V238.609L377.174 240.738V243.956Z",
    fill: "#FFE7C4"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 291.836L373.485 289.706V286.488L377.174 288.618V291.836Z",
    fill: "#FFE7C4"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 238.024L373.485 235.894V232.676L377.174 234.806V238.024Z",
    fill: "#FFE7C4"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 256.236L373.485 254.106V250.889L377.174 253.018V256.236Z",
    fill: "#FFE7C4"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 250.303L373.485 248.173V244.955L377.174 247.085V250.303Z",
    fill: "#FFE7C4"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 262.169L373.485 260.04V256.822L377.174 258.952V262.169Z",
    fill: "#FFE7C4"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 99.6312L381.135 97.5012V94.2832L384.823 96.4132V99.6312Z",
    fill: "#FFE7C4"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 297.769L373.485 295.64V292.422L377.174 294.551V297.769Z",
    fill: "#FFE7C4"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 105.563L381.135 103.433V100.215L384.823 102.345V105.563Z",
    fill: "#FFE7C4"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 111.497L381.135 109.368V106.15L384.823 108.28V111.497Z",
    fill: "#FFE7C4"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 117.43L381.135 115.3V112.082L384.823 114.212V117.43Z",
    fill: "#FFE7C4"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 93.6966L381.135 91.5666V88.3496L384.823 90.4786V93.6966Z",
    fill: "#FFE7C4"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 87.764L381.135 85.634V82.416L384.823 84.546V87.764Z",
    fill: "#FFE7C4"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M369.526 73.0599L365.837 70.9299V67.7129L369.526 69.8419V73.0599Z",
    fill: "#FFE7C4"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M377.174 77.4818L373.485 75.3518V72.1348L377.174 74.2638V77.4818Z",
    fill: "#FFE7C4"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 81.9036L381.135 79.7736V76.5566L384.823 78.6856V81.9036Z",
    fill: "#FFE7C4"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 153.032L381.135 150.902V147.684L384.823 149.814V153.032Z",
    fill: "#FFE7C4"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 173.941L277.975 171.811V168.594L281.665 170.723V173.941Z",
    fill: "#FFE7C4"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 162.074L277.975 159.945V156.727L281.665 158.857V162.074Z",
    fill: "#FFE7C4"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 168.008L277.975 165.878V162.66L281.665 164.79V168.008Z",
    fill: "#FFE7C4"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 185.808L277.975 183.678V180.461L281.665 182.59V185.808Z",
    fill: "#FFE7C4"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 132.407L277.975 130.277V127.059L281.665 129.189V132.407Z",
    fill: "#FFE7C4"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 179.875L277.975 177.745V174.527L281.665 176.657V179.875Z",
    fill: "#FFE7C4"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 138.339L277.975 136.21V132.992L281.665 135.121V138.339Z",
    fill: "#FFE7C4"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 156.141L277.975 154.011V150.793L281.665 152.923V156.141Z",
    fill: "#FFE7C4"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 144.274L277.975 142.144V138.926L281.665 141.056V144.274Z",
    fill: "#FFE7C4"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 150.206L277.975 148.077V144.859L281.665 146.989V150.206Z",
    fill: "#FFE7C4"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 266.591L381.135 264.462V261.244L384.823 263.374V266.591Z",
    fill: "#FFE7C4"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 239.62L277.975 237.491V234.273L281.665 236.403V239.62Z",
    fill: "#FFE7C4"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 227.753L277.975 225.624V222.406L281.665 224.536V227.753Z",
    fill: "#FFE7C4"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 233.688L277.975 231.558V228.34L281.665 230.47V233.688Z",
    fill: "#FFE7C4"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 245.555L277.975 243.425V240.207L281.665 242.337V245.555Z",
    fill: "#FFE7C4"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 251.9L277.975 249.77V246.553L281.665 248.682V251.9Z",
    fill: "#FFE7C4"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 204.019L277.975 201.89V198.672L281.665 200.802V204.019Z",
    fill: "#FFE7C4"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 209.953L277.975 207.823V204.605L281.665 206.735V209.953Z",
    fill: "#FFE7C4"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 198.087L277.975 195.957V192.74L281.665 194.869V198.087Z",
    fill: "#FFE7C4"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 221.821L277.975 219.691V216.473L281.665 218.603V221.821Z",
    fill: "#FFE7C4"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 215.886L277.975 213.757V210.539L281.665 212.669V215.886Z",
    fill: "#FFE7C4"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 192.153L277.975 190.023V186.805L281.665 188.935V192.153Z",
    fill: "#FFE7C4"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 125.998L277.975 123.868V120.65L281.665 122.78V125.998Z",
    fill: "#FFE7C4"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 302.191L381.135 300.061V296.844L384.823 298.974V302.191Z",
    fill: "#FFE7C4"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 60.7298L277.975 58.6008V55.3828L281.665 57.5128V60.7298Z",
    fill: "#FFE7C4"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 54.7962L277.975 52.6662V49.4492L281.665 51.5782V54.7962Z",
    fill: "#FFE7C4"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 48.8626L277.975 46.7336V43.5156L281.665 45.6456V48.8626Z",
    fill: "#FFE7C4"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 272.524L381.135 270.394V267.176L384.823 269.306V272.524Z",
    fill: "#FFE7C4"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 278.458L381.135 276.329V273.111L384.823 275.241V278.458Z",
    fill: "#FFE7C4"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 284.391L381.135 282.261V279.043L384.823 281.173V284.391Z",
    fill: "#FFE7C4"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 290.326L381.135 288.196V284.979L384.823 287.109V290.326Z",
    fill: "#FFE7C4"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M384.823 296.258L381.135 294.128V290.91L384.823 293.04V296.258Z",
    fill: "#FFE7C4"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 108.199L277.975 106.069V102.852L281.665 104.981V108.199Z",
    fill: "#FFE7C4"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 96.3314L277.975 94.2014V90.9844L281.665 93.1144V96.3314Z",
    fill: "#FFE7C4"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 102.264L277.975 100.134V96.916L281.665 99.046V102.264Z",
    fill: "#FFE7C4"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 114.131L277.975 112.001V108.783L281.665 110.913V114.131Z",
    fill: "#FFE7C4"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 120.064L277.975 117.934V114.717L281.665 116.846V120.064Z",
    fill: "#FFE7C4"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 72.597L277.975 70.468V67.25L281.665 69.38V72.597Z",
    fill: "#FFE7C4"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 66.6644L277.975 64.5344V61.3164L281.665 63.4464V66.6644Z",
    fill: "#FFE7C4"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 78.5316L277.975 76.4016V73.1836L281.665 75.3136V78.5316Z",
    fill: "#FFE7C4"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 84.4642L277.975 82.3352V79.1172L281.665 81.2462V84.4642Z",
    fill: "#FFE7C4"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 90.3968L277.975 88.2668V85.0488L281.665 87.1788V90.3968Z",
    fill: "#FFE7C4"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 108.097L144.42 110.226V107.008L148.109 104.879V108.097Z",
    fill: "#EEDBBF"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 102.163L144.42 104.293V101.075L148.109 98.9453V102.163Z",
    fill: "#EEDBBF"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 114.03L144.42 116.16V112.942L148.109 110.812V114.03Z",
    fill: "#EEDBBF"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 120.577L144.42 122.706V119.489L148.109 117.359V120.577Z",
    fill: "#EEDBBF"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 126.509L144.42 128.639V125.421L148.109 123.291V126.509Z",
    fill: "#EEDBBF"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 84.0637L144.42 86.1937V82.9757L148.109 80.8457V84.0637Z",
    fill: "#EEDBBF"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 198.186L144.42 200.316V197.098L148.109 194.969V198.186Z",
    fill: "#EEDBBF"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 72.1985L144.42 74.3285V71.1105L148.109 68.9805V72.1985Z",
    fill: "#EEDBBF"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 78.1321L144.42 80.2611V77.0441L148.109 74.9141V78.1321Z",
    fill: "#EEDBBF"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 132.445L144.42 134.574V131.356L148.109 129.227V132.445Z",
    fill: "#EEDBBF"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 89.9983L144.42 92.1283V88.9103L148.109 86.7812V89.9983Z",
    fill: "#EEDBBF"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 192.253L144.42 194.383V191.165L148.109 189.035V192.253Z",
    fill: "#EEDBBF"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 208.542L136.771 210.672V207.454L140.459 205.324V208.542Z",
    fill: "#EEDBBF"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 168.519L144.42 170.649V167.431L148.109 165.301V168.519Z",
    fill: "#EEDBBF"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 174.452L144.42 176.581V173.364L148.109 171.234V174.452Z",
    fill: "#EEDBBF"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 186.32L144.42 188.449V185.232L148.109 183.102V186.32Z",
    fill: "#EEDBBF"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 138.376L144.42 140.506V137.288L148.109 135.158V138.376Z",
    fill: "#EEDBBF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 66.2649L144.42 68.3939V65.1759L148.109 63.0469V66.2649Z",
    fill: "#EEDBBF"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 144.31L144.42 146.439V143.221L148.109 141.092V144.31Z",
    fill: "#EEDBBF"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 150.243L144.42 152.373V149.155L148.109 147.025V150.243Z",
    fill: "#EEDBBF"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 156.653L144.42 158.783V155.565L148.109 153.436V156.653Z",
    fill: "#EEDBBF"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 162.585L144.42 164.714V161.497L148.109 159.367V162.585Z",
    fill: "#EEDBBF"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 96.1711L144.42 98.3011V95.0831L148.109 92.9531V96.1711Z",
    fill: "#EEDBBF"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 244.554L136.771 246.683V243.466L140.459 241.336V244.554Z",
    fill: "#EEDBBF"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 250.488L136.771 252.618V249.4L140.459 247.27V250.488Z",
    fill: "#EEDBBF"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 256.421L136.771 258.55V255.332L140.459 253.203V256.421Z",
    fill: "#EEDBBF"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 238.62L136.771 240.75V237.532L140.459 235.402V238.62Z",
    fill: "#EEDBBF"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 262.355L136.771 264.485V261.267L140.459 259.137V262.355Z",
    fill: "#EEDBBF"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 214.475L136.771 216.605V213.387L140.459 211.258V214.475Z",
    fill: "#EEDBBF"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 268.288L136.771 270.417V267.199L140.459 265.07V268.288Z",
    fill: "#EEDBBF"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 220.822L136.771 222.952V219.734L140.459 217.604V220.822Z",
    fill: "#EEDBBF"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 226.753L136.771 228.883V225.665L140.459 223.535V226.753Z",
    fill: "#EEDBBF"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 232.687L136.771 234.817V231.599L140.459 229.469V232.687Z",
    fill: "#EEDBBF"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 286.501L136.771 288.631V285.413L140.459 283.283V286.501Z",
    fill: "#EEDBBF"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 274.222L136.771 276.352V273.134L140.459 271.004V274.222Z",
    fill: "#EEDBBF"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 298.368L136.771 300.497V297.28L140.459 295.15V298.368Z",
    fill: "#EEDBBF"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 60.3313L144.42 62.4613V59.2433L148.109 57.1133V60.3313Z",
    fill: "#EEDBBF"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 280.567L136.771 282.697V279.479L140.459 277.35V280.567Z",
    fill: "#EEDBBF"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 292.434L136.771 294.564V291.346L140.459 289.217V292.434Z",
    fill: "#EEDBBF"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 180.385L144.42 182.515V179.297L148.109 177.168V180.385Z",
    fill: "#EEDBBF"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 97.7414L152.068 99.8714V96.6534L155.757 94.5234V97.7414Z",
    fill: "#EEDBBF"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 103.675L152.068 105.804V102.587L155.757 100.457V103.675Z",
    fill: "#EEDBBF"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 109.609L152.068 111.739V108.521L155.757 106.391V109.609Z",
    fill: "#EEDBBF"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 128.021L152.068 130.15V126.933L155.757 124.803V128.021Z",
    fill: "#EEDBBF"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 116.156L152.068 118.285V115.068L155.757 112.938V116.156Z",
    fill: "#EEDBBF"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 67.7766L152.068 69.9066V66.6886L155.757 64.5586V67.7766Z",
    fill: "#EEDBBF"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 79.6418L152.068 81.7718V78.5538L155.757 76.4238V79.6418Z",
    fill: "#EEDBBF"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 73.7092L152.068 75.8392V72.6212L155.757 70.4922V73.7092Z",
    fill: "#EEDBBF"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 85.5764L152.068 87.7064V84.4884L155.757 82.3594V85.5764Z",
    fill: "#EEDBBF"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 91.7493L152.068 93.8792V90.6613L155.757 88.5312V91.7493Z",
    fill: "#EEDBBF"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 122.087L152.068 124.217V120.999L155.757 118.869V122.087Z",
    fill: "#EEDBBF"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 175.964L152.068 178.094V174.876L155.757 172.746V175.964Z",
    fill: "#EEDBBF"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 164.097L152.068 166.227V163.009L155.757 160.879V164.097Z",
    fill: "#EEDBBF"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 170.031L152.068 172.16V168.942L155.757 166.812V170.031Z",
    fill: "#EEDBBF"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 181.898L152.068 184.027V180.81L155.757 178.68V181.898Z",
    fill: "#EEDBBF"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 133.954L152.068 136.084V132.866L155.757 130.736V133.954Z",
    fill: "#EEDBBF"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 187.831L152.068 189.961V186.743L155.757 184.613V187.831Z",
    fill: "#EEDBBF"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 145.822L152.068 147.952V144.734L155.757 142.604V145.822Z",
    fill: "#EEDBBF"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 139.888L152.068 142.017V138.8L155.757 136.67V139.888Z",
    fill: "#EEDBBF"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 158.163L152.068 160.293V157.075L155.757 154.945V158.163Z",
    fill: "#EEDBBF"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 152.229L152.068 154.359V151.141L155.757 149.012V152.229Z",
    fill: "#EEDBBF"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 246.065L144.42 248.195V244.977L148.109 242.848V246.065Z",
    fill: "#EEDBBF"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 240.132L144.42 242.261V239.044L148.109 236.914V240.132Z",
    fill: "#EEDBBF"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 234.199L144.42 236.329V233.111L148.109 230.982V234.199Z",
    fill: "#EEDBBF"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 251.999L144.42 254.129V250.911L148.109 248.781V251.999Z",
    fill: "#EEDBBF"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 263.866L144.42 265.995V262.778L148.109 260.648V263.866Z",
    fill: "#EEDBBF"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 257.933L144.42 260.063V256.845L148.109 254.715V257.933Z",
    fill: "#EEDBBF"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 210.054L144.42 212.183V208.965L148.109 206.836V210.054Z",
    fill: "#EEDBBF"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 228.265L144.42 230.395V227.177L148.109 225.047V228.265Z",
    fill: "#EEDBBF"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 216.398L144.42 218.528V215.31L148.109 213.18V216.398Z",
    fill: "#EEDBBF"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 222.332L144.42 224.462V221.244L148.109 219.115V222.332Z",
    fill: "#EEDBBF"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 288.013L144.42 290.142V286.924L148.109 284.795V288.013Z",
    fill: "#EEDBBF"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 299.879L144.42 302.009V298.792L148.109 296.662V299.879Z",
    fill: "#EEDBBF"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 55.9094L152.068 58.0394V54.8214L155.757 52.6914V55.9094Z",
    fill: "#EEDBBF"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 204.12L144.42 206.25V203.032L148.109 200.902V204.12Z",
    fill: "#EEDBBF"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 282.079L144.42 284.209V280.991L148.109 278.861V282.079Z",
    fill: "#EEDBBF"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 293.947L144.42 296.077V292.859L148.109 290.729V293.947Z",
    fill: "#EEDBBF"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 269.8L144.42 271.93V268.712L148.109 266.582V269.8Z",
    fill: "#EEDBBF"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M148.109 276.146L144.42 278.275V275.057L148.109 272.928V276.146Z",
    fill: "#EEDBBF"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 61.842L152.068 63.972V60.755L155.757 58.625V61.842Z",
    fill: "#EEDBBF"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 296.856L129.122 298.986V295.768L132.811 293.639V296.856Z",
    fill: "#EEDBBF"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 122.874L129.122 125.004V121.786L132.811 119.656V122.874Z",
    fill: "#EEDBBF"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 129.42L129.122 131.55V128.332L132.811 126.203V129.42Z",
    fill: "#EEDBBF"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 135.353L129.122 137.483V134.265L132.811 132.135V135.353Z",
    fill: "#EEDBBF"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 141.287L129.122 143.417V140.199L132.811 138.07V141.287Z",
    fill: "#EEDBBF"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 116.94L129.122 119.07V115.852L132.811 113.723V116.94Z",
    fill: "#EEDBBF"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 98.841L129.122 100.971V97.753L132.811 95.623V98.841Z",
    fill: "#EEDBBF"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 111.007L129.122 113.137V109.919L132.811 107.789V111.007Z",
    fill: "#EEDBBF"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 147.22L129.122 149.35V146.132L132.811 144.002V147.22Z",
    fill: "#EEDBBF"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 92.9094L129.122 95.0384V91.8214L132.811 89.6914V92.9094Z",
    fill: "#EEDBBF"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 105.015L129.122 107.145V103.927L132.811 101.797V105.015Z",
    fill: "#EEDBBF"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 86.9748L129.122 89.1048V85.8868L132.811 83.7578V86.9748Z",
    fill: "#EEDBBF"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 153.155L129.122 155.285V152.066L132.811 149.938V153.155Z",
    fill: "#EEDBBF"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 189.23L129.122 191.36V188.142L132.811 186.012V189.23Z",
    fill: "#EEDBBF"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 207.029L129.122 209.16V205.942L132.811 203.812V207.029Z",
    fill: "#EEDBBF"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 183.296L129.122 185.425V182.207L132.811 180.078V183.296Z",
    fill: "#EEDBBF"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 201.097L129.122 203.227V200.009L132.811 197.879V201.097Z",
    fill: "#EEDBBF"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 195.162L129.122 197.292V194.074L132.811 191.945V195.162Z",
    fill: "#EEDBBF"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 177.363L129.122 179.493V176.275L132.811 174.145V177.363Z",
    fill: "#EEDBBF"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 159.087L129.122 161.216V157.999L132.811 155.869V159.087Z",
    fill: "#EEDBBF"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 165.496L129.122 167.626V164.408L132.811 162.279V165.496Z",
    fill: "#EEDBBF"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 171.429L129.122 173.558V170.341L132.811 168.211V171.429Z",
    fill: "#EEDBBF"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 81.0422L129.122 83.1712V79.9542L132.811 77.8242V81.0422Z",
    fill: "#EEDBBF"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 245.283L247.29 247.413V244.195L250.979 242.066V245.283Z",
    fill: "#EEDBBF"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 251.63L247.29 253.76V250.542L250.979 248.412V251.63Z",
    fill: "#EEDBBF"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 239.351L247.29 241.48V238.263L250.979 236.133V239.351Z",
    fill: "#EEDBBF"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 257.563L247.29 259.693V256.475L250.979 254.346V257.563Z",
    fill: "#EEDBBF"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 263.497L247.29 265.626V262.409L250.979 260.279V263.497Z",
    fill: "#EEDBBF"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 233.416L247.29 235.546V232.328L250.979 230.199V233.416Z",
    fill: "#EEDBBF"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 215.616L247.29 217.746V214.528L250.979 212.398V215.616Z",
    fill: "#EEDBBF"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 221.55L247.29 223.679V220.461L250.979 218.332V221.55Z",
    fill: "#EEDBBF"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 275.365L247.29 277.493V274.276L250.979 272.146V275.365Z",
    fill: "#EEDBBF"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 227.484L247.29 229.614V226.396L250.979 224.266V227.484Z",
    fill: "#EEDBBF"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 212.964L129.122 215.094V211.876L132.811 209.746V212.964Z",
    fill: "#EEDBBF"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 202.608L136.771 204.738V201.52L140.459 199.391V202.608Z",
    fill: "#EEDBBF"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 69.175L129.122 71.305V68.087L132.811 65.957V69.175Z",
    fill: "#EEDBBF"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 75.1076L129.122 77.2376V74.0196L132.811 71.8906V75.1076Z",
    fill: "#EEDBBF"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 287.229L247.29 289.359V286.141L250.979 284.012V287.229Z",
    fill: "#EEDBBF"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 281.296L247.29 283.426V280.208L250.979 278.078V281.296Z",
    fill: "#EEDBBF"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 293.163L247.29 295.293V292.075L250.979 289.945V293.163Z",
    fill: "#EEDBBF"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 299.096L247.29 301.226V298.009L250.979 295.879V299.096Z",
    fill: "#EEDBBF"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 118.452L136.771 120.582V117.364L140.459 115.234V118.452Z",
    fill: "#EEDBBF"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 112.518L136.771 114.648V111.43L140.459 109.301V112.518Z",
    fill: "#EEDBBF"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 130.931L136.771 133.061V129.843L140.459 127.713V130.931Z",
    fill: "#EEDBBF"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 124.998L136.771 127.128V123.911L140.459 121.781V124.998Z",
    fill: "#EEDBBF"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 136.865L136.771 138.995V135.777L140.459 133.648V136.865Z",
    fill: "#EEDBBF"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 106.585L136.771 108.715V105.497L140.459 103.367V106.585Z",
    fill: "#EEDBBF"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 82.5529L136.771 84.6829V81.4649L140.459 79.3359V82.5529Z",
    fill: "#EEDBBF"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 88.4875L136.771 90.6175V87.3995L140.459 85.2695V88.4875Z",
    fill: "#EEDBBF"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 100.593L136.771 102.723V99.505L140.459 97.375V100.593Z",
    fill: "#EEDBBF"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 94.4192L136.771 96.5492V93.3312L140.459 91.2012V94.4192Z",
    fill: "#EEDBBF"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 167.007L136.771 169.136V165.919L140.459 163.789V167.007Z",
    fill: "#EEDBBF"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 142.798L136.771 144.928V141.71L140.459 139.58V142.798Z",
    fill: "#EEDBBF"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 178.874L136.771 181.003V177.786L140.459 175.656V178.874Z",
    fill: "#EEDBBF"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 190.741L136.771 192.87V189.653L140.459 187.523V190.741Z",
    fill: "#EEDBBF"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 172.941L136.771 175.071V171.853L140.459 169.723V172.941Z",
    fill: "#EEDBBF"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 196.675L136.771 198.805V195.587L140.459 193.457V196.675Z",
    fill: "#EEDBBF"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 184.808L136.771 186.938V183.72L140.459 181.59V184.808Z",
    fill: "#EEDBBF"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 154.665L136.771 156.795V153.577L140.459 151.447V154.665Z",
    fill: "#EEDBBF"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 218.897L129.122 221.027V217.809L132.811 215.68V218.897Z",
    fill: "#EEDBBF"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 209.683L247.29 211.812V208.595L250.979 206.465V209.683Z",
    fill: "#EEDBBF"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 76.6203L136.771 78.7503V75.5323L140.459 73.4023V76.6203Z",
    fill: "#EEDBBF"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 148.731L136.771 150.861V147.643L140.459 145.514V148.731Z",
    fill: "#EEDBBF"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 260.843L129.122 262.972V259.755L132.811 257.625V260.843Z",
    fill: "#EEDBBF"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 254.909L129.122 257.039V253.821L132.811 251.691V254.909Z",
    fill: "#EEDBBF"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 272.71L129.122 274.839V271.622L132.811 269.492V272.71Z",
    fill: "#EEDBBF"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 266.777L129.122 268.907V265.689L132.811 263.559V266.777Z",
    fill: "#EEDBBF"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 278.644L129.122 280.774V277.556L132.811 275.426V278.644Z",
    fill: "#EEDBBF"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 248.976L129.122 251.105V247.888L132.811 245.758V248.976Z",
    fill: "#EEDBBF"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 225.243L129.122 227.372V224.155L132.811 222.025V225.243Z",
    fill: "#EEDBBF"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 70.6867L136.771 72.8158V69.5977L140.459 67.4688V70.6867Z",
    fill: "#EEDBBF"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 243.042L129.122 245.172V241.954L132.811 239.824V243.042Z",
    fill: "#EEDBBF"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 237.111L129.122 239.24V236.023L132.811 233.893V237.111Z",
    fill: "#EEDBBF"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 231.175L129.122 233.305V230.087L132.811 227.957V231.175Z",
    fill: "#EEDBBF"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 64.7532L136.771 66.8832V63.6652L140.459 61.5352V64.7532Z",
    fill: "#EEDBBF"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 290.923L129.122 293.053V289.835L132.811 287.705V290.923Z",
    fill: "#EEDBBF"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 193.765L152.068 195.895V192.677L155.757 190.547V193.765Z",
    fill: "#EEDBBF"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M132.811 284.989L129.122 287.118V283.9L132.811 281.771V284.989Z",
    fill: "#EEDBBF"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 161.074L136.771 163.204V159.986L140.459 157.857V161.074Z",
    fill: "#EEDBBF"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 194.281L65.0098 196.411V193.193L68.6988 191.064V194.281Z",
    fill: "#EEDBBF"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 200.214L65.0098 202.343V199.126L68.6988 196.996V200.214Z",
    fill: "#EEDBBF"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 206.559L65.0098 208.689V205.471L68.6988 203.342V206.559Z",
    fill: "#EEDBBF"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 212.493L65.0098 214.622V211.405L68.6988 209.275V212.493Z",
    fill: "#EEDBBF"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 218.426L65.0098 220.556V217.338L68.6988 215.209V218.426Z",
    fill: "#EEDBBF"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 224.361L65.0098 226.49V223.273L68.6988 221.143V224.361Z",
    fill: "#EEDBBF"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 164.614L65.0098 166.744V163.526L68.6988 161.396V164.614Z",
    fill: "#EEDBBF"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 170.547L65.0098 172.677V169.459L68.6988 167.33V170.547Z",
    fill: "#EEDBBF"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 176.48L65.0098 178.61V175.392L68.6988 173.262V176.48Z",
    fill: "#EEDBBF"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 182.414L65.0098 184.544V181.326L68.6988 179.197V182.414Z",
    fill: "#EEDBBF"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 188.347L65.0098 190.477V187.259L68.6988 185.129V188.347Z",
    fill: "#EEDBBF"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 236.227L65.0098 238.357V235.139L68.6988 233.01V236.227Z",
    fill: "#EEDBBF"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 230.294L65.0098 232.424V229.206L68.6988 227.076V230.294Z",
    fill: "#EEDBBF"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 272.24L65.0098 274.37V271.152L68.6988 269.023V272.24Z",
    fill: "#EEDBBF"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 266.306L65.0098 268.436V265.218L68.6988 263.088V266.306Z",
    fill: "#EEDBBF"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 284.108L65.0098 286.238V283.02L68.6988 280.891V284.108Z",
    fill: "#EEDBBF"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 278.173L65.0098 280.302V277.085L68.6988 274.955V278.173Z",
    fill: "#EEDBBF"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 259.961L65.0098 262.091V258.874L68.6988 256.744V259.961Z",
    fill: "#EEDBBF"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 158.68L65.0098 160.81V157.592L68.6988 155.463V158.68Z",
    fill: "#EEDBBF"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 242.161L65.0098 244.291V241.073L68.6988 238.943V242.161Z",
    fill: "#EEDBBF"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 248.094L65.0098 250.224V247.007L68.6988 244.877V248.094Z",
    fill: "#EEDBBF"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 254.029L65.0098 256.159V252.941L68.6988 250.811V254.029Z",
    fill: "#EEDBBF"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 300.396L57.3604 302.526V299.308L61.0494 297.178V300.396Z",
    fill: "#EEDBBF"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 290.04L65.0098 292.169V288.952L68.6988 286.822V290.04Z",
    fill: "#EEDBBF"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 264.382L57.3604 266.512V263.294L61.0494 261.164V264.382Z",
    fill: "#EEDBBF"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 199.698L152.068 201.828V198.61L155.757 196.48V199.698Z",
    fill: "#EEDBBF"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 270.728L57.3604 272.858V269.64L61.0494 267.51V270.728Z",
    fill: "#EEDBBF"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 288.529L57.3604 290.659V287.441L61.0494 285.311V288.529Z",
    fill: "#EEDBBF"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 276.661L57.3604 278.791V275.573L61.0494 273.443V276.661Z",
    fill: "#EEDBBF"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 282.595L57.3604 284.724V281.507L61.0494 279.377V282.595Z",
    fill: "#EEDBBF"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 134.133L65.0098 136.263V133.045L68.6988 130.916V134.133Z",
    fill: "#EEDBBF"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 128.786L65.0098 130.915V127.698L68.6988 125.568V128.786Z",
    fill: "#EEDBBF"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 152.747L65.0098 154.877V151.659L68.6988 149.529V152.747Z",
    fill: "#EEDBBF"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 146.814L65.0098 148.943V145.726L68.6988 143.596V146.814Z",
    fill: "#EEDBBF"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 140.066L65.0098 142.195V138.978L68.6988 136.848V140.066Z",
    fill: "#EEDBBF"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 294.462L57.3604 296.591V293.374L61.0494 291.244V294.462Z",
    fill: "#EEDBBF"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 225.872L72.6582 228.002V224.784L76.3462 222.654V225.872Z",
    fill: "#EEDBBF"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 231.806L72.6582 233.935V230.718L76.3462 228.588V231.806Z",
    fill: "#EEDBBF"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 237.739L72.6582 239.869V236.651L76.3462 234.521V237.739Z",
    fill: "#EEDBBF"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 249.605L72.6582 251.735V248.517L76.3462 246.387V249.605Z",
    fill: "#EEDBBF"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 243.673L72.6582 245.802V242.585L76.3462 240.455V243.673Z",
    fill: "#EEDBBF"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 214.004L72.6582 216.134V212.916L76.3462 210.787V214.004Z",
    fill: "#EEDBBF"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 202.137L72.6582 204.267V201.049L76.3462 198.92V202.137Z",
    fill: "#EEDBBF"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 219.939L72.6582 222.068V218.851L76.3462 216.721V219.939Z",
    fill: "#EEDBBF"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 208.072L72.6582 210.202V206.984L76.3462 204.854V208.072Z",
    fill: "#EEDBBF"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 255.54L72.6582 257.669V254.451L76.3462 252.322V255.54Z",
    fill: "#EEDBBF"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 297.486L72.6582 299.616V296.398L76.3462 294.268V297.486Z",
    fill: "#EEDBBF"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 195.792L72.6582 197.922V194.704L76.3462 192.574V195.792Z",
    fill: "#EEDBBF"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 291.551L72.6582 293.681V290.463L76.3462 288.334V291.551Z",
    fill: "#EEDBBF"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 273.751L72.6582 275.881V272.663L76.3462 270.533V273.751Z",
    fill: "#EEDBBF"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 285.618L72.6582 287.748V284.53L76.3462 282.4V285.618Z",
    fill: "#EEDBBF"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 267.819L72.6582 269.949V266.731L76.3462 264.602V267.819Z",
    fill: "#EEDBBF"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 261.884L72.6582 264.013V260.796L76.3462 258.666V261.884Z",
    fill: "#EEDBBF"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 279.684L72.6582 281.814V278.596L76.3462 276.467V279.684Z",
    fill: "#EEDBBF"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 124.364L72.6582 126.493V123.276L76.3462 121.146V124.364Z",
    fill: "#EEDBBF"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6988 295.974L65.0098 298.104V294.886L68.6988 292.756V295.974Z",
    fill: "#EEDBBF"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 189.86L72.6582 191.99V188.772L76.3462 186.643V189.86Z",
    fill: "#EEDBBF"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 166.126L72.6582 168.255V165.038L76.3462 162.908V166.126Z",
    fill: "#EEDBBF"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 172.058L72.6582 174.188V170.97L76.3462 168.84V172.058Z",
    fill: "#EEDBBF"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 177.993L72.6582 180.122V176.904L76.3462 174.775V177.993Z",
    fill: "#EEDBBF"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 160.191L72.6582 162.321V159.103L76.3462 156.973V160.191Z",
    fill: "#EEDBBF"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 183.925L72.6582 186.055V182.837L76.3462 180.707V183.925Z",
    fill: "#EEDBBF"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 148.325L72.6582 150.455V147.237L76.3462 145.107V148.325Z",
    fill: "#EEDBBF"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 154.259L72.6582 156.388V153.171L76.3462 151.041V154.259Z",
    fill: "#EEDBBF"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 142.392L72.6582 144.521V141.304L76.3462 139.174V142.392Z",
    fill: "#EEDBBF"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 135.644L72.6582 137.774V134.556L76.3462 132.426V135.644Z",
    fill: "#EEDBBF"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3462 129.711L72.6582 131.841V128.623L76.3462 126.494V129.711Z",
    fill: "#EEDBBF"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 173.458L49.7129 175.588V172.37L53.4019 170.24V173.458Z",
    fill: "#EEDBBF"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 142.976L49.7129 145.106V141.888L53.4019 139.758V142.976Z",
    fill: "#EEDBBF"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 148.911L49.7129 151.04V147.823L53.4019 145.693V148.911Z",
    fill: "#EEDBBF"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 161.591L49.7129 163.721V160.503L53.4019 158.373V161.591Z",
    fill: "#EEDBBF"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 167.525L49.7129 169.654V166.436L53.4019 164.307V167.525Z",
    fill: "#EEDBBF"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 155.657L49.7129 157.786V154.569L53.4019 152.439V155.657Z",
    fill: "#EEDBBF"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 239.138L49.7129 241.268V238.05L53.4019 235.92V239.138Z",
    fill: "#EEDBBF"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 137.63L49.7129 139.759V136.542L53.4019 134.412V137.63Z",
    fill: "#EEDBBF"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 215.404L49.7129 217.534V214.316L53.4019 212.186V215.404Z",
    fill: "#EEDBBF"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 221.337L49.7129 223.466V220.248L53.4019 218.119V221.337Z",
    fill: "#EEDBBF"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 227.271L49.7129 229.401V226.183L53.4019 224.053V227.271Z",
    fill: "#EEDBBF"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 209.058L49.7129 211.188V207.97L53.4019 205.84V209.058Z",
    fill: "#EEDBBF"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 233.203L49.7129 235.333V232.116L53.4019 229.986V233.203Z",
    fill: "#EEDBBF"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 185.325L49.7129 187.455V184.237L53.4019 182.107V185.325Z",
    fill: "#EEDBBF"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 179.391L49.7129 181.521V178.303L53.4019 176.174V179.391Z",
    fill: "#EEDBBF"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 191.257L49.7129 193.387V190.169L53.4019 188.039V191.257Z",
    fill: "#EEDBBF"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 203.124L49.7129 205.254V202.036L53.4019 199.906V203.124Z",
    fill: "#EEDBBF"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 197.191L49.7129 199.321V196.103L53.4019 193.973V197.191Z",
    fill: "#EEDBBF"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 235.71L152.068 237.84V234.622L155.757 232.492V235.71Z",
    fill: "#EEDBBF"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 241.644L152.068 243.774V240.556L155.757 238.426V241.644Z",
    fill: "#EEDBBF"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 253.51L152.068 255.64V252.422L155.757 250.293V253.51Z",
    fill: "#EEDBBF"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 247.577L152.068 249.707V246.489L155.757 244.359V247.577Z",
    fill: "#EEDBBF"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 259.445L152.068 261.574V258.357L155.757 256.227V259.445Z",
    fill: "#EEDBBF"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 211.976L152.068 214.106V210.888L155.757 208.758V211.976Z",
    fill: "#EEDBBF"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 205.631L152.068 207.761V204.544L155.757 202.414V205.631Z",
    fill: "#EEDBBF"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 217.91L152.068 220.04V216.822L155.757 214.693V217.91Z",
    fill: "#EEDBBF"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 223.843L152.068 225.973V222.755L155.757 220.625V223.843Z",
    fill: "#EEDBBF"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 229.778L152.068 231.908V228.69L155.757 226.561V229.778Z",
    fill: "#EEDBBF"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 258.45L57.3604 260.58V257.362L61.0494 255.232V258.45Z",
    fill: "#EEDBBF"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 295.458L152.068 297.587V294.369L155.757 292.24V295.458Z",
    fill: "#EEDBBF"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 265.378L152.068 267.508V264.29L155.757 262.16V265.378Z",
    fill: "#EEDBBF"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 271.724L152.068 273.853V270.636L155.757 268.506V271.724Z",
    fill: "#EEDBBF"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 277.657L152.068 279.787V276.569L155.757 274.439V277.657Z",
    fill: "#EEDBBF"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 283.591L152.068 285.72V282.503L155.757 280.373V283.591Z",
    fill: "#EEDBBF"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M155.757 289.523L152.068 291.653V288.435L155.757 286.305V289.523Z",
    fill: "#EEDBBF"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 169.036L57.3604 171.166V167.948L61.0494 165.818V169.036Z",
    fill: "#EEDBBF"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 174.969L57.3604 177.099V173.882L61.0494 171.752V174.969Z",
    fill: "#EEDBBF"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 186.836L57.3604 188.966V185.748L61.0494 183.619V186.836Z",
    fill: "#EEDBBF"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 163.102L57.3604 165.232V162.015L61.0494 159.885V163.102Z",
    fill: "#EEDBBF"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 180.904L57.3604 183.034V179.816L61.0494 177.686V180.904Z",
    fill: "#EEDBBF"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 138.554L57.3604 140.684V137.466L61.0494 135.336V138.554Z",
    fill: "#EEDBBF"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 192.769L57.3604 194.899V191.681L61.0494 189.551V192.769Z",
    fill: "#EEDBBF"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 144.489L57.3604 146.618V143.401L61.0494 141.271V144.489Z",
    fill: "#EEDBBF"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 157.169L57.3604 159.299V156.081L61.0494 153.951V157.169Z",
    fill: "#EEDBBF"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 151.236L57.3604 153.365V150.148L61.0494 148.018V151.236Z",
    fill: "#EEDBBF"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 216.915L57.3604 219.044V215.827L61.0494 213.697V216.915Z",
    fill: "#EEDBBF"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 234.716L57.3604 236.846V233.628L61.0494 231.498V234.716Z",
    fill: "#EEDBBF"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 240.65L57.3604 242.779V239.562L61.0494 237.432V240.65Z",
    fill: "#EEDBBF"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 228.782L57.3604 230.911V227.694L61.0494 225.564V228.782Z",
    fill: "#EEDBBF"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 246.583L57.3604 248.713V245.495L61.0494 243.365V246.583Z",
    fill: "#EEDBBF"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 252.516L57.3604 254.646V251.428L61.0494 249.299V252.516Z",
    fill: "#EEDBBF"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 198.703L57.3604 200.833V197.615L61.0494 195.486V198.703Z",
    fill: "#EEDBBF"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 222.849L57.3604 224.979V221.761L61.0494 219.631V222.849Z",
    fill: "#EEDBBF"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 204.636L57.3604 206.765V203.548L61.0494 201.418V204.636Z",
    fill: "#EEDBBF"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 210.982L57.3604 213.112V209.894L61.0494 207.764V210.982Z",
    fill: "#EEDBBF"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0494 133.208L57.3604 135.337V132.12L61.0494 129.99V133.208Z",
    fill: "#EEDBBF"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 287.017L49.7129 289.146V285.929L53.4019 283.799V287.017Z",
    fill: "#EEDBBF"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 281.083L49.7129 283.213V279.995L53.4019 277.865V281.083Z",
    fill: "#EEDBBF"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 245.071L49.7129 247.201V243.983L53.4019 241.854V245.071Z",
    fill: "#EEDBBF"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 275.152L49.7129 277.281V274.064L53.4019 271.934V275.152Z",
    fill: "#EEDBBF"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 298.883L49.7129 301.013V297.796L53.4019 295.666V298.883Z",
    fill: "#EEDBBF"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 292.95L49.7129 295.08V291.862L53.4019 289.732V292.95Z",
    fill: "#EEDBBF"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 251.005L49.7129 253.135V249.917L53.4019 247.787V251.005Z",
    fill: "#EEDBBF"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 256.938L49.7129 259.068V255.85L53.4019 253.721V256.938Z",
    fill: "#EEDBBF"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 268.805L49.7129 270.935V267.717L53.4019 265.588V268.805Z",
    fill: "#EEDBBF"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4019 262.872L49.7129 265.001V261.784L53.4019 259.654V262.872Z",
    fill: "#EEDBBF"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 269.429L247.29 271.559V268.341L250.979 266.211V269.429Z",
    fill: "#EEDBBF"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 300.061L393.259 302.191V298.974L396.947 296.844V300.061Z",
    fill: "#EEDBBF"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 81.2121L400.906 83.3421V80.1241L404.595 77.9941V81.2121Z",
    fill: "#EEDBBF"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 270.394L393.259 272.524V269.306L396.947 267.176V270.394Z",
    fill: "#EEDBBF"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 87.1447L400.906 89.2747V86.0577L404.595 83.9277V87.1447Z",
    fill: "#EEDBBF"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 276.329L393.259 278.458V275.241L396.947 273.111V276.329Z",
    fill: "#EEDBBF"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 264.462L393.259 266.591V263.374L396.947 261.244V264.462Z",
    fill: "#EEDBBF"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 288.196L393.259 290.326V287.109L396.947 284.979V288.196Z",
    fill: "#EEDBBF"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 294.128L393.259 296.258V293.04L396.947 290.91V294.128Z",
    fill: "#EEDBBF"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 282.261L393.259 284.391V281.173L396.947 279.043V282.261Z",
    fill: "#EEDBBF"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 134.613L400.906 136.743V133.525L404.595 131.395V134.613Z",
    fill: "#EEDBBF"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 128.679L400.906 130.808V127.591L404.595 125.461V128.679Z",
    fill: "#EEDBBF"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 140.545L400.906 142.675V139.457L404.595 137.328V140.545Z",
    fill: "#EEDBBF"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 122.745L400.906 124.875V121.657L404.595 119.527V122.745Z",
    fill: "#EEDBBF"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 146.48L400.906 148.61V145.392L404.595 143.262V146.48Z",
    fill: "#EEDBBF"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 116.812L400.906 118.942V115.724L404.595 113.594V116.812Z",
    fill: "#EEDBBF"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 99.0119L400.906 101.142V97.9239L404.595 95.7949V99.0119Z",
    fill: "#EEDBBF"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 93.0793L400.906 95.2093V91.9913L404.595 89.8613V93.0793Z",
    fill: "#EEDBBF"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 104.947L400.906 107.077V103.859L404.595 101.729V104.947Z",
    fill: "#EEDBBF"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 110.879L400.906 113.009V109.791L404.595 107.662V110.879Z",
    fill: "#EEDBBF"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 162.769L393.259 164.898V161.681L396.947 159.551V162.769Z",
    fill: "#EEDBBF"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 168.701L393.259 170.831V167.613L396.947 165.484V168.701Z",
    fill: "#EEDBBF"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 174.636L393.259 176.766V173.548L396.947 171.418V174.636Z",
    fill: "#EEDBBF"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 152.412L400.906 154.542V151.324L404.595 149.195V152.412Z",
    fill: "#EEDBBF"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 180.569L393.259 182.699V179.481L396.947 177.352V180.569Z",
    fill: "#EEDBBF"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 258.529L393.259 260.659V257.441L396.947 255.311V258.529Z",
    fill: "#EEDBBF"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 192.848L393.259 194.978V191.76L396.947 189.631V192.848Z",
    fill: "#EEDBBF"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 156.834L393.259 158.964V155.746L396.947 153.617V156.834Z",
    fill: "#EEDBBF"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 139.034L393.259 141.164V137.946L396.947 135.816V139.034Z",
    fill: "#EEDBBF"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 144.968L393.259 147.097V143.879L396.947 141.75V144.968Z",
    fill: "#EEDBBF"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 150.902L393.259 153.032V149.814L396.947 147.684V150.902Z",
    fill: "#EEDBBF"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 186.503L393.259 188.632V185.415L396.947 183.285V186.503Z",
    fill: "#EEDBBF"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 240.316L393.259 242.445V239.228L396.947 237.098V240.316Z",
    fill: "#EEDBBF"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 234.381L393.259 236.511V233.293L396.947 231.164V234.381Z",
    fill: "#EEDBBF"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 246.248L393.259 248.378V245.16L396.947 243.031V246.248Z",
    fill: "#EEDBBF"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 198.782L393.259 200.911V197.694L396.947 195.564V198.782Z",
    fill: "#EEDBBF"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 228.448L393.259 230.578V227.36L396.947 225.23V228.448Z",
    fill: "#EEDBBF"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 252.595L393.259 254.725V251.507L396.947 249.377V252.595Z",
    fill: "#EEDBBF"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 210.648L393.259 212.777V209.56L396.947 207.43V210.648Z",
    fill: "#EEDBBF"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 204.714L393.259 206.844V203.626L396.947 201.496V204.714Z",
    fill: "#EEDBBF"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 222.514L393.259 224.644V221.426L396.947 219.297V222.514Z",
    fill: "#EEDBBF"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 216.581L393.259 218.711V215.493L396.947 213.363V216.581Z",
    fill: "#EEDBBF"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 136.267L309.767 138.397V135.179L313.456 133.049V136.267Z",
    fill: "#EEDBBF"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 70.9993L309.767 73.1292V69.9113L313.456 67.7812V70.9993Z",
    fill: "#EEDBBF"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 65.0647L309.767 67.1947V63.9767L313.456 61.8477V65.0647Z",
    fill: "#EEDBBF"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 76.9318L309.767 79.0618V75.8438L313.456 73.7148V76.9318Z",
    fill: "#EEDBBF"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 88.7981L309.767 90.9281V87.7101L313.456 85.5801V88.7981Z",
    fill: "#EEDBBF"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 82.8664L309.767 84.9954V81.7784L313.456 79.6484V82.8664Z",
    fill: "#EEDBBF"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 59.1321L309.767 61.2621V58.0441L313.456 55.9141V59.1321Z",
    fill: "#EEDBBF"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 295.64L400.906 297.769V294.551L404.595 292.422V295.64Z",
    fill: "#EEDBBF"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 289.706L400.906 291.836V288.618L404.595 286.488V289.706Z",
    fill: "#EEDBBF"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 130.332L309.767 132.462V129.244L313.456 127.115V130.332Z",
    fill: "#EEDBBF"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 133.101L393.259 135.23V132.013L396.947 129.883V133.101Z",
    fill: "#EEDBBF"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 148.609L309.767 150.738V147.521L313.456 145.391V148.609Z",
    fill: "#EEDBBF"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 158.347L400.906 160.477V157.259L404.595 155.129V158.347Z",
    fill: "#EEDBBF"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 94.7317L309.767 96.8607V93.6437L313.456 91.5137V94.7317Z",
    fill: "#EEDBBF"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 142.674L309.767 144.804V141.586L313.456 139.457V142.674Z",
    fill: "#EEDBBF"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 118.465L309.767 120.595V117.378L313.456 115.248V118.465Z",
    fill: "#EEDBBF"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 106.599L309.767 108.728V105.511L313.456 103.381V106.599Z",
    fill: "#EEDBBF"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 100.665L309.767 102.795V99.5773L313.456 97.4473V100.665Z",
    fill: "#EEDBBF"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 112.532L309.767 114.662V111.444L313.456 109.314V112.532Z",
    fill: "#EEDBBF"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 124.4L309.767 126.53V123.312L313.456 121.182V124.4Z",
    fill: "#EEDBBF"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 188.426L400.906 190.556V187.338L404.595 185.209V188.426Z",
    fill: "#EEDBBF"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 200.293L400.906 202.423V199.205L404.595 197.076V200.293Z",
    fill: "#EEDBBF"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 194.361L400.906 196.49V193.273L404.595 191.143V194.361Z",
    fill: "#EEDBBF"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 206.226L400.906 208.355V205.138L404.595 203.008V206.226Z",
    fill: "#EEDBBF"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 212.159L400.906 214.289V211.071L404.595 208.941V212.159Z",
    fill: "#EEDBBF"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 182.081L400.906 184.21V180.993L404.595 178.863V182.081Z",
    fill: "#EEDBBF"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 164.281L400.906 166.41V163.191L404.595 161.062V164.281Z",
    fill: "#EEDBBF"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 170.214L400.906 172.344V169.126L404.595 166.996V170.214Z",
    fill: "#EEDBBF"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 176.147L400.906 178.277V175.059L404.595 172.93V176.147Z",
    fill: "#EEDBBF"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 218.093L400.906 220.222V217.004L404.595 214.875V218.093Z",
    fill: "#EEDBBF"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 277.839L400.906 279.969V276.751L404.595 274.621V277.839Z",
    fill: "#EEDBBF"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 260.04L400.906 262.169V258.952L404.595 256.822V260.04Z",
    fill: "#EEDBBF"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 265.973L400.906 268.103V264.885L404.595 262.756V265.973Z",
    fill: "#EEDBBF"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 254.106L400.906 256.236V253.018L404.595 250.889V254.106Z",
    fill: "#EEDBBF"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 283.772L400.906 285.902V282.684L404.595 280.555V283.772Z",
    fill: "#EEDBBF"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 271.907L400.906 274.036V270.819L404.595 268.689V271.907Z",
    fill: "#EEDBBF"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 241.826L400.906 243.956V240.738L404.595 238.609V241.826Z",
    fill: "#EEDBBF"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 248.173L400.906 250.303V247.085L404.595 244.955V248.173Z",
    fill: "#EEDBBF"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 235.894L400.906 238.024V234.806L404.595 232.676V235.894Z",
    fill: "#EEDBBF"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 229.96L400.906 232.09V228.872L404.595 226.742V229.96Z",
    fill: "#EEDBBF"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 224.027L400.906 226.157V222.939L404.595 220.809V224.027Z",
    fill: "#EEDBBF"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 258.408L449.432 256.278V253.061L453.121 255.19V258.408Z",
    fill: "#EEDBBF"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 278.131L441.783 276.001V272.783L445.472 274.913V278.131Z",
    fill: "#EEDBBF"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 253.986L441.783 251.856V248.639L445.472 250.768V253.986Z",
    fill: "#EEDBBF"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 272.199L441.783 270.07V266.852L445.472 268.982V272.199Z",
    fill: "#EEDBBF"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 265.852L441.783 263.722V260.504L445.472 262.634V265.852Z",
    fill: "#EEDBBF"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 212.452L441.783 210.322V207.104L445.472 209.234V212.452Z",
    fill: "#EEDBBF"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 218.384L441.783 216.255V213.037L445.472 215.166V218.384Z",
    fill: "#EEDBBF"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 224.319L441.783 222.189V218.971L445.472 221.101V224.319Z",
    fill: "#EEDBBF"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 236.186L441.783 234.056V230.838L445.472 232.968V236.186Z",
    fill: "#EEDBBF"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 230.251L441.783 228.121V224.904L445.472 227.033V230.251Z",
    fill: "#EEDBBF"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 242.118L441.783 239.988V236.771L445.472 238.901V242.118Z",
    fill: "#EEDBBF"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 259.919L441.783 257.79V254.572L445.472 256.702V259.919Z",
    fill: "#EEDBBF"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 284.064L441.783 281.935V278.717L445.472 280.847V284.064Z",
    fill: "#EEDBBF"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 295.931L441.783 293.802V290.584L445.472 292.714V295.931Z",
    fill: "#EEDBBF"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 289.998L441.783 287.868V284.65L445.472 286.78V289.998Z",
    fill: "#EEDBBF"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 301.866L441.783 299.736V296.518L445.472 298.648V301.866Z",
    fill: "#EEDBBF"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 248.053L441.783 245.923V242.705L445.472 244.835V248.053Z",
    fill: "#EEDBBF"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 134.43L441.783 132.3V129.082L445.472 131.212V134.43Z",
    fill: "#EEDBBF"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 140.363L441.783 138.234V135.016L445.472 137.146V140.363Z",
    fill: "#EEDBBF"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 128.495L441.783 126.366V123.148L445.472 125.278V128.495Z",
    fill: "#EEDBBF"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 164.572L441.783 162.443V159.225L445.472 161.354V164.572Z",
    fill: "#EEDBBF"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 188.305L441.783 186.175V182.957L445.472 185.087V188.305Z",
    fill: "#EEDBBF"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 182.372L441.783 180.243V177.025L445.472 179.155V182.372Z",
    fill: "#EEDBBF"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 200.173L441.783 198.043V194.826L445.472 196.955V200.173Z",
    fill: "#EEDBBF"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 176.439L441.783 174.309V171.092L445.472 173.221V176.439Z",
    fill: "#EEDBBF"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 194.24L441.783 192.111V188.893L445.472 191.023V194.24Z",
    fill: "#EEDBBF"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 152.704L441.783 150.575V147.357L445.472 149.486V152.704Z",
    fill: "#EEDBBF"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 158.639L441.783 156.509V153.291L445.472 155.421V158.639Z",
    fill: "#EEDBBF"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 146.297L441.783 144.167V140.949L445.472 143.079V146.297Z",
    fill: "#EEDBBF"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 206.105L441.783 203.976V200.758L445.472 202.888V206.105Z",
    fill: "#EEDBBF"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M445.472 170.505L441.783 168.376V165.158L445.472 167.288V170.505Z",
    fill: "#EEDBBF"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 192.727L449.432 190.597V187.379L453.121 189.509V192.727Z",
    fill: "#EEDBBF"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 294.42L449.432 292.29V289.072L453.121 291.202V294.42Z",
    fill: "#EEDBBF"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 288.488L449.432 286.358V283.141L453.121 285.271V288.488Z",
    fill: "#EEDBBF"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 300.353L449.432 298.223V295.006L453.121 297.135V300.353Z",
    fill: "#EEDBBF"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 282.553L449.432 280.423V277.205L453.121 279.335V282.553Z",
    fill: "#EEDBBF"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 276.62L449.432 274.491V271.273L453.121 273.403V276.62Z",
    fill: "#EEDBBF"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 154.542L309.767 156.672V153.454L313.456 151.324V154.542Z",
    fill: "#EEDBBF"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 264.341L449.432 262.212V258.994L453.121 261.124V264.341Z",
    fill: "#EEDBBF"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 270.274L449.432 268.144V264.926L453.121 267.056V270.274Z",
    fill: "#EEDBBF"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 121.236L393.259 123.365V120.148L396.947 118.018V121.236Z",
    fill: "#EEDBBF"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 109.368L393.259 111.497V108.28L396.947 106.15V109.368Z",
    fill: "#EEDBBF"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 115.3L393.259 117.43V114.212L396.947 112.082V115.3Z",
    fill: "#EEDBBF"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 252.475L449.432 250.345V247.127L453.121 249.257V252.475Z",
    fill: "#EEDBBF"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 97.5012L393.259 99.6312V96.4132L396.947 94.2832V97.5012Z",
    fill: "#EEDBBF"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 103.433L393.259 105.563V102.345L396.947 100.215V103.433Z",
    fill: "#EEDBBF"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 91.5666L393.259 93.6966V90.4786L396.947 88.3496V91.5666Z",
    fill: "#EEDBBF"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 85.634L393.259 87.764V84.546L396.947 82.416V85.634Z",
    fill: "#EEDBBF"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M404.595 75.3518L400.906 77.4818V74.2638L404.595 72.1348V75.3518Z",
    fill: "#EEDBBF"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 79.7736L393.259 81.9036V78.6856L396.947 76.5566V79.7736Z",
    fill: "#EEDBBF"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 234.673L449.432 232.543V229.326L453.121 231.455V234.673Z",
    fill: "#EEDBBF"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 150.719L449.432 148.589V145.371L453.121 147.501V150.719Z",
    fill: "#EEDBBF"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 157.126L449.432 154.996V151.779L453.121 153.908V157.126Z",
    fill: "#EEDBBF"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 163.061L449.432 160.931V157.713L453.121 159.843V163.061Z",
    fill: "#EEDBBF"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 174.928L449.432 172.798V169.58L453.121 171.71V174.928Z",
    fill: "#EEDBBF"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 168.993L449.432 166.863V163.646L453.121 165.775V168.993Z",
    fill: "#EEDBBF"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 180.861L449.432 178.731V175.514L453.121 177.643V180.861Z",
    fill: "#EEDBBF"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 132.917L449.432 130.787V127.57L453.121 129.7V132.917Z",
    fill: "#EEDBBF"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 144.785L449.432 142.654V139.438L453.121 141.567V144.785Z",
    fill: "#EEDBBF"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 138.852L449.432 136.722V133.504L453.121 135.634V138.852Z",
    fill: "#EEDBBF"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 210.527L449.432 208.397V205.18L453.121 207.31V210.527Z",
    fill: "#EEDBBF"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 216.873L449.432 214.743V211.525L453.121 213.655V216.873Z",
    fill: "#EEDBBF"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 228.741L449.432 226.611V223.393L453.121 225.523V228.741Z",
    fill: "#EEDBBF"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 222.806L449.432 220.676V217.459L453.121 219.588V222.806Z",
    fill: "#EEDBBF"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 186.794L449.432 184.665V181.447L453.121 183.577V186.794Z",
    fill: "#EEDBBF"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 240.608L449.432 238.478V235.26L453.121 237.39V240.608Z",
    fill: "#EEDBBF"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M396.947 127.167L393.259 129.297V126.079L396.947 123.949V127.167Z",
    fill: "#EEDBBF"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 198.661L449.432 196.532V193.314L453.121 195.444V198.661Z",
    fill: "#EEDBBF"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 204.594L449.432 202.464V199.246L453.121 201.376V204.594Z",
    fill: "#EEDBBF"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M453.121 246.541L449.432 244.411V241.193L453.121 243.323V246.541Z",
    fill: "#EEDBBF"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 167.737L247.29 169.867V166.649L250.979 164.52V167.737Z",
    fill: "#EEDBBF"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 271.124L325.063 273.254V270.036L328.752 267.906V271.124Z",
    fill: "#EEDBBF"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 94.6125L239.643 96.7425V93.5245L243.332 91.3945V94.6125Z",
    fill: "#EEDBBF"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 288.924L325.063 291.054V287.836L328.752 285.707V288.924Z",
    fill: "#EEDBBF"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 277.057L325.063 279.187V275.969L328.752 273.84V277.057Z",
    fill: "#EEDBBF"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 282.991L325.063 285.121V281.903L328.752 279.773V282.991Z",
    fill: "#EEDBBF"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 294.859L325.063 296.989V293.771L328.752 291.641V294.859Z",
    fill: "#EEDBBF"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 106.89L239.643 109.02V105.802L243.332 103.672V106.89Z",
    fill: "#EEDBBF"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 100.958L239.643 103.087V99.8702L243.332 97.7402V100.958Z",
    fill: "#EEDBBF"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 148.424L239.643 150.554V147.336L243.332 145.207V148.424Z",
    fill: "#EEDBBF"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 154.359L239.643 156.489V153.271L243.332 151.141V154.359Z",
    fill: "#EEDBBF"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 142.491L239.643 144.621V141.403L243.332 139.273V142.491Z",
    fill: "#EEDBBF"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 166.226L239.643 168.355V165.138L243.332 163.008V166.226Z",
    fill: "#EEDBBF"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 112.825L239.643 114.954V111.737L243.332 109.607V112.825Z",
    fill: "#EEDBBF"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 160.476L309.767 162.605V159.388L313.456 157.258V160.476Z",
    fill: "#EEDBBF"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 118.757L239.643 120.887V117.669L243.332 115.539V118.757Z",
    fill: "#EEDBBF"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 124.69L239.643 126.82V123.603L243.332 121.473V124.69Z",
    fill: "#EEDBBF"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 130.624L239.643 132.754V129.536L243.332 127.406V130.624Z",
    fill: "#EEDBBF"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 136.557L239.643 138.687V135.469L243.332 133.34V136.557Z",
    fill: "#EEDBBF"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 199.51L325.063 201.64V198.422L328.752 196.293V199.51Z",
    fill: "#EEDBBF"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 175.366L325.063 177.495V174.278L328.752 172.148V175.366Z",
    fill: "#EEDBBF"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 181.298L325.063 183.428V180.21L328.752 178.08V181.298Z",
    fill: "#EEDBBF"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 187.231L325.063 189.361V186.144L328.752 184.014V187.231Z",
    fill: "#EEDBBF"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 193.577L325.063 195.707V192.489L328.752 190.359V193.577Z",
    fill: "#EEDBBF"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 139.765L325.063 141.895V138.677L328.752 136.547V139.765Z",
    fill: "#EEDBBF"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 169.431L325.063 171.561V168.343L328.752 166.213V169.431Z",
    fill: "#EEDBBF"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 151.632L325.063 153.762V150.544L328.752 148.414V151.632Z",
    fill: "#EEDBBF"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 265.19L325.063 267.32V264.102L328.752 261.973V265.19Z",
    fill: "#EEDBBF"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 157.565L325.063 159.695V156.477L328.752 154.348V157.565Z",
    fill: "#EEDBBF"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 163.499L325.063 165.628V162.411L328.752 160.281V163.499Z",
    fill: "#EEDBBF"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 145.697L325.063 147.827V144.609L328.752 142.48V145.697Z",
    fill: "#EEDBBF"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 246.978L325.063 249.108V245.89L328.752 243.76V246.978Z",
    fill: "#EEDBBF"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 241.046L325.063 243.176V239.958L328.752 237.828V241.046Z",
    fill: "#EEDBBF"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 259.257L325.063 261.387V258.169L328.752 256.039V259.257Z",
    fill: "#EEDBBF"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 253.324L325.063 255.454V252.237L328.752 250.107V253.324Z",
    fill: "#EEDBBF"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 235.112L325.063 237.242V234.024L328.752 231.895V235.112Z",
    fill: "#EEDBBF"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 217.312L325.063 219.442V216.224L328.752 214.094V217.312Z",
    fill: "#EEDBBF"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 229.179L325.063 231.309V228.091L328.752 225.961V229.179Z",
    fill: "#EEDBBF"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 211.377L325.063 213.507V210.289L328.752 208.16V211.377Z",
    fill: "#EEDBBF"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 205.445L325.063 207.575V204.357L328.752 202.227V205.445Z",
    fill: "#EEDBBF"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 223.245L325.063 225.375V222.157L328.752 220.027V223.245Z",
    fill: "#EEDBBF"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 172.159L239.643 174.289V171.071L243.332 168.941V172.159Z",
    fill: "#EEDBBF"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 114.335L247.29 116.465V113.247L250.979 111.117V114.335Z",
    fill: "#EEDBBF"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 138.07L247.29 140.2V136.982L250.979 134.852V138.07Z",
    fill: "#EEDBBF"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 120.269L247.29 122.398V119.181L250.979 117.051V120.269Z",
    fill: "#EEDBBF"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 132.136L247.29 134.265V131.047L250.979 128.918V132.136Z",
    fill: "#EEDBBF"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 126.202L247.29 128.332V125.114L250.979 122.984V126.202Z",
    fill: "#EEDBBF"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 108.404L247.29 110.533V107.316L250.979 105.186V108.404Z",
    fill: "#EEDBBF"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 90.1897L247.29 92.3197V89.1017L250.979 86.9727V90.1897Z",
    fill: "#EEDBBF"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 96.5364L247.29 98.6654V95.4484L250.979 93.3184V96.5364Z",
    fill: "#EEDBBF"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 102.469L247.29 104.599V101.381L250.979 99.252V102.469Z",
    fill: "#EEDBBF"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 173.671L247.29 175.801V172.583L250.979 170.453V173.671Z",
    fill: "#EEDBBF"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 144.002L247.29 146.132V142.914L250.979 140.785V144.002Z",
    fill: "#EEDBBF"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 185.538L247.29 187.667V184.45L250.979 182.32V185.538Z",
    fill: "#EEDBBF"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 191.882L247.29 194.012V190.794L250.979 188.664V191.882Z",
    fill: "#EEDBBF"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 197.816L247.29 199.945V196.728L250.979 194.598V197.816Z",
    fill: "#EEDBBF"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 179.604L247.29 181.734V178.516L250.979 176.387V179.604Z",
    fill: "#EEDBBF"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 203.749L247.29 205.879V202.661L250.979 200.531V203.749Z",
    fill: "#EEDBBF"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 155.869L247.29 157.999V154.781L250.979 152.652V155.869Z",
    fill: "#EEDBBF"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 149.937L247.29 152.067V148.849L250.979 146.719V149.937Z",
    fill: "#EEDBBF"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M250.979 161.804L247.29 163.934V160.716L250.979 158.586V161.804Z",
    fill: "#EEDBBF"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 291.654L239.643 293.783V290.566L243.332 288.436V291.654Z",
    fill: "#EEDBBF"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 220.038L239.643 222.168V218.95L243.332 216.82V220.038Z",
    fill: "#EEDBBF"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 214.104L239.643 216.234V213.017L243.332 210.887V214.104Z",
    fill: "#EEDBBF"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 231.906L239.643 234.035V230.817L243.332 228.688V231.906Z",
    fill: "#EEDBBF"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 208.171L239.643 210.301V207.083L243.332 204.953V208.171Z",
    fill: "#EEDBBF"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 225.971L239.643 228.101V224.883L243.332 222.754V225.971Z",
    fill: "#EEDBBF"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 184.026L239.643 186.156V182.938L243.332 180.809V184.026Z",
    fill: "#EEDBBF"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 189.96L239.643 192.089V188.872L243.332 186.742V189.96Z",
    fill: "#EEDBBF"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 237.838L239.643 239.968V236.75L243.332 234.621V237.838Z",
    fill: "#EEDBBF"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 196.304L239.643 198.434V195.216L243.332 193.086V196.304Z",
    fill: "#EEDBBF"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 202.238L239.643 204.368V201.151L243.332 199.021V202.238Z",
    fill: "#EEDBBF"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 178.093L239.643 180.223V177.005L243.332 174.875V178.093Z",
    fill: "#EEDBBF"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 279.785L239.643 281.915V278.698L243.332 276.568V279.785Z",
    fill: "#EEDBBF"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 285.718L239.643 287.848V284.63L243.332 282.5V285.718Z",
    fill: "#EEDBBF"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 243.773L239.643 245.903V242.685L243.332 240.555V243.773Z",
    fill: "#EEDBBF"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 297.585L239.643 299.715V296.497L243.332 294.367V297.585Z",
    fill: "#EEDBBF"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 273.851L239.643 275.981V272.763L243.332 270.633V273.851Z",
    fill: "#EEDBBF"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 256.052L239.643 258.181V254.964L243.332 252.834V256.052Z",
    fill: "#EEDBBF"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 267.919L239.643 270.048V266.831L243.332 264.701V267.919Z",
    fill: "#EEDBBF"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 249.705L239.643 251.835V248.617L243.332 246.488V249.705Z",
    fill: "#EEDBBF"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 261.986L239.643 264.116V260.898L243.332 258.768V261.986Z",
    fill: "#EEDBBF"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M243.332 160.291L239.643 162.421V159.203L243.332 157.074V160.291Z",
    fill: "#EEDBBF"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 78.4446L317.414 80.5736V77.3566L321.103 75.2266V78.4446Z",
    fill: "#EEDBBF"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 54.7102L317.414 56.8402V53.6222L321.103 51.4922V54.7102Z",
    fill: "#EEDBBF"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 60.6438L317.414 62.7728V59.5548L321.103 57.4258V60.6438Z",
    fill: "#EEDBBF"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 72.51L317.414 74.64V71.422L321.103 69.293V72.51Z",
    fill: "#EEDBBF"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 66.5774L317.414 68.7074V65.4894L321.103 63.3594V66.5774Z",
    fill: "#EEDBBF"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 291.835L309.767 293.965V290.747L313.456 288.617V291.835Z",
    fill: "#EEDBBF"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 297.768L309.767 299.898V296.68L313.456 294.551V297.768Z",
    fill: "#EEDBBF"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 114.044L317.414 116.173V112.955L321.103 110.826V114.044Z",
    fill: "#EEDBBF"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 125.91L317.414 128.04V124.823L321.103 122.693V125.91Z",
    fill: "#EEDBBF"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 119.978L317.414 122.108V118.89L321.103 116.76V119.978Z",
    fill: "#EEDBBF"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 138.252L317.414 140.382V137.164L321.103 135.035V138.252Z",
    fill: "#EEDBBF"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 131.845L317.414 133.975V130.757L321.103 128.627V131.845Z",
    fill: "#EEDBBF"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 96.2434L317.414 98.3734V95.1554L321.103 93.0254V96.2434Z",
    fill: "#EEDBBF"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 90.3098L317.414 92.4388V89.2218L321.103 87.0918V90.3098Z",
    fill: "#EEDBBF"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 84.3772L317.414 86.5072V83.2892L321.103 81.1602V84.3772Z",
    fill: "#EEDBBF"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 102.177L317.414 104.306V101.089L321.103 98.959V102.177Z",
    fill: "#EEDBBF"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 108.111L317.414 110.241V107.023L321.103 104.893V108.111Z",
    fill: "#EEDBBF"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 208.354L309.767 210.484V207.266L313.456 205.137V208.354Z",
    fill: "#EEDBBF"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 190.142L309.767 192.272V189.054L313.456 186.924V190.142Z",
    fill: "#EEDBBF"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 220.221L309.767 222.351V219.133L313.456 217.004V220.221Z",
    fill: "#EEDBBF"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 196.076L309.767 198.206V194.988L313.456 192.859V196.076Z",
    fill: "#EEDBBF"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 144.187L317.414 146.317V143.099L321.103 140.969V144.187Z",
    fill: "#EEDBBF"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 214.288L309.767 216.418V213.2L313.456 211.07V214.288Z",
    fill: "#EEDBBF"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 202.421L309.767 204.551V201.333L313.456 199.203V202.421Z",
    fill: "#EEDBBF"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 166.409L309.767 168.539V165.321L313.456 163.191V166.409Z",
    fill: "#EEDBBF"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 184.21L309.767 186.339V183.122L313.456 180.992V184.21Z",
    fill: "#EEDBBF"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 172.343L309.767 174.472V171.255L313.456 169.125V172.343Z",
    fill: "#EEDBBF"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 178.277L309.767 180.407V177.189L313.456 175.059V178.277Z",
    fill: "#EEDBBF"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 255.823L309.767 257.953V254.735L313.456 252.605V255.823Z",
    fill: "#EEDBBF"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 262.168L309.767 264.298V261.081L313.456 258.951V262.168Z",
    fill: "#EEDBBF"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 285.903L309.767 288.033V284.816L313.456 282.686V285.903Z",
    fill: "#EEDBBF"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 226.156L309.767 228.285V225.067L313.456 222.938V226.156Z",
    fill: "#EEDBBF"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 274.035L309.767 276.165V272.947L313.456 270.818V274.035Z",
    fill: "#EEDBBF"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 279.968L309.767 282.098V278.88L313.456 276.75V279.968Z",
    fill: "#EEDBBF"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 268.101L309.767 270.231V267.013L313.456 264.883V268.101Z",
    fill: "#EEDBBF"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 249.889L309.767 252.019V248.801L313.456 246.672V249.889Z",
    fill: "#EEDBBF"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 232.088L309.767 234.218V231L313.456 228.871V232.088Z",
    fill: "#EEDBBF"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 238.023L309.767 240.152V236.935L313.456 234.805V238.023Z",
    fill: "#EEDBBF"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M313.456 243.956L309.767 246.086V242.868L313.456 240.738V243.956Z",
    fill: "#EEDBBF"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 173.853L317.414 175.983V172.765L321.103 170.635V173.853Z",
    fill: "#EEDBBF"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 50.2883L325.063 52.4183V49.2003L328.752 47.0703V50.2883Z",
    fill: "#EEDBBF"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 56.2219L325.063 58.3509V55.1329L328.752 53.0039V56.2219Z",
    fill: "#EEDBBF"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 62.1555L325.063 64.2855V61.0675L328.752 58.9375V62.1555Z",
    fill: "#EEDBBF"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 68.0891L325.063 70.2181V67.0001L328.752 64.8711V68.0891Z",
    fill: "#EEDBBF"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 287.413L317.414 289.542V286.325L321.103 284.195V287.413Z",
    fill: "#EEDBBF"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 293.346L317.414 295.476V292.258L321.103 290.129V293.346Z",
    fill: "#EEDBBF"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 299.281L317.414 301.411V298.193L321.103 296.062V299.281Z",
    fill: "#EEDBBF"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 109.622L325.063 111.751V108.534L328.752 106.404V109.622Z",
    fill: "#EEDBBF"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 103.689L325.063 105.819V102.601L328.752 100.471V103.689Z",
    fill: "#EEDBBF"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 115.556L325.063 117.686V114.468L328.752 112.338V115.556Z",
    fill: "#EEDBBF"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 281.479L317.414 283.609V280.391L321.103 278.262V281.479Z",
    fill: "#EEDBBF"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 127.423L325.063 129.553V126.335L328.752 124.205V127.423Z",
    fill: "#EEDBBF"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 121.489L325.063 123.618V120.4L328.752 118.271V121.489Z",
    fill: "#EEDBBF"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 74.0207L325.063 76.1497V72.9327L328.752 70.8027V74.0207Z",
    fill: "#EEDBBF"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 79.9553L325.063 82.0853V78.8673L328.752 76.7383V79.9553Z",
    fill: "#EEDBBF"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 85.8879L325.063 88.0179V84.7999L328.752 82.6699V85.8879Z",
    fill: "#EEDBBF"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 91.8215L325.063 93.9515V90.7335L328.752 88.6035V91.8215Z",
    fill: "#EEDBBF"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 97.7551L325.063 99.8841V96.6671L328.752 94.5371V97.7551Z",
    fill: "#EEDBBF"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 167.921L317.414 170.05V166.833L321.103 164.703V167.921Z",
    fill: "#EEDBBF"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 185.72L317.414 187.85V184.632L321.103 182.502V185.72Z",
    fill: "#EEDBBF"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 209.866L317.414 211.996V208.778L321.103 206.648V209.866Z",
    fill: "#EEDBBF"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 197.999L317.414 200.129V196.911L321.103 194.781V197.999Z",
    fill: "#EEDBBF"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 179.788L317.414 181.917V178.699L321.103 176.57V179.788Z",
    fill: "#EEDBBF"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 203.932L317.414 206.062V202.844L321.103 200.715V203.932Z",
    fill: "#EEDBBF"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 191.656L317.414 193.785V190.566L321.103 188.438V191.656Z",
    fill: "#EEDBBF"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 156.054L317.414 158.183V154.966L321.103 152.836V156.054Z",
    fill: "#EEDBBF"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M328.752 133.83L325.063 135.96V132.742L328.752 130.613V133.83Z",
    fill: "#EEDBBF"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 161.987L317.414 164.117V160.899L321.103 158.77V161.987Z",
    fill: "#EEDBBF"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 150.12L317.414 152.25V149.032L321.103 146.902V150.12Z",
    fill: "#EEDBBF"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 245.468L317.414 247.597V244.38L321.103 242.25V245.468Z",
    fill: "#EEDBBF"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 275.546L317.414 277.676V274.458L321.103 272.328V275.546Z",
    fill: "#EEDBBF"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 251.402L317.414 253.532V250.314L321.103 248.184V251.402Z",
    fill: "#EEDBBF"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 257.747L317.414 259.876V256.659L321.103 254.529V257.747Z",
    fill: "#EEDBBF"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 263.679L317.414 265.809V262.591L321.103 260.461V263.679Z",
    fill: "#EEDBBF"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 269.615L317.414 271.743V268.526L321.103 266.396V269.615Z",
    fill: "#EEDBBF"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 227.666L317.414 229.796V226.578L321.103 224.449V227.666Z",
    fill: "#EEDBBF"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 215.799L317.414 217.929V214.711L321.103 212.582V215.799Z",
    fill: "#EEDBBF"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 239.534L317.414 241.664V238.446L321.103 236.316V239.534Z",
    fill: "#EEDBBF"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 221.734L317.414 223.863V220.646L321.103 218.516V221.734Z",
    fill: "#EEDBBF"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 233.601L317.414 235.73V232.513L321.103 230.383V233.601Z",
    fill: "#EEDBBF"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M441.104 120.523L467.164 105.477L480.193 113L454.134 128.046L441.104 120.523Z",
    fill: "#F9E9D1"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M362.916 60.3573L384.65 47.8223L410.71 62.8673L388.976 75.4033L362.916 60.3573Z",
    fill: "#F9E9D1"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M410.7 84.2793V99.3133L423.729 91.8013L410.7 84.2793Z",
    fill: "#F9E9D1"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M276.055 39.002L302.116 23.957L332.518 41.511L306.458 56.555L276.055 39.002Z",
    fill: "#F9E9D1"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M106.662 56.4401L145.753 33.8711L163.124 43.9041L124.034 66.4731L106.662 56.4401Z",
    fill: "#F9E9D1"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8066 120.868L54.5336 100.799L80.6236 115.859L45.8966 135.928L19.8066 120.868Z",
    fill: "#F9E9D1"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M215.242 79.1297L232.618 69.0938L254.344 81.6348L236.968 91.6707L215.242 79.1297Z",
    fill: "#F9E9D1"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M163.124 67.3358L180.501 57.3008L197.879 67.3308L180.503 77.3658L163.124 67.3358Z",
    fill: "#F9E9D1"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M332.521 106.615V121.648L345.55 114.137L332.521 106.615Z",
    fill: "#F9E9D1"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M106.662 147.817V132.783L93.6328 140.295L106.662 147.817Z",
    fill: "#F9E9D1"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M78.783 230.933C-15.775 285.526 -15.772 374.039 78.788 428.632C173.348 483.225 326.659 483.225 421.217 428.632C515.775 374.039 515.772 285.526 421.212 230.933C326.651 176.34 173.341 176.34 78.783 230.933Z",
    fill: "#002F3F"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M216.454 191.335L489.801 349.153C490.24 347.329 490.621 345.5 490.935 343.669L225.952 190.68C222.78 190.862 219.614 191.081 216.454 191.335Z",
    fill: "#E0E0E0"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M216.454 191.335L489.801 349.153C490.24 347.329 490.621 345.5 490.935 343.669L225.952 190.68C222.78 190.862 219.614 191.081 216.454 191.335Z",
    fill: "black"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M421.212 230.932C367.809 200.101 295.669 186.686 225.955 190.679L490.935 343.667C497.852 303.416 474.617 261.765 421.212 230.932Z",
    fill: "#E0E0E0"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M304.321 193.542C303.309 193.408 302.298 193.272 301.285 193.146L265.752 213.66L267.617 214.737L304.321 193.542Z",
    fill: "black"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M392.079 216.569C391.36 216.267 390.637 215.97 389.913 215.674L329.573 250.509L331.438 251.586L392.079 216.569Z",
    fill: "black"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.152 307.914C488.983 307.297 488.819 306.678 488.636 306.062L457.216 324.202L459.081 325.279L489.152 307.914Z",
    fill: "black"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M452.575 253.164L393.394 287.33L395.259 288.407L454.029 254.471C453.545 254.035 453.068 253.598 452.575 253.164Z",
    fill: "black"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M433.355 148.289L429.864 150.304L429.863 301.343L433.355 299.327V148.289Z",
    fill: "#002F3F"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M426.372 148.289L429.864 150.304V301.343L426.372 299.327V148.289Z",
    fill: "#002F3F"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M426.372 148.289L429.864 146.273L433.355 148.289L429.864 150.304L426.372 148.289Z",
    fill: "#002F3F"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M441.457 93.8451L439.575 92.7591C439.324 92.6141 439.015 92.6141 438.765 92.7591L420.385 103.371C420.252 103.448 420.143 103.561 420.072 103.697L406.847 128.967C406.786 129.083 406.755 129.212 406.755 129.343V154.059C406.755 154.313 406.874 154.552 407.077 154.706L420.142 164.583C420.169 164.603 420.197 164.622 420.226 164.639L422.108 165.725C422.359 165.87 422.668 165.87 422.918 165.725L441.298 155.113C441.431 155.036 441.54 154.923 441.611 154.787L454.836 129.517C454.897 129.401 454.928 129.272 454.928 129.141V104.425C454.928 104.171 454.809 103.932 454.606 103.778L441.54 93.9001C441.514 93.8801 441.486 93.8611 441.457 93.8451Z",
    fill: "#002F3F"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M441.035 94.1403L422.716 104.717C422.583 104.794 422.474 104.907 422.403 105.043L409.177 130.313C409.116 130.429 409.085 130.558 409.085 130.689V155.405C409.085 155.659 409.204 155.898 409.407 156.052L422.084 165.635C422.344 165.831 422.696 165.853 422.978 165.69L441.297 155.113C441.43 155.036 441.539 154.923 441.61 154.787L454.835 129.517C454.896 129.401 454.927 129.272 454.927 129.141V104.425C454.927 104.171 454.808 103.932 454.605 103.778L441.928 94.1953C441.669 93.9983 441.317 93.9773 441.035 94.1403Z",
    fill: "#F5F5F5"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M441.479 94.2141L454.319 103.921C454.522 104.074 454.641 104.314 454.641 104.568V129.071C454.641 129.202 454.609 129.331 454.549 129.447L441.395 154.581C441.324 154.717 441.215 154.83 441.082 154.907L422.999 165.347C422.717 165.51 422.365 165.488 422.105 165.292L409.694 155.909C409.491 155.756 409.372 155.516 409.372 155.262V130.759C409.372 130.628 409.404 130.499 409.464 130.383L422.618 105.249C422.689 105.113 422.798 105 422.931 104.923L441.479 94.2141ZM441.5 93.8711L422.715 104.717C422.582 104.794 422.473 104.907 422.402 105.043L409.176 130.313C409.115 130.429 409.084 130.558 409.084 130.689V155.405C409.084 155.659 409.203 155.898 409.406 156.052L422.083 165.635C422.343 165.831 422.695 165.853 422.977 165.69L441.297 155.113C441.43 155.036 441.539 154.923 441.61 154.787L454.835 129.517C454.896 129.401 454.927 129.272 454.927 129.141V104.425C454.927 104.171 454.808 103.932 454.605 103.778L441.5 93.8711Z",
    fill: "#E0E0E0"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M410.803 154.548V131.11C410.803 130.979 410.835 130.85 410.895 130.734L423.693 106.28C423.764 106.144 423.873 106.031 424.006 105.954L440.907 96.1966C441.189 96.0336 441.541 96.0556 441.801 96.2516L452.886 104.632C453.089 104.785 453.208 105.025 453.208 105.279V128.717C453.208 128.848 453.176 128.977 453.116 129.093L440.318 153.546C440.247 153.682 440.138 153.795 440.005 153.872L423.104 163.63C422.822 163.793 422.47 163.771 422.21 163.575L411.125 155.195C410.923 155.041 410.803 154.802 410.803 154.548Z",
    fill: "#F78C3A"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M425.207 127.345C425.747 127.033 426.423 127.423 426.423 128.047V142.386C426.423 143.01 427.098 143.4 427.639 143.088L428.305 142.704C428.556 142.559 428.71 142.292 428.71 142.002V125.791C428.71 125.501 428.865 125.234 429.115 125.089L430.724 124.16C430.975 124.015 431.129 123.748 431.129 123.458V122.265C431.129 121.641 430.454 121.251 429.913 121.563L424.396 124.748C424.145 124.893 423.991 125.16 423.991 125.45V126.643C423.991 127.267 424.667 127.657 425.207 127.345ZM421.729 138.58C421.422 138.026 420.987 137.535 420.422 137.109C420.253 136.97 419.902 136.758 419.37 136.474C418.918 136.24 418.579 136.005 418.354 135.77C417.757 135.158 417.459 134.389 417.459 133.464C417.459 132.873 417.548 132.327 417.725 131.827C417.942 131.207 418.261 130.775 418.681 130.533C419.076 130.305 419.379 130.297 419.589 130.509C419.705 130.627 419.803 130.784 419.883 130.982C420.086 131.482 420.681 131.679 421.098 131.337L421.974 130.618C422.185 130.445 422.303 130.172 422.27 129.901C422.191 129.253 422.037 128.716 421.809 128.292C421.531 127.775 421.166 127.459 420.715 127.343C420.134 127.195 419.436 127.356 418.621 127.826C417.775 128.315 417.065 129.01 416.492 129.911C415.564 131.394 415.101 133.056 415.101 134.896C415.101 135.918 415.27 136.768 415.609 137.444C415.923 138.037 416.46 138.605 417.218 139.147C418.122 139.766 418.799 140.231 419.251 140.54C419.823 141.038 420.11 141.707 420.11 142.547C420.11 143.128 420.033 143.619 419.88 144.02C419.582 144.827 419.182 145.386 418.683 145.696C418.328 145.923 418.014 145.915 417.739 145.673C417.52 145.486 417.349 145.159 417.225 144.691C417.083 144.153 416.453 143.91 415.992 144.22L415.249 144.721C415.008 144.883 414.866 145.166 414.891 145.455C414.963 146.291 415.12 146.992 415.362 147.556C415.648 148.224 416.037 148.658 416.529 148.858C417.118 149.11 417.86 148.976 418.755 148.46C419.239 148.181 419.663 147.861 420.026 147.501C420.704 146.83 421.227 146.049 421.598 145.157C422.163 143.831 422.437 142.468 422.421 141.069C422.413 140.504 422.299 139.924 422.082 139.329C421.991 139.09 421.874 138.84 421.729 138.58ZM448.236 112.388C447.575 111.834 446.687 111.879 445.574 112.521L442.374 114.368C442.123 114.513 441.969 114.78 441.969 115.07V133.41C441.969 134.034 442.645 134.424 443.185 134.112L443.851 133.728C444.102 133.583 444.256 133.316 444.256 133.026V126.348C444.256 126.058 444.411 125.791 444.661 125.646L445.574 125.119C446.566 124.546 447.41 123.585 448.108 122.236C448.806 120.887 449.155 119.545 449.155 118.212V115.276C449.155 113.89 448.849 112.927 448.236 112.388ZM446.941 119.556C446.941 120.04 446.814 120.527 446.56 121.018C446.306 121.51 445.998 121.859 445.634 122.069L444.255 122.865V116.864C444.255 116.574 444.41 116.307 444.66 116.162L445.633 115.6C446.028 115.372 446.345 115.351 446.583 115.536C446.82 115.722 446.939 116.078 446.939 116.605V119.556H446.941ZM438.89 117.542C438.184 117.003 437.327 117.025 436.32 117.607C435.328 118.18 434.476 119.142 433.767 120.493C433.057 121.844 432.702 123.191 432.702 124.535V135.569C432.702 136.902 433.053 137.839 433.754 138.381C434.456 138.923 435.311 138.902 436.319 138.32C437.318 137.743 438.174 136.779 438.884 135.428C439.593 134.077 439.948 132.73 439.948 131.386V120.353C439.948 119.017 439.595 118.081 438.89 117.542ZM437.703 132.728C437.703 133.232 437.57 133.742 437.307 134.246C437.042 134.753 436.712 135.122 436.328 135.344C436.115 135.467 435.914 135.528 435.729 135.528C435.554 135.528 435.393 135.473 435.245 135.365C434.951 135.149 434.801 134.771 434.801 134.243V123.177C434.801 122.672 434.937 122.16 435.204 121.655C435.473 121.146 435.804 120.776 436.189 120.554C436.603 120.315 436.965 120.31 437.267 120.537C437.556 120.756 437.702 121.134 437.702 121.661V132.728H437.703Z",
    fill: "#F5F5F5"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M233.194 33.1268C233.185 30.0108 229.777 27.8448 225.909 27.4808C221.352 27.0508 218.12 29.0828 218.011 32.6708C215.031 31.4478 211.889 32.2328 212.125 35.5088C211.35 34.6148 208.45 34.6398 207.409 34.8898C206.309 35.1538 205.194 36.1438 204.813 37.1018C204.505 37.8768 204.489 38.2348 204.543 38.7788C202.805 38.2098 198.855 37.8618 197.867 39.4548C196.108 42.2918 203.135 42.3798 204.552 41.5228C204.852 43.7298 212.403 44.0918 214.232 42.0558C215.66 43.4948 217.712 43.8118 219.926 43.9438C222.33 44.0868 224.395 43.8578 226.492 42.4868C226.706 42.3468 226.927 42.1948 227.182 42.1758C227.44 42.1568 227.685 42.2788 227.918 42.3918C230.727 43.7618 234.204 44.2738 236.919 42.7248C237.085 42.6298 237.254 42.5258 237.444 42.5038C237.685 42.4758 237.919 42.5828 238.139 42.6838C240.76 43.8828 244.019 44.4268 246.4 42.8028C246.695 42.6018 246.977 42.3668 247.317 42.2568C248.61 41.8378 249.909 42.5428 251.28 41.9638C252.374 41.5008 253.224 40.6918 252.262 39.5818C251.712 38.9468 249.695 38.5438 248.841 38.7408C247.937 36.9628 244.31 35.2788 242.229 36.7818C242.149 34.6288 240.18 32.9448 237.41 32.5168C236.481 32.3728 234.253 32.2478 233.194 33.1268Z",
    fill: "#F5F5F5"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6544 64.9144C65.6444 61.4664 61.8734 59.0694 57.5934 58.6664C52.5514 58.1914 48.9744 60.4384 48.8544 64.4094C45.5574 63.0554 42.0804 63.9244 42.3414 67.5494C41.4844 66.5604 38.2744 66.5884 37.1234 66.8644C35.9064 67.1564 34.6724 68.2524 34.2514 69.3124C33.9104 70.1694 33.8924 70.5664 33.9524 71.1674C32.0294 70.5374 27.6584 70.1524 26.5654 71.9154C24.6194 75.0544 32.3944 75.1524 33.9624 74.2044C34.2944 76.6464 42.6504 77.0474 44.6734 74.7934C44.3654 75.1364 47.8244 76.4704 48.1124 76.5334C49.3504 76.8064 50.6314 77.1884 51.8874 77.3274C54.7544 77.6434 57.7454 76.8324 60.0264 75.0574C62.0184 76.6244 64.5404 77.5054 67.0754 77.5194C69.6104 77.5334 72.1414 76.6804 74.1514 75.1354C75.4314 75.8274 76.8244 76.3984 78.2794 76.4204C79.7344 76.4434 81.2654 75.8274 82.0284 74.5884C83.4144 75.0984 84.9564 75.1724 86.3854 74.7984C86.8354 74.6804 87.3054 74.4964 87.5624 74.1084C87.8344 73.6974 87.7964 73.1324 87.5514 72.7044C87.1294 71.9664 86.1734 71.5834 85.3954 71.3504C84.6374 71.1224 83.7884 70.9714 83.0034 71.1424C82.8024 69.4034 80.8464 68.3724 79.2624 68.2234C78.1574 68.1194 77.0444 68.3414 75.9874 68.6784C75.8344 68.7274 75.6364 68.7654 75.5394 68.6374C75.4934 68.5774 75.4874 68.4974 75.4804 68.4224C75.2454 65.9504 72.4814 64.5704 70.3204 64.2374C69.2914 64.0794 66.8264 63.9414 65.6544 64.9144Z",
    fill: "#F5F5F5"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M461.477 59.1199C461.467 55.8249 457.864 53.5349 453.775 53.1499C448.957 52.6959 445.539 54.8439 445.424 58.6379C442.273 57.3439 438.951 58.1739 439.201 61.6379C438.382 60.6929 435.315 60.7199 434.215 60.9829C433.052 61.2619 431.873 62.3089 431.47 63.3219C431.144 64.1409 431.127 64.5199 431.185 65.0949C429.348 64.4929 425.171 64.1249 424.126 65.8099C422.267 68.8089 429.696 68.9029 431.194 67.9969C431.511 70.3309 439.495 70.7129 441.428 68.5599C441.134 68.8869 444.439 70.1619 444.714 70.2229C445.897 70.4839 447.121 70.8489 448.321 70.9809C451.061 71.2829 453.919 70.5079 456.098 68.8119C458.002 70.3089 460.411 71.1509 462.833 71.1649C465.255 71.1789 467.674 70.3639 469.594 68.8869C470.817 69.5479 472.148 70.0929 473.538 70.1149C474.928 70.1369 476.391 69.5479 477.121 68.3649C478.445 68.8519 479.919 68.9229 481.284 68.5659C481.714 68.4529 482.163 68.2769 482.409 67.9059C482.669 67.5129 482.632 66.9729 482.399 66.5639C481.996 65.8579 481.082 65.4929 480.339 65.2699C479.615 65.0519 478.803 64.9079 478.053 65.0709C477.86 63.4099 475.992 62.4239 474.478 62.2819C473.422 62.1829 472.359 62.3939 471.348 62.7169C471.202 62.7639 471.013 62.7999 470.92 62.6779C470.877 62.6199 470.871 62.5439 470.864 62.4719C470.639 60.1099 467.998 58.7919 465.933 58.4729C464.953 58.3229 462.597 58.1909 461.477 59.1199Z",
    fill: "#F5F5F5"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.097 234.607L47.7 292.323C33.535 300.468 35.221 314.667 51.468 324.038L242.184 434.099C323.438 481.135 459.061 383.451 394.107 347.031L195.82 232.209C179.574 222.836 162.264 226.463 148.097 234.607Z",
    fill: "black"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.1441 404.138L121.065 389.172C122.027 388.617 122.027 387.717 121.065 387.161L95.1441 372.196C94.1821 371.641 92.6231 371.641 91.6611 372.196L65.7401 387.162C64.7781 387.717 64.7781 388.617 65.7401 389.173L91.6611 404.138C92.6231 404.693 94.1821 404.693 95.1441 404.138Z",
    fill: "black"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.427 444.141L190.348 429.175C191.31 428.62 191.31 427.72 190.348 427.164L164.427 412.199C163.465 411.644 161.906 411.644 160.944 412.199L135.023 427.165C134.061 427.72 134.061 428.62 135.023 429.176L160.944 444.141C161.906 444.696 163.465 444.696 164.427 444.141Z",
    fill: "black"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M117.963 384.574L94.9451 371.283C94.5171 371.033 93.9591 370.912 93.4021 370.912C92.8451 370.912 92.2811 371.033 91.8521 371.283L68.8411 384.574C68.4121 384.824 68.2051 385.145 68.2051 385.467V387.145C68.2051 387.466 68.4121 387.788 68.8411 388.038L91.8521 401.322C92.2801 401.572 92.8451 401.693 93.4021 401.693C93.9591 401.693 94.5161 401.571 94.9451 401.322L117.963 388.038C118.392 387.788 118.599 387.467 118.599 387.145V385.467C118.599 385.146 118.392 384.824 117.963 384.574Z",
    fill: "#F78C3A"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.598 385.467V387.145C118.598 387.466 118.391 387.788 117.962 388.038L94.9444 401.322C94.5164 401.572 93.9584 401.693 93.4014 401.693V370.912C93.9584 370.912 94.5154 371.033 94.9444 371.283L117.962 384.574C118.391 384.824 118.598 385.146 118.598 385.467Z",
    fill: "black"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.4021 370.912V401.693C92.8451 401.693 92.2811 401.571 91.8521 401.322L68.8411 388.038C68.4121 387.788 68.2051 387.467 68.2051 387.145V385.467C68.2051 385.146 68.4121 384.824 68.8411 384.574L91.8521 371.283C92.2811 371.033 92.8451 370.912 93.4021 370.912Z",
    fill: "black"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8557 399.649L68.8387 386.36C67.9847 385.867 67.9847 385.068 68.8387 384.575L91.8557 371.286C92.7097 370.793 94.0947 370.793 94.9477 371.286L117.965 384.575C118.819 385.068 118.819 385.867 117.965 386.36L94.9477 399.649C94.0937 400.142 92.7097 400.142 91.8557 399.649Z",
    fill: "#F78C3A"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.8557 399.649L68.8387 386.36C67.9847 385.867 67.9847 385.068 68.8387 384.575L91.8557 371.286C92.7097 370.793 94.0947 370.793 94.9477 371.286L117.965 384.575C118.819 385.068 118.819 385.867 117.965 386.36L94.9477 399.649C94.0937 400.142 92.7097 400.142 91.8557 399.649Z",
    fill: "white"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M93.4027 370.916C92.8427 370.916 92.2827 371.039 91.8557 371.286L68.8387 384.575C67.9847 385.068 67.9847 385.868 68.8387 386.36L91.8557 399.649C92.2827 399.896 92.8427 400.019 93.4027 400.019V370.916Z",
    fill: "black"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M107.525 383.019H107.531L97.4069 350.071C97.4049 350.065 97.4029 350.059 97.4009 350.053L97.3919 350.022H97.3869C97.2299 349.555 96.8659 349.108 96.2859 348.745C94.6929 347.749 92.1109 347.749 90.5189 348.745C89.9379 349.108 89.5749 349.554 89.4179 350.022H89.4119L89.4009 350.058C89.3999 350.061 89.3989 350.063 89.3979 350.066L79.2739 383.019H79.2789C78.3479 385.885 79.6529 388.978 83.2069 391.201C88.8379 394.723 97.9679 394.723 103.599 391.201C107.151 388.978 108.456 385.884 107.525 383.019Z",
    fill: "#F78C3A"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M100.309 359.52L100.298 359.485L98.8594 354.801C99.0984 355.598 98.8864 356.435 98.2304 357.158C97.9894 357.424 97.6924 357.676 97.3294 357.903C95.1594 359.26 91.6424 359.26 89.4724 357.903C89.1094 357.676 88.8134 357.424 88.5714 357.158C87.9134 356.433 87.7014 355.592 87.9444 354.793L86.5014 359.489L86.4934 359.515C86.2544 360.299 86.3644 361.114 86.8114 361.87C87.1524 362.447 87.6864 362.99 88.4274 363.453C88.9514 363.781 89.5494 364.026 90.1744 364.229C92.1994 364.886 94.6024 364.886 96.6274 364.229C97.2524 364.026 97.8504 363.781 98.3744 363.453C99.1154 362.99 99.6494 362.447 99.9904 361.87C100.436 361.116 100.546 360.303 100.309 359.52Z",
    fill: "#FAFAFA"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M106.11 378.397L106.101 378.367L104.66 373.678C104.898 374.455 104.917 375.252 104.741 376.034C104.557 376.853 104.157 377.655 103.52 378.402C103 379.013 102.331 379.587 101.508 380.102C97.0307 382.903 89.7717 382.903 85.2947 380.102C84.4717 379.587 83.8027 379.013 83.2827 378.402C82.6457 377.655 82.2457 376.852 82.0617 376.034C81.8857 375.253 81.9047 374.458 82.1417 373.682L80.7047 378.359L80.6907 378.405C80.4537 379.183 80.4027 379.978 80.5327 380.763C80.8277 382.548 82.0637 384.284 84.2507 385.652C89.3047 388.813 97.4987 388.813 102.553 385.652C104.74 384.284 105.976 382.548 106.27 380.763C106.401 379.975 106.349 379.177 106.11 378.397Z",
    fill: "#FAFAFA"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M103.21 368.958L103.2 368.926L101.76 364.239C101.997 365.019 101.947 365.825 101.623 366.595C101.26 367.458 100.551 368.275 99.4837 368.958C99.4607 368.973 99.4417 368.989 99.4187 369.003C96.0957 371.082 90.7077 371.082 87.3837 369.003C87.3607 368.989 87.3417 368.972 87.3187 368.958C86.2517 368.276 85.5417 367.459 85.1797 366.595C84.8557 365.824 84.8057 365.018 85.0437 364.238L83.6037 368.924L83.5927 368.96C83.3547 369.742 83.3557 370.546 83.5967 371.327C83.8527 372.155 84.3857 372.955 85.1817 373.676C85.5207 373.983 85.9017 374.279 86.3397 374.552C87.4567 375.251 88.7757 375.742 90.1757 376.041C92.2657 376.486 94.5377 376.486 96.6277 376.041C98.0287 375.742 99.3467 375.251 100.464 374.552C100.902 374.279 101.282 373.983 101.622 373.676C102.418 372.955 102.951 372.155 103.207 371.327C103.448 370.546 103.449 369.741 103.21 368.958Z",
    fill: "#FAFAFA"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.4019 347.998C92.3579 347.998 91.3139 348.247 90.5179 348.745C89.9369 349.108 89.5739 349.554 89.4169 350.022H89.4109L89.3999 350.058C89.3989 350.061 89.3979 350.063 89.3969 350.066L79.2739 383.019H79.2789C78.3479 385.885 79.6529 388.978 83.2069 391.201C86.0219 392.962 89.7129 393.843 93.4029 393.843C93.3739 393.838 93.3449 393.833 93.3169 393.828C88.7489 393.035 85.6709 388.312 86.3089 383.348L90.5199 350.549L93.4019 347.998Z",
    fill: "black"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M90.518 352.353C88.925 351.357 88.925 349.741 90.518 348.745C92.111 347.749 94.693 347.749 96.286 348.745C97.878 349.741 97.878 351.357 96.286 352.353C94.693 353.349 92.111 353.349 90.518 352.353Z",
    fill: "#F78C3A"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.518 352.353C88.925 351.357 88.925 349.741 90.518 348.745C92.111 347.749 94.693 347.749 96.286 348.745C97.878 349.741 97.878 351.357 96.286 352.353C94.693 353.349 92.111 353.349 90.518 352.353Z",
    fill: "white"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M187.247 424.58L164.229 411.289C163.801 411.039 163.243 410.918 162.686 410.918C162.129 410.918 161.565 411.039 161.136 411.289L138.125 424.58C137.697 424.83 137.489 425.151 137.489 425.473V427.151C137.489 427.472 137.696 427.794 138.125 428.044L161.136 441.328C161.564 441.578 162.129 441.699 162.686 441.699C163.243 441.699 163.8 441.577 164.229 441.328L187.247 428.044C187.675 427.794 187.883 427.472 187.883 427.151V425.473C187.882 425.151 187.675 424.829 187.247 424.58Z",
    fill: "#F78C3A"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.882 425.471V427.149C187.882 427.47 187.675 427.792 187.246 428.042L164.228 441.326C163.8 441.576 163.242 441.697 162.685 441.697V410.916C163.242 410.916 163.799 411.037 164.228 411.287L187.246 424.578C187.675 424.828 187.882 425.15 187.882 425.471Z",
    fill: "black"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M162.686 410.916V441.697C162.129 441.697 161.565 441.575 161.136 441.326L138.125 428.042C137.697 427.792 137.489 427.47 137.489 427.149V425.471C137.489 425.15 137.696 424.828 138.125 424.578L161.136 411.287C161.565 411.038 162.129 410.916 162.686 410.916Z",
    fill: "black"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M161.14 439.655L138.123 426.366C137.269 425.873 137.269 425.074 138.123 424.581L161.14 411.292C161.994 410.799 163.379 410.799 164.232 411.292L187.249 424.581C188.103 425.074 188.103 425.873 187.249 426.366L164.232 439.655C163.378 440.148 161.993 440.148 161.14 439.655Z",
    fill: "#F78C3A"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.14 439.655L138.123 426.366C137.269 425.873 137.269 425.074 138.123 424.581L161.14 411.292C161.994 410.799 163.379 410.799 164.232 411.292L187.249 424.581C188.103 425.074 188.103 425.873 187.249 426.366L164.232 439.655C163.378 440.148 161.993 440.148 161.14 439.655Z",
    fill: "white"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M162.686 410.922C162.126 410.922 161.566 411.045 161.139 411.292L138.122 424.581C137.268 425.074 137.268 425.873 138.122 426.366L161.139 439.655C161.566 439.902 162.126 440.025 162.686 440.025V410.922Z",
    fill: "black"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M176.809 423.023H176.815L166.691 390.075C166.689 390.069 166.687 390.063 166.685 390.057L166.676 390.026H166.671C166.514 389.559 166.15 389.112 165.57 388.749C163.977 387.753 161.395 387.753 159.802 388.749C159.222 389.112 158.858 389.558 158.701 390.026H158.695L158.684 390.062C158.683 390.065 158.682 390.067 158.681 390.07L148.557 423.023H148.562C147.631 425.889 148.936 428.982 152.49 431.205C158.121 434.727 167.251 434.727 172.882 431.205C176.435 428.982 177.74 425.889 176.809 423.023Z",
    fill: "#F78C3A"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M169.594 399.524L169.583 399.489L168.144 394.805C168.383 395.602 168.171 396.439 167.515 397.162C167.273 397.428 166.977 397.68 166.614 397.907C164.444 399.264 160.927 399.264 158.757 397.907C158.394 397.68 158.098 397.428 157.856 397.162C157.198 396.437 156.986 395.596 157.229 394.797L155.786 399.494L155.778 399.519C155.539 400.303 155.649 401.118 156.096 401.874C156.437 402.451 156.971 402.994 157.712 403.457C158.236 403.785 158.834 404.03 159.459 404.233C161.483 404.89 163.887 404.89 165.912 404.233C166.537 404.03 167.135 403.785 167.659 403.457C168.4 402.994 168.934 402.451 169.275 401.874C169.72 401.12 169.831 400.306 169.594 399.524Z",
    fill: "#FAFAFA"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M175.394 418.401L175.385 418.371L173.944 413.682C174.182 414.459 174.201 415.256 174.025 416.038C173.841 416.857 173.441 417.659 172.804 418.406C172.284 419.017 171.615 419.591 170.792 420.106C166.315 422.907 159.056 422.907 154.579 420.106C153.756 419.591 153.087 419.017 152.567 418.406C151.93 417.659 151.53 416.856 151.346 416.038C151.17 415.257 151.189 414.462 151.426 413.686L149.989 418.363L149.975 418.409C149.738 419.187 149.687 419.981 149.817 420.767C150.112 422.552 151.348 424.288 153.535 425.656C158.589 428.817 166.783 428.817 171.838 425.656C174.025 424.288 175.261 422.552 175.555 420.768C175.684 419.979 175.633 419.182 175.394 418.401Z",
    fill: "#FAFAFA"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M172.494 408.962L172.484 408.93L171.044 404.243C171.281 405.023 171.231 405.829 170.907 406.599C170.544 407.462 169.835 408.279 168.768 408.962C168.745 408.977 168.726 408.993 168.703 409.007C165.38 411.086 159.992 411.086 156.668 409.007C156.645 408.993 156.626 408.976 156.603 408.962C155.536 408.28 154.826 407.462 154.464 406.599C154.14 405.828 154.09 405.022 154.328 404.242L152.888 408.928L152.877 408.964C152.639 409.746 152.64 410.55 152.881 411.331C153.137 412.159 153.671 412.959 154.466 413.68C154.806 413.988 155.186 414.283 155.624 414.556C156.741 415.255 158.06 415.746 159.46 416.045C161.549 416.49 163.822 416.49 165.912 416.045C167.313 415.746 168.631 415.255 169.748 414.556C170.185 414.283 170.566 413.987 170.906 413.68C171.701 412.959 172.235 412.159 172.491 411.331C172.732 410.549 172.732 409.744 172.494 408.962Z",
    fill: "#FAFAFA"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.686 388.002C161.642 388.002 160.598 388.251 159.802 388.749C159.222 389.112 158.858 389.558 158.701 390.026H158.695L158.684 390.062C158.683 390.065 158.682 390.067 158.681 390.07L148.557 423.023H148.562C147.631 425.889 148.936 428.982 152.49 431.205C155.305 432.966 158.996 433.847 162.686 433.847C162.657 433.842 162.628 433.837 162.6 433.832C158.032 433.039 154.954 428.316 155.592 423.352L159.803 390.553L162.686 388.002Z",
    fill: "black"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M159.802 392.357C158.209 391.361 158.209 389.745 159.802 388.749C161.395 387.753 163.977 387.753 165.57 388.749C167.162 389.745 167.162 391.361 165.57 392.357C163.977 393.354 161.395 393.354 159.802 392.357Z",
    fill: "#F78C3A"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.802 392.357C158.209 391.361 158.209 389.745 159.802 388.749C161.395 387.753 163.977 387.753 165.57 388.749C167.162 389.745 167.162 391.361 165.57 392.357C163.977 393.354 161.395 393.354 159.802 392.357Z",
    fill: "white"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M331.515 251.865L332.376 255.454C334.36 259.169 338.746 263.86 340.321 263.472C341.727 263.126 342.588 261.079 343.029 258.55V258.519C343.239 257.365 343.354 256.105 343.396 254.857C343.533 250.879 341.759 241.602 336.239 239.136C334.979 238.58 333.846 239.02 332.965 239.871C332.231 240.585 331.663 241.571 331.37 242.505C330.445 245.295 331.389 251.718 331.515 251.865Z",
    fill: "#002F3F"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M332.376 255.454C334.36 259.169 338.746 263.86 340.321 263.472C341.727 263.126 342.588 261.079 343.029 258.55V258.519C343.239 257.365 343.354 256.105 343.396 254.857C343.533 250.879 341.759 241.602 336.239 239.136C334.979 238.58 333.846 239.02 332.965 239.871L333.721 241.582C337.583 243.23 338.622 249.19 338.265 253.724C337.917 258.256 334.59 257.794 332.376 255.454Z",
    fill: "#002F3F"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M331.377 242.507C332.772 241.027 336.236 240.954 339.153 244.963C342.07 248.972 343.023 255.849 343.034 258.515C343.244 257.361 343.359 256.101 343.402 254.853C343.538 250.876 341.77 241.599 336.25 239.132C333.941 238.103 332.038 240.46 331.377 242.507Z",
    fill: "#08181E"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M337.398 259.145C337.398 259.145 312.711 248.225 272.466 227.184C261.759 221.586 252.198 214.387 245.338 208.615C234.768 197.882 233.78 192.965 229.102 190.961C224.03 188.788 217.775 187.027 211.394 185.193L97.7969 257.288L209.331 346.357L240.102 323.324L337.573 262.27C337.484 262.271 337.36 262.257 337.237 262.244C337.29 262.222 337.349 262.193 337.401 262.172C339.365 261.38 337.398 259.145 337.398 259.145Z",
    fill: "#E0E0E0"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M211.393 185.193C207.757 183.093 204.779 181.389 202.623 180.178C188.533 172.264 175.693 171.292 166.433 172.122C159.692 172.726 156.01 173.639 152.8 174.815C148.92 176.236 144.854 178.758 142.472 184.382L67.7969 233.333L97.7959 257.289",
    fill: "#E0E0E0"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M245.199 204.905L233.792 197.227L139.755 248.552L154.745 257.202L154.73 315.189L245.199 262.935V204.905Z",
    fill: "#E0E0E0"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M218.886 188.464C226.421 190.782 231.492 192.219 229.608 193.239C227.725 194.26 179.367 181.074 169.93 179.335C160.493 177.596 153.179 176.863 164.9 174.252C175.365 171.921 182.082 172.67 188.312 174.843C194.543 177.017 206.313 183.452 206.313 183.452C206.313 183.452 176.094 176.003 174.959 175.858C173.823 175.712 170.97 175.822 178.07 177.865C185.17 179.909 211.351 186.145 218.886 188.464Z",
    fill: "#FFE7C4"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M269.877 293.541C269.877 293.541 258.821 247.461 257.673 224.031C265.218 227.907 278.137 234.561 297.116 244.628C303.404 247.964 326.083 258.979 334.404 261.554C334.404 261.554 336.519 261.986 337.41 262.17L280.224 297.973L269.877 293.541Z",
    fill: "black"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M331.866 255.994C318.947 249.328 291.232 235.063 278.057 228.515C259.483 219.277 247.132 211.266 238.945 197.6C235.901 192.534 232.898 187.4 230.62 183.473C235.833 185.427 243.294 188.441 251.393 192.377C267.042 199.985 286.007 209.15 297.532 216.896C306.418 222.866 326.722 246.521 331.866 255.994Z",
    fill: "black"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M299.182 214.452C287.44 206.559 268.21 197.277 252.679 189.727C237.148 182.178 224.081 178.035 224.081 178.035C224.081 178.035 230.138 188.648 236.411 199.113C245.394 214.084 259.128 222.4 276.741 231.147C294.353 239.904 337.412 262.17 337.412 262.17C337.394 256.377 310.924 222.345 299.182 214.452ZM238.945 197.601C235.901 192.535 232.898 187.401 230.62 183.474C235.833 185.428 243.294 188.442 251.393 192.378C267.042 199.986 286.007 209.151 297.532 216.897C306.417 222.866 324.604 245.456 331.865 255.995C318.946 249.329 291.231 235.064 278.056 228.516C259.483 219.278 247.133 211.267 238.945 197.601Z",
    fill: "#08181E"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M230.62 183.475C230.718 183.652 230.826 183.828 230.934 184.015C231.238 183.995 231.552 183.966 231.867 183.956C231.435 183.779 231.023 183.622 230.62 183.475ZM257.961 192.379V195.697C257.971 202.697 257.981 211.532 257.981 217.138V218.935C257.981 219.544 257.952 220.113 257.883 220.633C259.051 221.408 260.259 222.164 261.496 222.911L261.506 219.446L261.516 197.563V194.235C260.298 193.587 259.11 192.968 257.961 192.379Z",
    fill: "#08181E"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M127.246 283.994L185.021 256.728L211.078 242.17C213.603 240.724 217.8 240.521 220.452 241.718L239.21 250.181L252.067 249.929V257.434L252.061 257.437C252.064 258.28 251.465 259.148 250.245 259.853L158.38 312.059C155.86 313.514 151.986 313.207 149.726 311.373L128.807 294.393C127.76 293.543 127.268 292.518 127.267 291.517C127.262 291.514 127.244 291.501 127.244 291.501L127.246 283.994Z",
    fill: "#002F3F"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M250.246 252.341L158.381 304.547C155.861 306.002 151.987 305.695 149.727 303.861L128.808 286.88C126.549 285.046 126.764 282.387 129.289 280.941L211.077 234.66C213.602 233.213 217.799 233.011 220.451 234.208L250.005 247.541C252.659 248.737 252.766 250.886 250.246 252.341Z",
    fill: "#08181E"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M127.241 284.002V291.494C127.241 291.494 127.262 291.515 127.273 291.515C127.273 292.516 127.758 293.538 128.811 294.392L149.728 311.368C150.824 312.264 152.299 312.78 153.817 312.927V305.424C152.3 305.287 150.824 304.75 149.728 303.865L128.811 286.879C127.758 286.025 127.241 285.003 127.241 284.002Z",
    fill: "#002F3F"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M127.245 279.735C127.203 280.61 127.487 281.221 127.961 281.516L133.593 284.773V284.763C133.097 284.5 132.813 283.878 132.855 282.982L134.72 241.075C134.794 239.326 136.09 237.208 137.597 236.333L212.284 193.679C213.064 193.226 213.822 193.194 214.413 193.51V193.5L208.844 190.285V190.295C208.243 189.958 207.474 189.968 206.663 190.432L131.987 233.086C130.47 233.961 129.184 236.079 129.11 237.828L127.245 279.735Z",
    fill: "#002F3F"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M212.282 193.674L137.6 236.33C136.088 237.203 134.8 239.325 134.722 241.069L132.861 282.984C132.784 284.728 133.947 285.434 135.459 284.561L218.702 236.963C220.214 236.09 221.232 233.982 220.976 232.255L215.484 195.22C215.227 193.494 213.794 192.801 212.282 193.674Z",
    fill: "#002F3F"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M129.996 235.14L135.607 238.386C136.134 237.522 136.84 236.774 137.598 236.331L212.285 193.677C213.065 193.224 213.823 193.192 214.414 193.508V193.498L208.845 190.283V190.293C208.244 189.956 207.475 189.966 206.664 190.43L131.988 233.084C131.229 233.527 130.523 234.275 129.996 235.14Z",
    fill: "#002F3F"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M236.273 285.452L247.502 285.232L264.584 275.447C267.372 273.85 272.005 273.626 274.933 274.948L295.642 284.29L309.836 284.012V292.297L309.83 292.3C309.833 293.231 309.173 294.189 307.825 294.967L270.645 316.433C267.863 318.039 263.586 317.7 261.092 315.675L237.999 296.929C236.844 295.991 236.3 294.859 236.299 293.754C236.294 293.75 236.273 293.736 236.273 293.736V285.452Z",
    fill: "#08181E"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M307.826 286.676L270.646 308.142C267.864 309.748 263.587 309.409 261.093 307.385L238 288.639C235.506 286.614 235.744 283.679 238.531 282.082L264.586 267.157C267.374 265.56 272.007 265.337 274.935 266.658L307.562 281.377C310.49 282.698 310.608 285.07 307.826 286.676Z",
    fill: "#002F3F"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M236.268 285.461V293.732C236.268 293.732 236.292 293.755 236.304 293.755C236.304 294.86 236.839 295.989 238.002 296.931L261.094 315.672C262.304 316.661 263.932 317.231 265.608 317.394V309.111C263.933 308.96 262.304 308.366 261.094 307.389L238.002 288.636C236.839 287.695 236.268 286.567 236.268 285.461Z",
    fill: "#002F3F"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M234.033 284.994C234.11 285.888 234.538 286.497 235.144 286.775L241.725 290.011L241.724 290C241.097 289.755 240.668 289.135 240.587 288.22L236.685 245.397C236.517 243.61 237.748 241.387 239.411 240.422L261.724 227.544C262.585 227.044 263.481 226.975 264.229 227.268L264.227 227.257L257.728 224.061L257.73 224.072C256.967 223.757 256.055 223.806 255.158 224.318L232.858 237.195C231.183 238.161 229.965 240.383 230.132 242.17L234.033 284.994Z",
    fill: "#002F3F"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M261.719 227.542L239.411 240.421C237.742 241.385 236.52 243.611 236.683 245.393L240.591 288.224C240.754 290.006 242.239 290.67 243.908 289.706L275.666 271.37C277.335 270.406 278.237 268.207 277.681 266.459L265.748 228.962C265.193 227.214 263.389 226.578 261.719 227.542Z",
    fill: "#08181E"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M230.789 239.388L237.343 242.614C237.843 241.707 238.572 240.91 239.409 240.422L261.722 227.544C262.583 227.044 263.479 226.975 264.227 227.268L264.225 227.257L257.726 224.061L257.728 224.072C256.965 223.757 256.053 223.806 255.156 224.318L232.856 237.195C232.019 237.684 231.289 238.482 230.789 239.388Z",
    fill: "#002F3F"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M234.096 233.001C233.732 230.458 233.977 232.172 233.366 227.899C232.27 220.245 236.671 210.986 243.195 207.219C246.189 205.49 249.103 205.234 251.493 206.186L251.5 206.171L255.467 208.323L252.838 214.111L253.389 217.963C253.644 219.743 256.832 223.364 255.163 224.328L247.974 228.479L239.187 236.885L235.31 234.77L235.308 234.769L235.3 234.765L235.301 234.764C234.673 234.494 234.223 233.887 234.096 233.001Z",
    fill: "#002F3F"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M241.029 220.972L234.688 217.838C236.393 213.381 239.438 209.388 243.195 207.219C246.189 205.49 249.102 205.234 251.492 206.186L251.499 206.171L255.466 208.323L252.837 214.111L253.102 215.956L241.029 220.972Z",
    fill: "#002F3F"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M237.935 235.1C237.571 232.558 237.816 234.271 237.205 229.999C236.109 222.344 240.51 213.086 247.034 209.319C253.559 205.552 259.736 208.704 260.832 216.358L261.562 221.459C261.817 223.239 260.672 225.464 259.002 226.427L241.419 236.578C239.749 237.542 238.19 236.881 237.935 235.1Z",
    fill: "#08181E"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M185.01 315.51L196.239 315.29L213.321 305.505C216.109 303.908 220.742 303.684 223.67 305.006L244.379 314.348L258.573 314.07V322.355L258.567 322.358C258.57 323.289 257.91 324.247 256.562 325.025L219.383 346.491C216.601 348.097 212.324 347.758 209.83 345.733L186.736 326.987C185.58 326.049 185.037 324.917 185.036 323.812C185.031 323.808 185.01 323.794 185.01 323.794V315.51Z",
    fill: "#08181E"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M256.562 316.736L219.383 338.202C216.601 339.808 212.324 339.469 209.83 337.444L186.736 318.698C184.242 316.673 184.48 313.738 187.267 312.141L213.322 297.216C216.11 295.619 220.743 295.396 223.671 296.717L256.298 311.436C259.226 312.757 259.344 315.13 256.562 316.736Z",
    fill: "#002F3F"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M185.005 315.52V323.791C185.005 323.791 185.029 323.814 185.041 323.814C185.041 324.919 185.576 326.048 186.739 326.99L209.831 345.731C211.041 346.72 212.669 347.29 214.345 347.453V339.17C212.67 339.019 211.041 338.425 209.831 337.448L186.739 318.695C185.575 317.754 185.005 316.626 185.005 315.52Z",
    fill: "#002F3F"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M182.769 315.053C182.846 315.947 183.274 316.556 183.88 316.834L190.461 320.07L190.46 320.059C189.833 319.814 189.404 319.194 189.323 318.279L185.421 275.456C185.253 273.669 186.484 271.446 188.147 270.481L210.46 257.603C211.32 257.103 212.217 257.034 212.965 257.327L212.963 257.316L206.464 254.12L206.466 254.131C205.703 253.816 204.79 253.865 203.894 254.377L181.594 267.254C179.919 268.22 178.701 270.442 178.868 272.229L182.769 315.053Z",
    fill: "#002F3F"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M210.456 257.6L188.148 270.479C186.479 271.443 185.257 273.669 185.42 275.451L189.328 318.282C189.491 320.064 190.976 320.728 192.645 319.764L224.403 301.428C226.072 300.464 226.974 298.265 226.418 296.517L214.485 259.02C213.929 257.272 212.125 256.636 210.456 257.6Z",
    fill: "#08181E"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M179.525 269.447L186.079 272.673C186.579 271.766 187.308 270.969 188.145 270.481L210.458 257.603C211.318 257.103 212.215 257.034 212.963 257.327L212.961 257.316L206.462 254.12L206.464 254.131C205.701 253.816 204.788 253.865 203.892 254.377L181.592 267.254C180.755 267.743 180.026 268.54 179.525 269.447Z",
    fill: "#002F3F"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M182.833 263.06C182.469 260.517 182.714 262.231 182.103 257.958C181.007 250.304 185.408 241.045 191.932 237.278C194.926 235.549 197.84 235.293 200.23 236.244L200.237 236.229L204.203 238.381L201.574 244.169L202.125 248.021C202.38 249.801 205.568 253.422 203.899 254.386L196.71 258.537L187.923 266.943L184.046 264.828L184.044 264.827L184.036 264.823L184.037 264.822C183.41 264.553 182.959 263.945 182.833 263.06Z",
    fill: "#002F3F"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M189.766 251.031L183.424 247.897C185.129 243.44 188.174 239.447 191.931 237.278C194.925 235.549 197.839 235.293 200.229 236.244L200.236 236.229L204.202 238.381L201.573 244.169L201.837 246.014L189.766 251.031Z",
    fill: "#002F3F"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M186.672 265.16C186.308 262.618 186.553 264.331 185.942 260.058C184.846 252.404 189.247 243.145 195.771 239.378C202.296 235.611 208.473 238.762 209.569 246.417L210.299 251.518C210.554 253.299 209.408 255.523 207.738 256.487L190.156 266.638C188.486 267.602 186.927 266.941 186.672 265.16Z",
    fill: "#08181E"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M281.633 270.523C286.185 273.298 289.753 275.656 295.642 279.616C302.042 283.92 307.338 287.52 309.319 291.302C311.087 294.677 311.004 299.222 308.859 304.741C306.714 310.26 295.311 329.218 295.311 329.218L287.747 321.983C287.747 321.983 289.871 309.693 291.291 306.298C292.404 303.637 293.459 302.79 293.459 302.79L272.832 294.934L268.079 283.925C269.177 277.886 275.729 272.174 281.633 270.523Z",
    fill: "#002F3F"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M247.164 276.271C247.164 278.514 247.141 284.391 247.794 288.364C248.515 292.748 249.641 296.802 256.593 301.843C263.264 306.68 280.361 314.074 281.135 315.51C281.59 321.101 282.598 324.077 284.291 327.417C287.433 333.616 291.087 340.841 291.087 340.841C295.123 341.516 300.262 340.262 302.452 338.217C302.452 338.217 300.607 328.317 299.181 321.715C296.742 310.416 296.547 304.957 294.149 302.265C291.721 299.539 278.583 288.796 278.583 288.796C278.583 288.796 280.778 287.48 282.19 279.887C282.865 276.253 282.19 270.357 282.19 270.357C282.19 270.357 259.555 279.042 247.164 276.271Z",
    fill: "#002F3F"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M270.911 233.645C275.586 234.396 277.907 236.734 283.095 243.645C288.952 251.446 291.594 255.169 291.594 255.169L314.393 264.157L309.837 269.447C309.837 269.447 296.191 266.988 290.957 265.549C287.109 264.491 285.895 264.502 282.19 260.67C278.946 257.315 272.123 249.135 272.123 249.135L270.911 233.645Z",
    fill: "#FFA8A7"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M270.877 233.027C274.589 233.612 276.461 235.007 277.448 235.995C278.435 236.982 284.169 244.546 287.131 248.699C287.131 248.699 286.605 250.7 283.542 253.493C280.693 256.092 277.993 256.08 277.993 256.08L271.763 248.693L270.877 233.027Z",
    fill: "#F78C3A"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M261.655 233.445C257.686 233.74 251.567 236.969 247.144 239.395C244.164 241.739 244.233 249.95 244.782 256.194C245.7 266.624 245.724 268.855 246.619 278.554C247.11 284.363 247.26 285.901 247.26 285.901C259.269 287.834 276.237 283.569 282.19 270.357C282.19 270.357 279.829 264.076 277.975 246.044C277.031 236.859 272.881 234.582 270.876 233.437C268.424 233.065 264.69 233.22 261.655 233.445Z",
    fill: "#FAFAFA"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M254.616 230.178C254.121 227.617 251.501 224.992 250.297 222.777C249.136 220.641 248.436 218.979 248.516 216.944C248.563 215.739 249.284 214.09 250.169 213.727C249.034 209.277 252.343 207.124 254.116 206.659C254.796 206.481 255.919 206.203 256.566 205.914C257.526 205.487 257.727 204.702 258.493 204.021C259.731 202.92 262.137 202.724 262.923 204.474C263.782 203.805 264.875 203.44 265.965 203.461C266.678 203.474 267.41 203.66 267.962 204.113C268.514 204.566 268.849 205.317 268.685 206.011C270.051 205.683 271.602 206.13 272.503 207.208C273.404 208.286 273.548 209.965 272.757 211.126C273.574 211.762 273.945 212.916 273.652 213.909C273.359 214.902 272.421 215.669 271.39 215.76C271.653 215.737 271.158 217.438 271.078 217.574C270.747 218.136 270.196 218.656 269.614 218.949C267.737 219.897 265.644 220.239 263.61 220.709C262.805 220.895 262 221.081 261.195 221.267C261.054 221.3 260.323 221.361 260.238 221.488L254.616 230.178Z",
    fill: "#97382B"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M251.425 226.924C253.257 227.962 254.455 226.765 254.455 226.765L254.722 235.818C256.91 238.909 261.636 239.136 264.08 238.457C267.238 237.58 266.465 235.163 264.959 233.92L264.988 232.437C264.988 232.437 266.477 232.433 267.681 232.236C269.69 231.914 271.599 229.744 272.057 228.041C272.67 225.762 272.665 222.107 272.106 219.384C271.963 218.688 271.891 217.977 271.948 217.269C272.099 215.389 271.737 214.307 271.216 212.743C268.957 211.007 263.133 210.719 258.415 213.737C259.033 216.571 258.657 218.649 256.611 219.782C256.725 220.548 256.865 222.487 255.601 222.48C254.69 222.475 254.603 221.335 253.646 220.351C252.669 219.346 250.501 219.145 249.69 220.648C248.559 222.75 249.418 225.787 251.425 226.924Z",
    fill: "#FFA8A7"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M264.988 232.437C261.782 232.133 259.344 231.84 257.625 229.561C256.547 228.132 255.872 225.936 255.872 225.936C255.872 225.936 256.004 228.639 257.091 230.534C257.929 231.994 259.967 233.182 264.99 233.5L264.988 232.437Z",
    fill: "#F28F8F"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M263.583 219.923C263.587 220.465 263.167 220.907 262.645 220.909C262.123 220.912 261.697 220.474 261.693 219.931C261.689 219.388 262.109 218.947 262.631 218.945C263.153 218.943 263.579 219.381 263.583 219.923Z",
    fill: "#002F3F"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M262.662 217.063L260.789 218.216C260.479 217.677 260.647 216.982 261.164 216.664C261.681 216.345 262.352 216.524 262.662 217.063Z",
    fill: "#002F3F"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M270.613 217.217L268.526 216.472C268.712 215.883 269.329 215.573 269.906 215.779C270.482 215.984 270.798 216.628 270.613 217.217Z",
    fill: "#002F3F"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M270.652 219.353C270.656 219.895 270.236 220.337 269.714 220.339C269.192 220.341 268.766 219.904 268.762 219.361C268.758 218.819 269.178 218.377 269.7 218.375C270.222 218.373 270.648 218.811 270.652 219.353Z",
    fill: "#002F3F"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M269.975 223.423L266.874 224.879L265.778 218.761C266.932 218.32 268.489 221.11 269.975 223.423Z",
    fill: "#F28F8F"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M262.921 225.809L266.701 226.534C266.524 227.612 265.534 228.324 264.49 228.124C263.446 227.924 262.744 226.888 262.921 225.809Z",
    fill: "#B16668"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M263.389 226.413C263.229 226.399 263.074 226.409 262.923 226.429C263.041 227.259 263.651 227.963 264.49 228.124C264.701 228.164 264.907 228.159 265.107 228.129C265.146 227.262 264.393 226.499 263.389 226.413Z",
    fill: "#F28F8F"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M237.271 292.905C236.431 289.89 235.611 290.058 238.403 288.645C242.116 286.765 245.957 284.92 246.601 285.766C247.245 286.612 248.465 290.283 248.745 291.848C249.025 293.414 243.409 294.653 241.006 295.087C237.564 295.709 237.787 294.756 237.271 292.905Z",
    fill: "#002F3F"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M270.189 233.125C272.173 242.862 273.623 273.359 245.153 286.84L247.163 291.831C247.163 291.831 264.847 288.982 274.387 283.455C283.927 277.928 284.722 271.249 284.722 271.249L282.189 268.7C282.189 268.7 278.693 280.242 253.716 286.344C267.298 278.503 278.883 258.841 273.682 233.688L270.189 233.125Z",
    fill: "black"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M315.387 270.768C314.912 267.25 313.319 264.566 310.777 263.102C309.467 262.344 308.004 261.959 306.437 261.959C304.344 261.959 302.071 262.627 299.76 263.962C292.184 268.341 286.252 278.626 286.252 287.371V287.512L291.028 284.777C291.247 283.377 291.632 281.939 292.158 280.514C292.441 279.782 292.749 279.05 293.108 278.318C295.163 273.978 298.437 270.01 302.045 267.93C303.624 267.005 305.127 266.556 306.436 266.556C307.207 266.556 307.9 266.723 308.491 267.057C308.812 267.25 309.107 267.481 309.377 267.776C309.891 268.328 310.289 269.073 310.546 269.959C310.828 270.858 310.97 271.924 310.97 273.092V273.31L315.387 270.768Z",
    fill: "#002F3F"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M305.114 276.675L297.576 281.002L296.677 281.529C296.703 281.336 296.754 281.131 296.805 280.938C296.985 280.193 297.28 279.435 297.665 278.716C298.449 277.226 299.604 275.904 300.901 275.159C302.005 274.53 303.007 274.427 303.764 274.761C304.446 275.07 304.934 275.725 305.114 276.675Z",
    fill: "#002F3F"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M312.484 267.544L310.545 269.958L305.191 276.622L305.127 276.712C305.127 276.699 305.127 276.686 305.114 276.673L297.576 281L296.805 280.936L292.157 280.512L290.09 280.332L290.283 278.059L293.108 278.316L297.666 278.714L300.388 278.958L303.765 274.759L309.376 267.773L310.712 266.117L312.484 267.544Z",
    fill: "#002F3F"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M314.144 266.679C314.661 267.839 314.771 268.417 313.702 269.559C312.633 270.701 310.818 271.122 310.818 271.122L310.546 269.96C310.546 269.96 309.203 270.996 309.119 271.737C309.057 272.279 309.422 272.627 309.353 272.922C309.283 273.218 309.127 273.478 309.196 273.965L317.976 269.393C317.976 269.393 317.489 267.898 317.159 267.15C316.829 266.402 315.316 264.467 314.395 264.157C313.474 263.847 312.188 264.124 312.188 264.124C312.188 264.124 313.507 265.29 314.144 266.679Z",
    fill: "#FFA8A7"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M293.604 280.502C293.061 280.009 292.563 279.513 292.563 279.513L292.026 280.88C292.026 280.88 290.792 282.427 289.213 282.229C287.634 282.032 287.048 281.529 287.048 281.529L287.833 279.021C287.833 279.021 286.845 279.267 285.365 279.613C283.853 279.966 282.799 280.722 281.218 280.955C277.324 281.528 260.854 272.629 258.396 271.18L254.331 252.673C254.331 252.673 252.92 242.229 247.172 239.793C240.521 243.709 240.84 247.315 242.615 256.206C244.414 265.22 247.309 275.556 248.191 278.051C248.634 279.305 249.11 281.577 253.207 282.768C259.7 284.656 273.789 289.341 280.275 289.6C285.807 286.265 294.294 282.176 294.294 282.176C294.294 282.176 294.147 280.995 293.604 280.502Z",
    fill: "#FFA8A7"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M247.144 239.395C242.45 241.83 240.218 245.183 241.52 252.112C242.822 259.041 244.486 265.449 244.486 265.449C244.486 265.449 247.056 266.418 251.198 265.449C255.34 264.48 256.755 262.17 256.755 262.17C256.755 262.17 254.371 250.344 253.626 247.316C252.881 244.289 250.572 240.164 247.144 239.395Z",
    fill: "#F78C3A"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M257.907 315.297C255.73 313.036 254.325 312.232 245.603 307.863C237.595 303.852 228.165 300.441 228.165 300.441L220.618 312.221L230.36 318.921L244.494 324.889C244.494 324.889 242.847 327.09 241.967 330.576C241.687 331.683 239.501 343.862 239.501 343.862L247.435 350.569C247.435 350.569 254.576 334.303 257.584 326.464C260.415 319.087 258.724 316.145 257.907 315.297Z",
    fill: "#C8856A"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M230.264 295.498C232.688 297.131 235.269 298.304 241.594 301.736C247.286 304.824 256.552 310.063 258.744 313.797C260.701 317.128 260.408 320.509 258.507 326.205C256.606 331.901 247.152 351.79 247.152 351.79L239.134 344.834C239.134 344.834 240.681 332.282 241.952 328.773C242.949 326.023 243.975 325.113 243.975 325.113L222.696 318.172L217.339 307.256C218.155 301.084 224.366 297.461 230.264 295.498Z",
    fill: "#08181E"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M247.153 351.789L239.135 344.833C239.135 344.833 240.682 332.281 241.953 328.772C242.387 327.573 242.827 326.725 243.185 326.148C245.163 328.232 246.31 329.384 247.856 334.931C248.556 337.444 249.49 341.444 250.301 345.072C248.512 348.93 247.153 351.789 247.153 351.789Z",
    fill: "#002F3F"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M228.299 304.182C229.013 308.796 229.201 312.335 229.201 312.335L242.001 324.469L222.697 318.172L228.299 304.182Z",
    fill: "#002F3F"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M239.615 305.689C242.318 306.983 248.65 311.488 250.076 312.569C252.296 314.251 253.309 315.156 254.304 316.211C254.796 316.739 255.25 317.302 255.573 317.903C255.73 318.203 255.85 318.512 255.894 318.812C255.932 319.143 255.949 319.489 255.927 319.845C255.853 321.27 255.536 322.731 255.174 324.163C254.819 325.603 254.39 327.029 253.951 328.454C253.051 331.298 252.099 334.135 251.112 336.967C252.446 334.279 253.64 331.522 254.661 328.693C255.178 327.281 255.639 325.847 256.045 324.39C256.422 322.926 256.788 321.45 256.858 319.88C256.877 319.488 256.857 319.084 256.803 318.673C256.733 318.231 256.567 317.836 256.375 317.476C255.983 316.758 255.474 316.156 254.928 315.608C253.835 314.513 252.909 313.681 250.585 311.997C248.059 310.164 242.451 306.661 239.615 305.689Z",
    fill: "#002F3F"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M197.87 300.944C197.266 303.032 196.345 307.88 196.917 311.922C197.491 315.983 198.091 320.582 206.588 325.967C213.646 330.44 231.264 337.185 232.119 338.602C232.856 344.242 234.022 347.207 235.902 350.507C239.39 356.631 243.446 363.77 243.446 363.77C247.567 364.255 251.212 363.156 253.329 360.976C253.329 360.976 250.715 350.701 248.947 344.084C245.921 332.76 245.282 329.196 242.72 326.587C240.126 323.945 239.272 323.168 239.272 323.168L227.592 312.893C227.592 312.893 228.357 309.778 228.299 304.181C228.261 300.433 226.619 295.645 226.619 295.645C226.619 295.645 210.557 303.14 197.87 300.944Z",
    fill: "#08181E"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M205.505 314.544L205.399 314.347C202.754 311.175 202.99 307.8 203.301 303.387C203.353 302.642 203.404 301.867 203.446 301.068C203.602 301.079 203.759 301.089 203.914 301.098C203.871 301.899 203.821 302.674 203.768 303.42C203.471 307.639 203.253 310.882 205.646 313.891C208.613 311.85 207.333 306.767 206.548 303.677C206.419 303.167 206.302 302.709 206.219 302.322L206.678 302.223C206.76 302.605 206.875 303.057 207.003 303.56C207.817 306.765 209.153 312.036 205.952 314.264C206.368 314.739 206.848 315.21 207.411 315.678C210.269 318.049 217.345 322.931 223.588 327.238C228.521 330.641 232.781 333.58 233.749 334.453C234.971 335.555 236.023 339.197 237.355 343.808C238.447 347.589 245.785 361.34 247.504 363.555C247.32 363.572 247.132 363.584 246.942 363.594C245.138 361.241 238 347.732 236.905 343.939C235.645 339.579 234.558 335.814 233.435 334.801C232.49 333.949 228.241 331.018 223.321 327.624C217.07 323.311 209.985 318.424 207.111 316.039C206.504 315.535 205.987 315.03 205.544 314.52C205.533 314.527 205.52 314.536 205.505 314.544Z",
    fill: "#002F3F"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M211.942 303.014C211.952 304.52 212.241 306.023 212.68 307.469C213.115 308.92 213.725 310.315 214.442 311.649C215.174 312.975 216.016 314.24 216.983 315.402C217.944 316.566 219.015 317.64 220.207 318.557C219.291 317.364 218.4 316.182 217.568 314.962C216.743 313.74 215.962 312.494 215.265 311.2C214.554 309.915 213.929 308.584 213.367 307.224C212.812 305.86 212.338 304.464 211.942 303.014Z",
    fill: "#002F3F"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M210.915 303.172C210.581 304.409 210.469 305.699 210.466 306.978C210.458 308.261 210.583 309.539 210.776 310.803C210.987 312.065 211.274 313.313 211.666 314.53C212.055 315.744 212.531 316.948 213.214 318.033C212.892 316.797 212.626 315.575 212.375 314.345C212.134 313.115 211.892 311.887 211.702 310.652C211.495 309.42 211.335 308.182 211.194 306.94C211.062 305.697 210.968 304.45 210.915 303.172Z",
    fill: "#002F3F"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M232.37 321.785C234.162 323.639 236.018 325.428 237.794 327.269C238.675 328.196 239.538 329.135 240.312 330.13C241.077 331.128 241.779 332.173 242.217 333.316C242.645 334.49 243.074 335.723 243.483 336.933L244.738 340.577C245.57 343.009 246.45 345.429 247.369 347.839C246.818 345.319 246.184 342.82 245.463 340.347C244.738 337.868 243.991 335.424 243.079 332.974C242.573 331.717 241.826 330.599 240.986 329.593C240.151 328.58 239.236 327.653 238.289 326.77C236.397 325 234.391 323.385 232.37 321.785Z",
    fill: "#002F3F"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M252.893 359.398C251.619 361.11 245.181 363.156 242.624 362.412L244.023 365.602C244.023 365.602 245.768 366.164 249.674 365.202C253.58 364.24 253.799 362.605 253.799 362.605L252.893 359.398Z",
    fill: "#002F3F"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M200.8 297.677C203.202 298.604 207.246 299.497 213.287 298.562C219.327 297.627 224.987 294.133 226.501 292.131L227.571 295.189C227.571 295.189 223.256 300.221 213.902 301.831C204.548 303.441 200.705 300.74 200.705 300.74L200.8 297.677Z",
    fill: "#002F3F"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M217.172 263.549C223.567 264.536 224.246 265.894 227.341 269.169C231.541 273.612 236.84 279.544 236.84 279.544L253.542 273.226L254.028 282.35C254.028 282.35 242.382 288.653 238.456 290.217C235.519 291.387 233.748 290.091 231.282 288.048C227.504 284.917 219.859 278.454 219.859 278.454L217.172 263.549Z",
    fill: "#C8856A"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M259.548 261.383L239.533 270.005L235.229 296.115L235.72 296.571L254.72 287.971L260.037 261.84L259.548 261.383Z",
    fill: "#3AF7EC"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M260.038 261.84L240.025 270.461L235.721 296.571L254.721 287.971L260.038 261.84Z",
    fill: "#2797FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.2 267.255C254.2 267.255 254.251 266.884 254.314 266.426C254.377 265.968 253.19 266.287 251.662 267.138L248.037 268.509C246.51 269.36 245.056 270.016 244.993 270.474L244.879 271.303L254.2 267.255Z",
    fill: "black"
  }))), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M255.167 263.474C255.207 263.188 254.743 263.277 254.1 263.495L252.946 263.977C252.946 263.977 253.267 262.552 250.604 263.704C247.196 265.178 247.624 266.285 247.624 266.285C247.624 266.285 247.285 266.482 246.183 266.924C245.185 267.325 245.085 267.532 245.021 267.824L244.905 268.353L255.107 263.965C255.107 263.965 255.127 263.76 255.167 263.474Z",
    fill: "#08181E"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M254.176 265.115C253.238 265.62 252.85 265.861 252.753 266.567C252.642 267.374 252.629 267.708 252.629 267.708L247.332 270.224C247.332 270.224 247.547 269.033 247.593 268.638C247.639 268.242 246.919 268.288 246.006 268.788L246.164 267.796L254.365 264.291L254.176 265.115Z",
    fill: "#002F3F"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M254.481 267.249C254.481 267.249 254.532 266.878 254.595 266.42C254.658 265.962 253.471 266.281 251.943 267.132L248.318 268.503C246.791 269.354 245.337 270.01 245.274 270.468L245.16 271.297L254.481 267.249Z",
    fill: "#002F3F"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M259.161 273.042C259.671 271.762 259.563 271.635 259.004 271.184C258.445 270.733 257.276 270.052 255.865 270.446C254.916 270.711 253.946 270.931 253.515 271.307C253.085 271.683 253.761 272.617 255.076 272.588C257.148 272.543 257.268 273.079 257.268 273.079C257.268 273.079 255.36 273.122 254.623 273.261C253.887 273.4 252.647 274.073 251.851 274.408C251.055 274.743 251.156 275.852 252.65 275.873C252.65 275.873 251.646 276.299 251.193 276.491C250.173 276.923 249.951 277.578 250.948 278.029C251.185 278.136 251.505 278.249 251.999 278.152C251.999 278.152 250.867 278.431 250.937 278.813C251.137 279.908 251.906 280.018 254.356 280.117C255.215 280.152 255.63 280.771 255.826 281.275C255.956 281.61 255.984 281.974 255.913 282.327C255.845 282.66 255.752 283.111 255.701 283.314C255.701 283.314 257.951 281.462 258.599 280.728C259.074 280.191 259.449 279.626 258.97 278.796C258.97 278.796 260.222 278.512 260.107 277.723C259.993 276.934 259.398 276.146 259.398 276.146C259.398 276.146 260.04 275.605 259.769 274.698C259.498 273.792 258.981 273.456 258.981 273.456L259.161 273.042Z",
    fill: "#C8856A"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M252.65 275.876C253.09 275.694 253.495 275.488 253.99 275.386C254.504 275.307 254.971 275.41 255.429 275.479C256.348 275.647 257.262 275.847 258.15 276.171C257.202 276.17 256.279 276.044 255.361 275.888C254.903 275.808 254.445 275.698 254.025 275.706C253.598 275.74 253.118 275.851 252.65 275.876Z",
    fill: "#AF6152"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M251.999 278.153C252.437 277.895 252.962 277.754 253.479 277.739C253.997 277.712 254.507 277.767 255.009 277.836C256.01 277.993 256.995 278.219 257.948 278.583C256.93 278.541 255.937 278.389 254.949 278.246C253.958 278.105 252.997 277.927 251.999 278.153Z",
    fill: "#AF6152"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M198.366 292.851C198.193 291.657 197.882 289.607 196.242 286.24C194.601 282.873 194.423 278.69 193.896 275.711C193.114 271.294 193.435 268.856 194.744 267.823C194.744 267.823 197.753 266.223 198.827 265.924C200.326 265.506 202.76 264.856 205.813 264.139C211.051 262.908 217.174 263.547 217.174 263.547C220.21 265.365 222.268 266.55 226.262 270.859C228.659 273.444 230.588 278.221 227.006 282.488C227.206 283.386 227.746 283.469 228.412 289.658C229.775 292.099 231.087 293.027 230.775 296.044C230.775 296.044 226.671 303.393 215.896 304.655C203.752 306.078 199.372 302.144 198.029 301.397C196.293 300.383 198.718 295.27 198.366 292.851Z",
    fill: "#F5F5F5"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M198.027 301.395C197.778 301.266 197.594 301.028 197.489 300.765C197.384 300.5 197.343 300.216 197.324 299.935C197.293 299.37 197.352 298.809 197.425 298.255C197.593 297.149 197.848 296.065 198.017 294.978C198.098 294.436 198.163 293.891 198.159 293.363C198.145 292.856 198.022 292.294 197.921 291.764C197.703 290.693 197.378 289.644 196.982 288.621C196.784 288.109 196.575 287.601 196.347 287.1C196.122 286.604 195.872 286.103 195.659 285.573C195.246 284.521 194.938 283.435 194.727 282.335C194.512 281.237 194.366 280.131 194.239 279.026C194.13 277.918 194.023 276.816 193.896 275.711C194.38 277.883 194.622 280.102 195.143 282.244C195.411 283.312 195.714 284.369 196.143 285.373C196.355 285.869 196.599 286.363 196.839 286.875C197.074 287.383 197.293 287.9 197.498 288.422C197.893 289.473 198.226 290.554 198.433 291.663C198.525 292.224 198.635 292.755 198.642 293.36C198.638 293.943 198.544 294.502 198.434 295.053C198.21 296.152 197.911 297.221 197.691 298.302C197.579 298.841 197.48 299.385 197.47 299.932C197.468 300.46 197.546 301.071 198.027 301.395Z",
    fill: "#E0E0E0"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M221.034 284.27C220.939 278.941 219.541 276.838 218.06 274.612C217.827 274.262 217.59 273.906 217.354 273.531L216.865 273.839C217.104 274.218 217.343 274.578 217.579 274.932C219.073 277.179 220.364 279.119 220.457 284.279C220.533 288.51 221.842 296.343 223.029 302.649C223.211 302.563 223.392 302.476 223.568 302.386C222.392 296.134 221.109 288.433 221.034 284.27Z",
    fill: "#E0E0E0"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M217.343 284.365C217.343 284.365 214.575 288.462 209.847 288.347C207.562 288.292 205.953 287.445 204.901 286.585C204.605 286.343 204.214 286.73 204.447 287.033C205.442 288.327 207.222 289.675 210.309 289.623C215.987 289.527 217.343 284.365 217.343 284.365Z",
    fill: "#E0E0E0"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M194.54 237.091C193.793 237.833 193.295 238.669 192.932 239.633C192.156 241.694 190.079 242.703 188.896 244.504C188.061 245.776 187.602 247.379 188.024 248.84C188.402 250.149 189.431 251.198 189.794 252.512C190.243 254.136 189.605 255.881 189.877 257.544C190.182 259.415 191.742 261.014 193.605 261.366C194.866 261.604 196.13 261.308 197.393 261.27C198.657 261.232 199.795 261.699 201.04 261.858C202.042 261.986 204.219 261.703 204.512 260.495C204.647 259.94 204.472 259.111 204.455 258.545C204.427 257.618 204.359 256.692 204.264 255.77C203.89 252.159 203.085 248.614 202.377 245.059C201.992 243.129 202.558 241.392 202.733 239.45C202.825 238.436 203.05 237.175 202.252 236.387C201.87 236.009 201.366 235.776 200.853 235.616C199.207 235.101 197.355 235.289 195.845 236.122C195.337 236.4 194.908 236.726 194.54 237.091Z",
    fill: "black"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M199.757 235.816C199.195 236.2 198.712 236.726 198.419 237.293C198.116 237.88 197.972 238.541 197.943 239.202C197.928 239.541 197.945 239.893 198.103 240.193C198.381 240.723 198.997 240.714 199.521 240.693C200.139 240.668 200.69 240.297 201.138 239.871C202.008 239.043 203.085 237.497 202.892 236.211C202.734 235.162 201.7 235.056 200.845 235.297C200.468 235.402 200.098 235.582 199.757 235.816Z",
    fill: "#F78C3A"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M202.517 235.366C202.869 235.144 203.233 234.944 203.607 234.765C205.639 233.794 207.929 233.445 210.18 233.505C213.534 233.595 216.664 234.893 218.777 237.554C221.229 240.641 221.181 244.635 218.627 247.694C215.29 251.69 208.409 252.047 206.346 257.317C205.925 258.391 205.706 259.544 205.101 260.539C205.033 260.65 204.933 260.769 204.803 260.762C204.708 260.757 204.633 260.684 204.566 260.616C201.343 257.328 198.255 253.791 196.36 249.595C195.187 246.999 195.437 243.701 197.467 241.554C197.748 241.256 198.058 240.982 198.286 240.642C198.555 240.239 198.694 239.766 198.879 239.318C199.551 237.686 201.04 236.297 202.517 235.366Z",
    fill: "black"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M215.117 240.318C215.136 240.321 215.155 240.325 215.174 240.329C217.565 240.803 218.442 243.923 218.492 246.007C218.514 246.922 219.117 248.273 219.224 250.784C219.415 255.286 218.283 258.675 215.788 259.781C213.824 260.652 212.281 260.665 212.281 260.665L212.311 263.995C212.311 263.995 217.238 267.244 217.437 274.353C206.045 270.361 202.001 264.78 202.001 264.78L201.727 255.46C201.727 255.46 200.837 256.544 198.921 255.444C197.361 254.549 196.415 251.805 197.655 250.268C198.894 248.731 200.643 249.003 201.3 250.597C201.557 251.22 202.273 251.943 202.872 251.251C203.225 250.844 203.202 250.311 203.225 249.809C203.251 249.23 203.452 249.02 203.817 248.595C204.361 247.962 204.338 247.021 204.159 246.206C203.98 245.391 203.673 244.579 203.751 243.748C203.862 242.564 204.781 241.552 205.888 241.119C206.995 240.686 208.252 240.769 209.387 241.124C210.275 241.401 211.24 241.838 212.088 241.455C212.458 241.288 212.745 240.985 213.08 240.757C213.669 240.355 214.416 240.195 215.117 240.318Z",
    fill: "#C8856A"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M201.972 263.982L202.001 264.78C202.001 264.78 207.594 268.294 217.437 274.353C213.529 274.22 207.731 274.657 205.512 273.458C205.041 273.203 206.008 270.851 206.008 270.851L198.071 266.202L201.972 263.982Z",
    fill: "#E0E0E0"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M217.439 274.353C217.439 274.353 218.671 272.92 218.611 270.562C218.601 270.156 216.571 268.386 216.571 268.386L216.05 263.462L212.303 262.965L212.312 263.994C212.312 263.994 216.922 267.757 217.439 274.353Z",
    fill: "#E0E0E0"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M210.065 253.908L213.072 254.836C212.845 255.683 211.988 256.162 211.158 255.905C210.328 255.649 209.838 254.754 210.065 253.908Z",
    fill: "#AF6152"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M211.947 246.438L212.643 252.785L215.788 251.82L211.947 246.438Z",
    fill: "#AF6152"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M209.822 248.37C209.793 248.929 209.317 249.358 208.758 249.329C208.199 249.3 207.77 248.824 207.799 248.265C207.828 247.706 208.305 247.277 208.863 247.306C209.422 247.335 209.851 247.811 209.822 248.37Z",
    fill: "#002F3F"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M217.07 247.861C216.965 248.41 216.435 248.771 215.886 248.667C215.337 248.562 214.976 248.032 215.081 247.483C215.186 246.934 215.716 246.573 216.265 246.678C216.814 246.781 217.174 247.311 217.07 247.861Z",
    fill: "#002F3F"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M217.317 245.271L214.792 244.623C214.971 243.926 215.681 243.505 216.379 243.684C217.076 243.864 217.496 244.574 217.317 245.271Z",
    fill: "#002F3F"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M206.86 246.658L209.169 245.447C208.835 244.809 208.047 244.563 207.409 244.898C206.772 245.233 206.526 246.021 206.86 246.658Z",
    fill: "#002F3F"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M212.282 260.665C208.579 260.467 205.653 259.616 203.183 256.42C203.183 256.42 203.366 258.124 205.535 260.009C207.483 261.702 212.292 261.712 212.292 261.712L212.282 260.665Z",
    fill: "#AF6152"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M211.849 255.949C211.813 255.178 211.165 254.578 210.392 254.604C210.274 254.608 210.161 254.631 210.052 254.662C210.171 255.231 210.578 255.724 211.159 255.904C211.392 255.976 211.626 255.984 211.849 255.949Z",
    fill: "#FFA8A7"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M209.607 288.912C208.376 289.935 197.43 293.457 197.43 293.457L197.866 282.563C197.866 282.563 200.268 272.365 195.256 268.57C190.578 269.715 188.955 270.328 187.517 274.755C186.083 279.169 185.669 299.03 186.121 302.023C186.629 305.377 186.838 308.324 192.272 307.163C197.84 305.973 207.388 298.244 213.439 295.331L209.607 288.912Z",
    fill: "#C8856A"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M197.519 292.275L197.429 293.455C195.009 294.412 192.533 296.552 192.104 297.995C192.298 295.768 193.264 294.001 197.519 292.275Z",
    fill: "#AF6152"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M220.618 281.511C213.629 275.561 193.778 263.755 178.029 261.191L178.285 264.952C202.291 269.953 226.201 289.986 230.772 296.044L232.369 293.414C232.369 293.414 229.046 288.686 220.618 281.511Z",
    fill: "black"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 280.893C218.324 279.17 219.249 278.474 220.139 278.098C221.029 277.721 224.097 275.969 225.299 275.504C226.062 275.209 226.537 276.421 225.643 277.408C224.954 278.168 223.057 279.288 222.237 279.881C221.417 280.473 219.952 282.79 219.952 282.79L216.53 280.893Z",
    fill: "#AF6152"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M225.604 284.306C225.363 284.089 225.099 284.095 225.099 284.095C225.099 284.095 225.127 283.921 224.937 283.147C224.648 281.974 223.566 282.133 222.83 282.133C222.83 282.133 222.79 281.432 222.167 281.137C221.544 280.843 220.916 280.688 218.136 280.62C217.287 280.599 216.447 280.49 215.005 282.269C213.945 283.576 210.838 287.888 209.606 288.911L213.438 295.329C215.057 294.549 216.333 294.407 216.934 294.185C219.781 293.129 219.502 289.991 221.524 288.137L222.543 287.947C222.543 287.947 222.295 288.737 223.042 288.744C223.92 288.753 224.571 288.619 224.98 288.147C225.564 287.476 226.295 284.929 225.604 284.306Z",
    fill: "#C8856A"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M222.831 282.131L219.509 281.883L222.707 281.691C222.776 281.837 222.819 281.984 222.831 282.131Z",
    fill: "#AF6152"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1 284.095L221.31 284.079L225.051 283.662C225.083 283.794 225.098 283.94 225.1 284.095Z",
    fill: "#AF6152"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M224.815 285.799C224.726 286.005 224.556 286.173 224.367 286.297C224.18 286.427 223.974 286.52 223.757 286.595L223.802 286.553C223.727 286.76 223.645 286.965 223.56 287.169L223.47 287.079C223.682 287.013 223.901 287.046 224.081 287.15C224.261 287.254 224.384 287.422 224.467 287.597C224.35 287.441 224.2 287.316 224.036 287.238C223.871 287.169 223.677 287.155 223.519 287.209L223.379 287.256L223.429 287.118C223.505 286.911 223.583 286.705 223.669 286.501L223.683 286.469L223.715 286.459C223.919 286.397 224.121 286.309 224.313 286.21C224.502 286.105 224.688 285.985 224.815 285.799Z",
    fill: "#AF6152"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M223.883 286.402C223.521 286.525 222.545 286.666 222.545 286.666C222.545 286.666 222.55 286.936 222.171 287.441C221.968 287.711 221.524 288.136 221.524 288.136L222.543 287.946C222.543 287.946 222.736 287.456 223.638 287.163L223.883 286.402Z",
    fill: "#AF6152"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M232.37 293.414L230.773 296.044C218.791 307.635 188.246 310.86 188.246 310.86L193.445 313.594C193.445 313.594 210.344 310.878 219.952 306.944C229.262 303.132 233.465 297.5 233.465 297.5L232.37 293.414Z",
    fill: "black"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9274 287.186L91.2934 265.033L69.9784 252.727L49.2324 265.829L52.9274 287.186Z",
    fill: "#002F3F"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1008 281.927L63.5908 270.982L76.7008 263.393L76.7018 263.395C80.8718 260.997 86.4248 261.269 92.5218 264.789C105.47 272.265 115.967 291.548 115.969 307.859C115.97 316.4 113.088 322.427 108.487 325.162L108.49 325.168L108.305 325.275C108.296 325.28 108.287 325.286 108.278 325.291L94.8378 333.051L89.0258 321.506C78.0248 313.082 69.5278 296.477 69.1008 281.927Z",
    fill: "#08181E"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1008 281.927L63.5908 270.982L76.7008 263.393L76.7018 263.395C80.8718 260.997 86.4248 261.269 92.5218 264.789C105.47 272.265 115.967 291.548 115.969 307.859C115.97 316.4 113.088 322.427 108.487 325.162L108.49 325.168L108.305 325.275C108.296 325.28 108.287 325.286 108.278 325.291L94.8378 333.051L89.0258 321.506C78.0248 313.082 69.5278 296.477 69.1008 281.927Z",
    fill: "#002F3F"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4346 288.659C55.4346 302.722 63.2426 318.999 73.6956 328.003C73.7166 328.014 73.7276 328.035 73.7376 328.045C75.3956 329.462 77.1166 330.71 78.8796 331.729C91.8296 339.212 102.336 332.044 102.325 315.735C102.325 303.414 96.3316 289.383 87.8206 280.043C87.7996 280.022 87.7686 280.001 87.7476 279.97C85.0086 276.979 82.0176 274.471 78.8796 272.666C65.9296 265.194 55.4346 272.351 55.4346 288.659Z",
    fill: "#08181E"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8809 282.509C70.6409 277.751 63.9609 282.709 63.9609 293.583C63.9609 304.457 70.6409 317.129 78.8809 321.887C87.1209 326.645 93.8009 321.687 93.8009 310.813C93.8009 299.939 87.1209 287.266 78.8809 282.509Z",
    fill: "#002F3F"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1612 299.138C72.6862 304.548 76.1242 310.309 79.8302 311.995C81.4622 312.733 82.8692 312.564 83.8912 311.685C85.2072 310.577 85.8922 308.296 85.5972 305.256C85.0722 299.845 81.6452 294.083 77.9282 292.399C76.9232 291.938 75.9952 291.827 75.2022 292.02C75.2022 292.02 75.1912 292.011 75.1922 292.021C73.0502 292.536 71.7792 295.2 72.1612 299.138Z",
    fill: "#FAFAFA"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4972 298.449C74.0222 303.86 77.4602 309.621 81.1662 311.307C82.1692 311.758 83.0882 311.88 83.8912 311.685C85.2072 310.577 85.8922 308.296 85.5972 305.256C85.0722 299.845 81.6452 294.083 77.9282 292.399C76.9232 291.938 75.9952 291.827 75.2022 292.02C75.2022 292.02 75.1912 292.011 75.1922 292.021C73.8882 293.139 73.2032 295.42 73.4972 298.449Z",
    fill: "#E0E0E0"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4346 288.659C55.4346 302.722 63.2426 318.999 73.6956 328.003C67.5036 321.266 61.0916 309.984 58.8246 299.227C56.8416 289.824 57.5866 276.328 65.6566 272.917C73.6636 269.527 84.3786 276.695 87.7476 279.969C85.0086 276.978 82.0176 274.47 78.8796 272.665C65.9296 265.194 55.4346 272.351 55.4346 288.659Z",
    fill: "#002F3F"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0709 234C53.8249 222.771 73.6459 211.108 82.1019 215.342C84.7389 216.654 92.2259 221.191 101.66 226.625C101.66 226.625 132.69 245.396 135.556 247.051C135.556 247.051 120.721 246.801 117.358 248.022C113.995 249.243 114.653 251.815 114.88 252.772L116.574 258.271C120.429 277.079 154.859 293.418 154.859 293.418C154.859 293.418 160.299 296.356 164.058 298.299C167.716 300.189 189.193 311.569 192.363 313.402C198.061 316.693 207.295 320.887 207.295 320.887L207.294 376.072L109.793 320.171C109.793 318.685 109.719 317.175 109.558 315.64C107.825 297.701 94.6679 276.885 80.5669 268.751C65.2649 259.912 52.8589 268.169 52.8589 287.198L50.3819 285.767C41.5689 280.45 44.3289 245.217 49.0709 234Z",
    fill: "#E0E0E0"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M123.955 277.257C126.64 279.266 141.907 288.381 144.041 289.725C144.041 289.725 141.91 291.742 141.373 294.064C141.373 294.064 87.1241 262.751 73.8851 251.025C60.6461 239.298 53.3811 228.377 63.5931 222.695C66.7051 220.963 69.6121 218.645 73.3571 220.045C73.6271 220.146 73.8971 220.267 74.1071 220.464C74.4751 220.809 74.6041 221.331 74.7301 221.819C77.7381 233.478 87.2801 242.211 94.9851 251.027C102.539 259.671 114.479 270.165 123.955 277.257Z",
    fill: "#EBEBEB"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M118.238 267.709L124.246 271.454C137.252 282.237 147.465 289.573 154.859 293.419C164.058 298.203 205.515 320.004 205.515 320.004L205.514 370.397C205.42 371.528 204.19 372.215 203.179 371.64C190.315 364.319 128.405 329.065 120.812 324.373C112.332 319.133 112.165 316.851 109.803 306.978C106.825 294.533 101.29 286.388 98.0816 280.43C95.2216 275.119 111.73 271.321 118.238 267.709Z",
    fill: "#F78C3A"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M124.028 293.189C125.015 293.759 125.885 294.414 126.636 295.154C127.387 295.894 128.014 296.638 128.514 297.387C129.015 298.135 129.391 298.863 129.642 299.569C129.907 300.266 130.054 300.87 130.084 301.381C130.098 301.593 130.039 301.729 129.907 301.789C129.789 301.84 129.649 301.819 129.487 301.725L127.94 300.832C127.689 300.687 127.498 300.526 127.365 300.347C127.247 300.16 127.137 299.943 127.034 299.696C126.813 299.143 126.474 298.582 126.017 298.012C125.575 297.433 124.912 296.889 124.028 296.379C123.645 296.157 123.277 295.996 122.923 295.894C122.584 295.783 122.282 295.745 122.017 295.779C121.766 295.804 121.567 295.902 121.42 296.072C121.273 296.242 121.199 296.489 121.199 296.812C121.199 297.204 121.265 297.565 121.398 297.897C121.545 298.22 121.781 298.569 122.105 298.943C122.444 299.309 122.886 299.726 123.431 300.194C123.976 300.662 124.654 301.232 125.465 301.904C126.349 302.635 127.107 303.337 127.741 304.009C128.389 304.673 128.912 305.332 129.31 305.987C129.723 306.633 130.025 307.284 130.216 307.939C130.423 308.603 130.526 309.283 130.526 309.981C130.526 310.746 130.378 311.376 130.084 311.869C129.789 312.346 129.369 312.665 128.824 312.826C128.279 312.971 127.608 312.95 126.813 312.762C126.017 312.575 125.126 312.197 124.139 311.627C123.313 311.15 122.525 310.585 121.774 309.93C121.022 309.258 120.352 308.539 119.763 307.773C119.188 306.999 118.724 306.204 118.37 305.387C118.017 304.57 117.818 303.775 117.774 303.001C117.759 302.788 117.81 302.656 117.928 302.605C118.061 302.546 118.208 302.563 118.37 302.656L119.917 303.55C120.168 303.694 120.359 303.856 120.492 304.035C120.625 304.213 120.735 304.43 120.823 304.685C120.927 304.966 121.052 305.259 121.199 305.566C121.346 305.872 121.545 306.182 121.796 306.497C122.046 306.812 122.356 307.135 122.724 307.467C123.107 307.79 123.579 308.114 124.139 308.437C124.581 308.692 125.008 308.905 125.42 309.075C125.833 309.228 126.194 309.309 126.503 309.317C126.813 309.309 127.063 309.232 127.255 309.088C127.446 308.926 127.542 308.649 127.542 308.258C127.542 307.884 127.439 307.518 127.233 307.161C127.026 306.804 126.71 306.416 126.282 306C125.87 305.591 125.354 305.132 124.735 304.622C124.116 304.111 123.402 303.503 122.591 302.797C121.855 302.167 121.207 301.555 120.647 300.959C120.101 300.355 119.645 299.743 119.276 299.122C118.923 298.509 118.658 297.88 118.481 297.233C118.304 296.57 118.216 295.855 118.216 295.09C118.216 294.324 118.363 293.703 118.658 293.227C118.952 292.75 119.357 292.431 119.873 292.27C120.389 292.108 121 292.104 121.707 292.257C122.429 292.402 123.203 292.712 124.028 293.189ZM142.558 316.341C142.588 316.137 142.661 316.018 142.779 315.984C142.912 315.941 143.052 315.962 143.199 316.048L144.989 317.081C145.151 317.175 145.291 317.324 145.409 317.528C145.542 317.723 145.601 317.919 145.586 318.115C145.542 318.787 145.387 319.395 145.122 319.939C144.871 320.492 144.481 320.896 143.95 321.152C143.42 321.407 142.75 321.479 141.939 321.368C141.129 321.258 140.149 320.871 139 320.207C137.983 319.62 137.085 318.931 136.304 318.14C135.523 317.332 134.86 316.464 134.315 315.537C133.769 314.593 133.342 313.597 133.033 312.551C132.738 311.513 132.561 310.467 132.502 309.412C132.473 308.749 132.458 308.026 132.458 307.243C132.458 306.46 132.473 305.754 132.502 305.125C132.561 304.138 132.738 303.296 133.033 302.598C133.342 301.909 133.769 301.416 134.315 301.118C134.86 300.804 135.523 300.701 136.304 300.812C137.085 300.906 137.983 301.246 139 301.833C140.149 302.496 141.129 303.241 141.939 304.066C142.75 304.891 143.42 305.737 143.95 306.605C144.481 307.473 144.871 308.336 145.122 309.195C145.387 310.046 145.542 310.824 145.586 311.531C145.601 311.743 145.542 311.879 145.409 311.939C145.291 311.99 145.151 311.969 144.989 311.875L143.199 310.841C143.052 310.756 142.912 310.625 142.779 310.446C142.647 310.25 142.566 310.033 142.536 309.795C142.492 309.429 142.389 309.038 142.227 308.621C142.065 308.204 141.844 307.788 141.564 307.371C141.284 306.954 140.93 306.546 140.503 306.146C140.075 305.729 139.575 305.355 139 305.023C138.425 304.691 137.924 304.504 137.497 304.461C137.07 304.419 136.709 304.483 136.414 304.653C136.134 304.831 135.913 305.112 135.751 305.495C135.604 305.886 135.515 306.337 135.486 306.847C135.456 307.477 135.442 308.183 135.442 308.966C135.442 309.748 135.456 310.471 135.486 311.135C135.515 311.696 135.604 312.258 135.751 312.819C135.913 313.372 136.134 313.9 136.414 314.401C136.709 314.912 137.07 315.392 137.497 315.843C137.924 316.294 138.425 316.685 139 317.017C139.575 317.349 140.075 317.562 140.503 317.655C140.93 317.732 141.284 317.723 141.564 317.63C141.858 317.545 142.087 317.387 142.249 317.158C142.411 316.928 142.514 316.656 142.558 316.341ZM160.208 314.333C160.37 314.426 160.51 314.575 160.628 314.779C160.745 314.983 160.804 315.179 160.804 315.366V331.852C160.804 332.039 160.745 332.167 160.628 332.235C160.51 332.303 160.37 332.29 160.208 332.197L158.417 331.163C158.255 331.07 158.115 330.921 157.998 330.716C157.88 330.512 157.821 330.317 157.821 330.13V323.392L151.146 319.539V326.276C151.146 326.463 151.087 326.591 150.97 326.659C150.852 326.727 150.712 326.714 150.55 326.62L148.759 325.587C148.597 325.493 148.457 325.353 148.34 325.166C148.222 324.962 148.163 324.757 148.163 324.553V308.067C148.163 307.88 148.222 307.753 148.34 307.685C148.457 307.617 148.597 307.629 148.759 307.723L150.55 308.756C150.712 308.85 150.852 308.999 150.97 309.203C151.087 309.407 151.146 309.603 151.146 309.79V316.349L157.821 320.202V313.644C157.821 313.457 157.88 313.329 157.998 313.261C158.115 313.193 158.255 313.206 158.417 313.299L160.208 314.333ZM163.711 323.016C163.756 322.089 163.91 321.285 164.176 320.605C164.456 319.916 164.861 319.418 165.391 319.112C165.922 318.789 166.585 318.678 167.38 318.78C168.176 318.865 169.119 319.223 170.209 319.852C171.285 320.473 172.22 321.192 173.016 322.009C173.812 322.825 174.475 323.701 175.005 324.637C175.535 325.573 175.941 326.538 176.221 327.534C176.5 328.529 176.663 329.524 176.707 330.519C176.721 330.851 176.729 331.213 176.729 331.604C176.744 332.004 176.751 332.416 176.751 332.842C176.751 333.25 176.744 333.646 176.729 334.028C176.729 334.42 176.721 334.773 176.707 335.088C176.663 336.015 176.5 336.823 176.221 337.512C175.955 338.192 175.557 338.694 175.027 339.018C174.497 339.324 173.826 339.422 173.016 339.311C172.22 339.209 171.285 338.847 170.209 338.226C169.119 337.597 168.176 336.874 167.38 336.057C166.585 335.241 165.922 334.373 165.391 333.454C164.861 332.518 164.456 331.553 164.176 330.558C163.91 329.554 163.756 328.563 163.711 327.584C163.697 327.253 163.682 326.887 163.667 326.487C163.667 326.096 163.667 325.696 163.667 325.288C163.667 324.862 163.667 324.454 163.667 324.063C163.682 323.68 163.697 323.331 163.711 323.016ZM173.723 328.924C173.664 327.665 173.318 326.521 172.684 325.492C172.066 324.454 171.24 323.638 170.209 323.042C169.178 322.447 168.345 322.306 167.712 322.621C167.093 322.927 166.754 323.676 166.695 324.867C166.666 325.496 166.651 326.211 166.651 327.01C166.651 327.793 166.666 328.516 166.695 329.18C166.754 330.439 167.093 331.578 167.712 332.599C168.345 333.629 169.178 334.441 170.209 335.036C171.24 335.632 172.066 335.777 172.684 335.47C173.318 335.173 173.664 334.428 173.723 333.237C173.753 332.608 173.767 331.902 173.767 331.119C173.767 330.32 173.753 329.588 173.723 328.924ZM179.1 331.901C179.144 330.974 179.299 330.17 179.564 329.49C179.844 328.801 180.249 328.303 180.78 327.997C181.31 327.673 181.973 327.563 182.769 327.665C183.564 327.75 184.507 328.107 185.598 328.737C186.673 329.358 187.609 330.077 188.404 330.893C189.2 331.71 189.863 332.586 190.393 333.522C190.924 334.458 191.329 335.423 191.609 336.418C191.889 337.414 192.051 338.409 192.095 339.404C192.11 339.736 192.117 340.098 192.117 340.489C192.132 340.889 192.139 341.301 192.139 341.727C192.139 342.135 192.132 342.53 192.117 342.913C192.117 343.305 192.11 343.658 192.095 343.972C192.051 344.9 191.889 345.708 191.609 346.397C191.344 347.077 190.946 347.579 190.416 347.902C189.885 348.209 189.215 348.306 188.404 348.196C187.609 348.094 186.673 347.732 185.598 347.111C184.507 346.482 183.564 345.759 182.769 344.942C181.973 344.125 181.31 343.258 180.78 342.339C180.249 341.403 179.844 340.438 179.564 339.442C179.299 338.439 179.144 337.448 179.1 336.469C179.085 336.138 179.071 335.772 179.056 335.372C179.056 334.981 179.056 334.581 179.056 334.173C179.056 333.747 179.056 333.339 179.056 332.948C179.071 332.565 179.085 332.216 179.1 331.901ZM189.112 337.809C189.053 336.55 188.706 335.406 188.073 334.377C187.454 333.339 186.629 332.522 185.598 331.927C184.566 331.331 183.734 331.191 183.1 331.506C182.481 331.812 182.143 332.561 182.084 333.751C182.054 334.381 182.039 335.096 182.039 335.895C182.039 336.678 182.054 337.401 182.084 338.064C182.143 339.323 182.481 340.463 183.1 341.484C183.734 342.513 184.566 343.326 185.598 343.921C186.629 344.517 187.454 344.661 188.073 344.355C188.706 344.057 189.053 343.313 189.112 342.122C189.141 341.493 189.156 340.787 189.156 340.004C189.156 339.204 189.141 338.473 189.112 337.809ZM205.296 355.039C205.458 355.133 205.598 355.282 205.716 355.486C205.834 355.69 205.892 355.886 205.892 356.073V357.885C205.892 358.072 205.834 358.199 205.716 358.267C205.598 358.335 205.458 358.323 205.296 358.229L195.616 352.64C195.454 352.547 195.314 352.398 195.196 352.193C195.078 351.989 195.019 351.794 195.019 351.607V335.121C195.019 334.934 195.078 334.806 195.196 334.738C195.314 334.67 195.454 334.683 195.616 334.776L197.406 335.81C197.568 335.903 197.708 336.052 197.826 336.256C197.944 336.46 198.003 336.656 198.003 336.843V350.828L205.296 355.039Z",
    fill: "#FFE7C4"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M125.962 278.105C122.916 275.826 117.609 272.345 114.282 269.537C111.695 270.601 108.695 271.698 105.961 272.86C123.63 283.822 141.374 294.065 141.374 294.065C141.911 291.743 144.042 289.726 144.042 289.726C141.907 288.381 128.646 280.114 125.962 278.105Z",
    fill: "#FFE7C4"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 315.939L200.572 366.901V364.611L111.314 313.08C111.617 314.146 111.936 315.08 112.3 315.939Z",
    fill: "#002F3F"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M205.515 324.438L153.257 294.504C153.257 294.504 151.652 295.492 151.683 297.977L205.515 324.438Z",
    fill: "#FFE7C4"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M103.142 247.284C109.136 247.284 109.379 250.402 111.335 256.577C112.871 261.426 115.243 265.732 112.35 264.311C109.458 262.889 99.4863 252.227 97.6353 250.383C93.8013 246.565 100.406 247.284 103.142 247.284Z",
    fill: "black"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9805 214.886C77.1375 214.18 80.0095 214.23 82.1515 215.307C84.7885 216.619 92.2785 221.163 101.712 226.598C101.712 226.598 107.085 229.693 114.414 233.915L182.106 194.921C182.106 194.921 155.851 181.521 146.528 177.918C137.207 174.303 76.6175 207.904 73.9805 214.886Z",
    fill: "#EBEBEB"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M160.993 306.425C161.205 306.547 161.471 306.394 161.471 306.149V304.656C161.471 303.527 159.781 301.635 157.696 300.432L154.621 298.657C152.536 297.453 150.846 297.393 150.846 298.522V299.741C150.846 300.252 151.119 300.724 151.561 300.98L160.993 306.425Z",
    fill: "#002F3F"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M94.4973 265.827C92.6233 268.265 91.2943 274.762 91.2943 274.762C91.2943 274.762 94.2033 269.458 96.3573 267.161C98.5113 264.864 106.298 262.181 106.298 262.181C106.298 262.181 96.3723 263.389 94.4973 265.827ZM50.3093 256.439C48.1803 252.714 47.2843 240.283 47.2843 240.283C47.2843 240.283 46.4303 254.523 48.9013 257.929C51.3733 261.335 62.3363 265.826 62.3363 265.826C62.3363 265.826 52.4383 260.164 50.3093 256.439ZM104.313 231.252C92.0793 223.954 80.9763 217.867 79.3843 218.783C74.1553 221.792 82.6273 230.842 93.9193 240.138L104.313 231.252ZM144.215 302.359C145.242 309.919 146.929 334.011 146.929 334.011C146.929 334.011 147.025 312.366 147.025 303.253C147.025 295.673 150.009 292.184 150.009 292.184L147.03 290.54C147.03 290.54 143.189 294.799 144.215 302.359ZM202.705 333.639C203.732 341.199 205.419 365.291 205.419 365.291C205.419 365.291 205.515 343.646 205.515 334.533C205.515 326.953 208.499 323.464 208.499 323.464L205.52 321.82C205.52 321.82 201.678 326.079 202.705 333.639ZM154.842 178.722C150.279 181.405 210.977 208.228 210.977 208.228L223.685 194.142C223.685 194.142 159.405 176.04 154.842 178.722Z",
    fill: "black"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M252.68 189.727L154.879 246.187L152.926 247.316C150.442 246.59 147.134 246.05 141.646 245.559C131.505 244.656 120.097 247.287 120.097 247.287L90.3023 240.945C89.8013 240.837 87.6223 240.317 87.0423 240.14C85.5013 239.679 84.9713 237.862 86.1293 236.733C86.1393 236.733 86.1493 236.723 86.1583 236.713C94.4933 228.741 104.664 222.949 114.432 216.921C124.122 210.942 133.851 205.062 143.688 199.338C152.219 194.38 160.79 189.442 169.645 185.083C171.491 184.18 173.366 183.336 175.27 182.57C175.78 182.364 176.262 182.177 176.684 182.04C176.723 182.03 176.762 182.011 176.792 182.001C177.97 181.628 179.443 181.206 181.141 180.764C189.849 178.506 204.693 175.747 217.73 176.562C222.904 176.886 252.68 189.727 252.68 189.727Z",
    fill: "#E0E0E0"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M252.68 189.728L154.879 246.188C148.989 243.793 144.498 244.709 135.152 244.67C128.241 244.641 121.392 244.804 115.05 246.218L94.4629 241.82C102.7 238.993 118.898 237.471 126.575 233.593C133.211 230.226 139.711 226.525 146.19 222.833C163.989 212.662 180.767 203.022 198.448 191.26C214.941 180.284 217.346 176.868 224.081 178.036C225.858 178.586 228.713 179.424 230.902 180.249C237.629 182.767 241.011 184.194 247.87 187.345C250.8 188.69 252.66 189.719 252.68 189.728Z",
    fill: "#F5F5F5"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M105.091 236.643C119.211 234.349 129.972 228.775 137.121 224.643C144.26 220.523 177.837 200.106 190.119 193.002C202.413 185.908 206 182.417 199.853 182.182C196.234 182.126 189.529 183.312 185.496 183.944C177.736 185.161 172.199 187.68 166.32 191.075C150.183 200.395 135.385 209.549 114.597 221.552C80.3791 241.307 90.9731 238.938 105.091 236.643Z",
    fill: "#002F3F"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M154.883 246.186C150.993 244.202 143.307 243.962 137.235 243.942C129.739 243.917 117.357 244.52 113.303 247.036C110.767 248.61 112.903 251.653 114.894 259.146C116.57 265.457 117.806 267.986 122.167 271.569C130.233 278.195 150.365 290.637 154.859 293.419L154.883 246.186ZM148.431 285.592C142.33 281.555 125.771 271.24 122.849 268.87C119.093 265.822 116.333 253.213 115.622 250.17C114.728 246.342 142.843 247.011 147.025 247.73C150.411 248.312 151.466 249.951 151.324 254.093C151.324 261.917 151.336 275.811 151.336 282.431C151.337 285.051 150.838 287.185 148.431 285.592Z",
    fill: "#08181E"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.622 250.171C116.333 253.214 119.094 265.824 122.849 268.871C125.77 271.241 142.329 281.556 148.431 285.593C150.838 287.186 151.337 285.051 151.337 282.432C151.337 275.812 151.325 261.917 151.325 254.094C151.467 249.952 150.412 248.313 147.026 247.731C142.844 247.011 114.728 246.343 115.622 250.171Z",
    fill: "black"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M226.097 323.92C235.791 316.702 257.222 301.227 279.568 288.19C307.659 271.798 337.347 262.185 337.409 262.172C336.605 265.205 331.814 270.027 325.363 275.265C320.795 278.991 315.645 282.792 309.69 286.791C295.626 296.609 282.305 303.381 277.476 306.266C253.297 319.377 228.693 329.565 224.632 324.737C224.632 324.737 226.085 323.933 226.097 323.92Z",
    fill: "#002F3F"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M224.633 324.737C225.784 324.019 264.019 300.447 281.686 289.824C298.511 279.709 333.193 264.079 337.402 262.172C333.836 263.299 307.661 271.798 279.569 288.19C257.222 301.227 234.327 317.519 224.633 324.737Z",
    fill: "#08181E"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M207.364 376.06L245.731 353.906L224.416 341.6L207.364 351.482V376.06Z",
    fill: "#002F3F"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M223.16 370.554L217.65 359.609L230.76 352.02L230.761 352.022C234.931 349.623 240.483 349.896 246.58 353.416C259.528 360.892 270.025 380.175 270.026 396.486C270.027 405.028 267.145 411.054 262.544 413.789L262.547 413.796L262.362 413.903C262.353 413.908 262.344 413.913 262.335 413.919L248.895 421.679L243.084 410.135C232.084 401.709 223.587 385.103 223.16 370.554Z",
    fill: "#08181E"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M223.16 370.554L217.65 359.609L230.76 352.02L230.761 352.022C234.931 349.623 240.483 349.896 246.58 353.416C259.528 360.892 270.025 380.175 270.026 396.486C270.027 405.028 267.145 411.054 262.544 413.789L262.547 413.796L262.362 413.903C262.353 413.908 262.344 413.913 262.335 413.919L248.895 421.679L243.084 410.135C232.084 401.709 223.587 385.103 223.16 370.554Z",
    fill: "#002F3F"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M209.494 377.287C209.494 391.35 217.302 407.627 227.755 416.631C227.776 416.641 227.786 416.663 227.797 416.673C229.455 418.09 231.176 419.339 232.939 420.357C245.889 427.84 256.395 420.672 256.384 404.363C256.384 392.043 250.392 378.011 241.88 368.671C241.859 368.65 241.828 368.629 241.807 368.597C239.068 365.606 236.077 363.098 232.939 361.293C219.989 353.821 209.494 360.978 209.494 377.287Z",
    fill: "#08181E"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M232.94 371.136C224.7 366.378 218.02 371.336 218.02 382.21C218.02 393.084 224.7 405.757 232.94 410.514C241.18 415.271 247.86 410.313 247.86 399.44C247.861 388.566 241.18 375.894 232.94 371.136Z",
    fill: "#002F3F"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M226.198 387.817C226.765 393.223 230.246 398.958 233.965 400.615C235.603 401.34 237.009 401.161 238.024 400.274C239.331 399.156 239.999 396.87 239.681 393.833C239.114 388.427 235.643 382.691 231.914 381.035C230.906 380.582 229.977 380.478 229.186 380.677C229.186 380.677 229.174 380.668 229.175 380.678C227.036 381.208 225.786 383.882 226.198 387.817Z",
    fill: "#FAFAFA"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M227.528 387.118C228.095 392.525 231.576 398.259 235.295 399.916C236.302 400.359 237.221 400.474 238.023 400.274C239.33 399.156 239.998 396.87 239.68 393.833C239.113 388.427 235.642 382.691 231.913 381.035C230.905 380.582 229.976 380.478 229.185 380.677C229.185 380.677 229.173 380.668 229.174 380.678C227.879 381.805 227.211 384.091 227.528 387.118Z",
    fill: "#E0E0E0"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M209.494 377.287C209.494 391.35 217.302 407.627 227.755 416.631C221.563 409.894 215.151 398.612 212.884 387.855C210.901 378.452 211.645 364.956 219.716 361.545C227.723 358.155 238.438 365.323 241.807 368.597C239.068 365.606 236.077 363.098 232.939 361.293C219.989 353.821 209.494 360.978 209.494 377.287Z",
    fill: "#002F3F"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M207.295 320.887C207.295 320.887 209.52 320.463 209.003 318.527C209.003 318.527 222.066 324.512 224.809 325.416C230.797 327.391 253.298 319.386 277.474 306.261C282.306 303.383 295.623 296.611 309.685 286.79C315.644 282.793 320.792 278.987 325.369 275.266C330.196 271.342 333.782 267.484 335.977 264.791C336.747 263.846 338.339 261.259 337.398 259.146C385.347 293.254 411.634 307.373 406.001 346.272C406.001 346.272 405.817 349.124 404.779 354.875C403.196 363.651 398.51 378.572 386.45 387.085C375.378 394.901 374.611 395.471 359.599 403.569C344.587 411.667 324.352 417.584 304.642 416.952C282.432 416.234 262.994 407.766 262.387 402.628C262.127 400.35 261.718 398.06 261.149 395.757C259.75 390.025 257.497 384.305 254.588 379.019C250.155 370.947 244.225 363.865 237.627 359.285C236.76 358.678 235.881 358.121 235.002 357.614C220.727 349.369 208.966 356.004 207.455 372.372C207.343 373.56 207.294 374.786 207.294 376.074L207.295 320.887Z",
    fill: "#EBEBEB"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M360.668 378.711C337.414 389.701 308.031 390.915 287.2 375.828C278.864 369.791 272.387 361.602 265.198 354.237C253.848 342.608 240.522 332.921 225.989 325.652C225.547 325.603 225.148 325.528 224.809 325.416C222.066 324.512 209.003 318.527 209.003 318.527C209.521 320.463 207.295 320.887 207.295 320.887L207.294 376.072C207.294 374.784 207.344 373.559 207.455 372.37C208.965 356.003 220.727 349.367 235.001 357.612C235.88 358.12 236.759 358.677 237.626 359.283C244.225 363.864 250.155 370.945 254.587 379.017C257.496 384.303 259.75 390.023 261.148 395.755C261.718 398.058 262.126 400.348 262.386 402.626C262.992 407.764 282.43 416.232 304.641 416.95C324.351 417.581 344.585 411.664 359.598 403.567C374.61 395.47 375.377 394.899 386.449 387.083C398.509 378.57 403.195 363.649 404.778 354.873C405.816 349.122 406 346.27 406 346.27C406.181 345.019 406.327 343.795 406.442 342.593C393.165 357.164 378.379 370.341 360.668 378.711Z",
    fill: "#E0E0E0"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M351.401 385.084C345.625 387.442 340.384 385.561 334.138 380.417C327.892 375.274 320.729 365.362 312.617 358.209C304.505 351.056 265.579 322.824 265.579 322.824C265.579 322.824 259.341 325.313 254.544 325.957C262.996 328.223 263.537 325.845 272.46 331.766C281.383 337.687 304.778 355.23 312.54 363.21C319.519 370.385 325.729 381.239 330.325 386.909C334.921 392.58 344.362 388.419 351.401 385.084Z",
    fill: "#F5F5F5"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M338.529 406.093C352.357 402.645 362.398 397.203 372.207 391.422C382.026 385.632 388.406 380.229 392.059 375.64C395.51 371.305 397.608 365.675 395.43 366.465C391.809 369.587 383.981 376.213 378.99 379.234C364.053 388.291 348.199 399.513 323.806 399.931C321.692 399.923 319.93 400.047 319.113 400.292C313.16 402.07 329.126 408.437 338.529 406.093Z",
    fill: "#002F3F"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M288.256 394.99C289.619 394.8 293.011 395.71 298.774 397.367C304.537 399.024 305.934 399.175 308.067 400.648C309.876 401.897 314.706 405.828 317.037 407.032C320.73 408.94 317 410.313 306.698 410.323C296.396 410.333 292.866 407.236 290.489 404.066C288.112 400.897 285.159 395.422 288.256 394.99Z",
    fill: "#002F3F"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M405.735 348.766C405.554 350.19 405.258 352.219 404.779 354.875C404.144 358.398 402.994 362.916 401.081 367.608C400.317 368.312 399.631 368.781 399.174 368.75C397.412 368.633 398.922 365.595 400.181 361.064C401.439 356.533 404.586 352.128 405.735 348.766Z",
    fill: "#002F3F"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M334.099 372.817C336.293 375.825 339.451 378.543 342.394 380.149C344.588 381.348 348.57 380.973 350.914 380.085C364.079 375.087 375.051 368.814 383.838 361.268C385.733 359.641 387.959 356.312 388.034 353.808C388.152 350.233 387.617 345.438 386.396 342.291C385.475 339.958 381.9 340.311 379.888 341.799C367.376 350.993 352.819 359.417 336.046 367.016C333.767 368.054 332.622 370.794 334.099 372.817ZM336.186 370.58C336.304 370.141 336.689 369.713 337.171 369.499C353.826 361.942 368.736 353.369 381.494 343.993C382.029 343.597 383.463 342.494 383.891 343.383C384.844 345.898 385.432 350.126 385.314 353.723C385.271 355.147 383.687 357.812 382.06 359.203C373.561 366.503 362.762 372.668 349.939 377.538C348.89 377.934 347.434 378.18 346.118 378.18C345.09 378.18 344.191 378.03 343.699 377.752C341.002 376.286 338.165 373.781 336.292 371.212C336.197 371.083 336.101 370.901 336.186 370.58Z",
    fill: "#002F3F"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M336.293 371.211C338.166 373.78 341.003 376.284 343.7 377.751C344.192 378.029 345.091 378.179 346.119 378.179C347.435 378.179 348.891 377.933 349.94 377.537C362.763 372.667 373.562 366.502 382.061 359.202C383.688 357.81 385.272 355.145 385.315 353.722C385.433 350.126 384.844 345.898 383.892 343.382C383.464 342.494 382.03 343.596 381.495 343.992C368.736 353.368 353.826 361.942 337.172 369.498C336.69 369.712 336.305 370.14 336.187 370.579C336.101 370.9 336.197 371.082 336.293 371.211Z",
    fill: "black"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M335.401 371.768L335.256 371.339C337.631 370.534 352.184 364.035 362.44 357.934C361.753 356.553 361.28 355.71 361.266 355.686L363.632 354.339C363.688 354.436 364.133 355.225 364.779 356.511C374.877 350.248 384.544 343.296 384.645 343.223L384.911 343.592C384.81 343.664 375.108 350.642 364.982 356.919C365.165 357.29 365.359 357.688 365.565 358.124C375.668 351.865 384.741 345.255 384.835 345.187L385.102 345.554C385.009 345.622 375.894 352.262 365.758 358.538C365.938 358.925 366.123 359.334 366.312 359.761C376.449 353.493 384.937 347.215 385.023 347.151L385.294 347.516C385.207 347.58 376.673 353.89 366.497 360.18C366.671 360.579 366.846 360.992 367.024 361.42C377.223 355.126 385.132 349.175 385.212 349.115L385.485 349.477C385.405 349.538 377.448 355.526 367.199 361.846C367.366 362.255 367.532 362.674 367.697 363.105C378.001 356.764 385.327 351.136 385.401 351.08L385.677 351.44C385.604 351.497 378.224 357.165 367.86 363.539C368.018 363.957 368.173 364.383 368.326 364.817C378.781 358.404 385.522 353.099 385.589 353.045L385.871 353.401C385.804 353.454 379.02 358.794 368.507 365.237C368.497 365.242 368.488 365.248 368.478 365.254C368.625 365.68 368.767 366.113 368.907 366.55C369.001 366.493 369.099 366.437 369.193 366.379C379.679 359.952 385.717 355.057 385.776 355.009L386.063 355.36C386.003 355.41 379.944 360.321 369.429 366.765C369.304 366.842 369.175 366.916 369.049 366.993C369.368 368.023 369.664 369.079 369.92 370.149L367.272 370.782C367.082 369.986 366.864 369.198 366.632 368.419C356.73 374.114 345.707 378.7 343.54 379.434L343.395 379.005C345.561 378.271 356.606 373.674 366.502 367.972C366.368 367.535 366.229 367.103 366.086 366.676C355.792 372.648 344.102 377.507 342.184 378.157L342.038 377.728C343.952 377.078 355.656 372.213 365.936 366.239C365.787 365.808 365.636 365.383 365.482 364.965C354.974 371.106 342.697 376.245 340.827 376.879L340.682 376.45C342.548 375.818 354.829 370.675 365.32 364.535C365.158 364.105 364.995 363.686 364.831 363.275C354.504 369.344 341.762 374.826 339.471 375.602L339.325 375.173C341.611 374.397 354.351 368.914 364.66 362.848C364.486 362.421 364.313 362.006 364.14 361.606C353.79 367.713 340.268 373.594 338.114 374.323L337.968 373.894C340.118 373.166 353.63 367.287 363.957 361.187C363.77 360.759 363.587 360.352 363.408 359.963C352.815 366.241 338.688 372.392 336.757 373.046L336.612 372.617C338.538 371.964 352.648 365.818 363.216 359.549C363.015 359.117 362.822 358.713 362.641 358.342C352.359 364.455 337.785 370.962 335.401 371.768Z",
    fill: "#002F3F"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M406.076 340.969C403.18 349.285 392.969 361.943 377.816 370.839C362.663 379.735 343.028 391.991 320.745 392.718C298.461 393.446 275.842 383.716 275.842 383.716C275.842 383.716 294.57 395.207 320.746 395.782C346.923 396.358 363.036 384.769 378.587 375.334C394.751 365.528 404.24 351.568 406.076 340.969Z",
    fill: "#002F3F"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M259.456 386.909C268.262 380.954 277.264 376.589 286.474 373.924C286.474 373.924 271.054 374.379 259.456 386.909ZM266.596 379.8C261.919 364.188 249.875 354.868 240.79 354.145C249.175 357.066 259.22 367.631 264.521 381.09C265.238 380.607 266.596 379.8 266.596 379.8ZM265.578 384.006C267.275 389.062 268.218 394.276 268.218 399.789C268.908 393.682 268.551 388.083 267.441 383.056L265.578 384.006Z",
    fill: "black"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M194.156 321.555C195.929 330.004 205.29 331.787 212.301 331.578C216.016 331.473 219.07 330.791 220.004 330.256C222.712 328.692 221.462 325.449 220.014 323.571C217.558 320.391 206.539 314.01 199.623 313.79C195.573 313.652 192.917 315.625 194.156 321.555Z",
    fill: "#002F3F"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M194.156 321.555C195.929 330.004 205.29 331.787 212.301 331.578C216.016 331.473 219.07 330.791 220.004 330.256C222.712 328.692 221.462 325.449 220.014 323.571C221.378 326.152 214.158 327.748 207.725 325.439C201.292 323.119 196.496 318.156 199.623 313.79C195.573 313.652 192.917 315.625 194.156 321.555Z",
    fill: "#002F3F"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M194.156 321.555C195.929 330.004 205.29 331.787 212.301 331.578C205.322 331.379 199.76 327.359 197.661 322.973C195.572 318.596 197.157 314.346 199.623 313.79C195.573 313.652 192.917 315.625 194.156 321.555Z",
    fill: "#08181E"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M360.658 349.674C350.024 330.118 327.099 313.941 307.898 303.303C326.371 317.21 346.732 330.964 360.658 349.674Z",
    fill: "#F5F5F5"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M386.062 365.292C391.769 359.548 393.317 345.217 388.049 335.228C383.006 325.665 364.875 307.613 353.747 297.335C342.619 287.057 336.727 281.542 337.184 277.125C337.641 272.708 339.654 269.117 339.654 269.117C339.654 269.117 336.762 278.516 346.718 287.325C356.674 296.135 380.159 319.578 386.06 327.744C390.23 333.515 395.956 342.394 395.323 351.344C395.062 355.059 393.727 359.448 386.062 365.292Z",
    fill: "#F5F5F5"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M315.853 375.281C318.328 375.077 320.708 376.235 322.073 378.31C324.279 381.664 327.386 386.475 327.74 387.997C328.273 390.286 324.946 391.383 318.272 391.421C311.598 391.459 297.355 389.66 290.145 387.343C281.478 384.558 285.189 378.179 296.582 377.031C304.182 376.266 311.505 375.639 315.853 375.281Z",
    fill: "#FAFAFA"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M296.583 377.033C297.232 376.968 297.877 376.904 298.52 376.84C301.451 379.83 303.372 383.823 303.75 387.999C303.814 388.704 303.809 389.445 303.721 390.166C298.652 389.439 293.594 388.452 290.145 387.344C281.478 384.56 285.19 378.181 296.583 377.033Z",
    fill: "#F78C3A"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M296.583 377.033C297.232 376.968 297.877 376.904 298.52 376.84C301.451 379.83 303.372 383.823 303.75 387.999C303.814 388.704 303.809 389.445 303.721 390.166C298.652 389.439 293.594 388.452 290.145 387.344C281.478 384.56 285.19 378.181 296.583 377.033Z",
    fill: "#FFE7C4"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M394.321 332.994C393.652 334.491 393.528 336.18 394.054 337.733C396.419 344.723 396.159 349.081 397.158 351.271C398.268 353.705 402.928 345.929 404.26 340.611C405.592 335.293 404.833 327.054 402.771 321.076C400.709 315.098 399.156 320.342 397.824 323.823C396.793 326.516 395.611 330.107 394.321 332.994Z",
    fill: "#FAFAFA"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M398.773 321.319C399.89 318.533 401.179 316.462 402.77 321.076C404.308 325.534 405.119 331.249 404.881 336.073C404.091 332.191 402.971 329.451 401.654 326.273C400.926 324.515 399.976 322.793 398.773 321.319Z",
    fill: "#F78C3A"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M398.773 321.319C399.89 318.533 401.179 316.462 402.77 321.076C404.308 325.534 405.119 331.249 404.881 336.073C404.091 332.191 402.971 329.451 401.654 326.273C400.926 324.515 399.976 322.793 398.773 321.319Z",
    fill: "#FFE7C4"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M185.264 202.229L201.592 192.821L194.047 188.494L177.72 197.902L185.264 202.229Z",
    fill: "#E43EFF"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M185.264 202.229L201.592 192.821L194.047 188.494L177.72 197.902L185.264 202.229Z",
    fill: "#FFE7C4"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M201.592 192.82L206.44 210.851L185.264 223.063V202.228L201.592 192.82Z",
    fill: "#E43EFF"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M201.592 192.82L206.44 210.851L185.264 223.063V202.228L201.592 192.82Z",
    fill: "#FFE7C4"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M186.953 220.14V203.204L200.531 195.379L204.472 210.036L186.953 220.14ZM187.732 203.654V218.791L203.565 209.661L200.042 196.561L187.732 203.654Z",
    fill: "#E43EFF"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M177.719 197.902L172.944 215.964L185.263 223.064V202.229L177.719 197.902Z",
    fill: "#E43EFF"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M177.719 197.902L172.944 215.964L185.263 223.064V202.229L177.719 197.902Z",
    fill: "#FFE7C4"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M198.846 207.807L199.037 210.608L193.423 213.849L192.664 202.727L194.782 201.504L195.35 209.825L198.846 207.807Z",
    fill: "#FFE7C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructorSupport);
export default __webpack_public_path__ + "static/media/instructor-support.d083e0733585ec34437c45e25cf021a2.svg";
export { ForwardRef as ReactComponent };